webpackJsonp([1],Array(28).concat([
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__ = __webpack_require__(42);




// URL and endpoint constants
var PATH_LOGIN = 'authapi/login';
// const PATH_LOGOUT = 'authapi/logout'
var PATH_REGISTER = 'authapi/register';
var PATH_VERIFY = 'users/verify';
var PATH_USERS = 'users';
var PATH_PROJECTS = 'projects';

/* harmony default export */ __webpack_exports__["a"] = ({
  isSecured: true,
  baseUrl: '//noctorus.studio/october/',
  login: function login(creds) {
    var _this = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].post(PATH_LOGIN, creds).then(function (data) {
        __WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__["a" /* default */].$emit('authenticated', data);
        resolve(data);
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__["a" /* default */].$emit('unauthenticated');
        reject(error);
      });
    });
  },
  register: function register(creds) {
    var _this2 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this2.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this2.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].post(PATH_REGISTER, creds).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  logout: function logout(context, callback) {
    __WEBPACK_IMPORTED_MODULE_2__controllers_EventBus__["a" /* default */].$emit('unauthenticated');
    callback(context);
  },
  verify: function verify(token) {
    var _this3 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this3.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this3.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get(PATH_VERIFY + '/' + token, {}).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  users: function users() {
    var _this4 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this4.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this4.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get(PATH_USERS).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  projects: function projects() {
    var _this5 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this5.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this5.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get(PATH_PROJECTS).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
});

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_showdown__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_showdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_showdown__);


// export const EventBus = new Vue({ el: '#app' }) <-- in this case access using import { EventBus }
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  data: {
    _isDesktop: true,
    _navMain: [{
      title: 'home',
      name: 'landing',
      path: '/',
      params: {}
    }, {
      title: 'about',
      name: 'about',
      path: '/about',
      params: {}
    }, {
      title: 'iOS',
      name: 'showcase',
      path: '/showcase/ios',
      params: {
        type: 'ios'
      }
    }, {
      title: 'contact',
      name: 'contact',
      path: '/contact',
      params: {}
      // , {
      //   title: 'contact',
      //   name: 'contact',
      //   // path: '/contact'
      //   subnavOpen: false,
      //   subnav: [
      //     {
      //       name: 'about',
      //       title: 'About',
      //       path: '/about'
      //     }, {
      //       name: 'test-2',
      //       title: 'Test 2',
      //       path: 'test-2'
      //     }
      //   ]
      // }
    }],
    _navSocial: [{
      name: 'facebook',
      title: 'noctorus.studio',
      fa: 'facebook',
      path: 'https://www.facebook.com/noctorus.studio'
    }, {
      name: 'twitter',
      fa: 'twitter',
      path: 'https://www.twitter.com/noctorus'
    }, {
      name: 'medium',
      fa: 'medium',
      path: 'https://www.medium.com/@noctorus'
    }, {
      name: 'github',
      fa: 'github',
      path: 'https://www.github.com/morph85'
    }],
    _navPhone: '01-234-5678',
    _navEmail: 'ivan@noctorus.studio'
  },
  computed: {
    isDesktop: {
      get: function get() {
        return this._isDesktop;
      },
      set: function set(isDesktop) {
        if (this._isDesktop !== isDesktop) {
          // do not update immediately, only change if necessary
          this._isDesktop = isDesktop;
          this.$emit('isDesktopChanged', isDesktop);
        }
      }
    }
  },
  watch: {},
  methods: {
    getHtml: function getHtml(content) {
      var converter = new __WEBPACK_IMPORTED_MODULE_1_showdown___default.a.Converter();
      var html = converter.makeHtml(content);
      return html;
    },

    getSocialNav: function getSocialNav(type) {
      console.log(this._data._navSocial);
      for (var i = 0; i < this._data._navSocial.length; i++) {
        var navItem = this._data._navSocial[i];
        if (navItem.name === type) {
          return navItem;
        }
      }
      return undefined;
    },

    detectIE: function detectIE() {
      /**
       * detect IE
       * returns version of IE or false, if browser is not Internet Explorer
       */
      var ua = window.navigator.userAgent;

      // Test values; Uncomment to check result …

      // IE 10
      // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

      // IE 11
      // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

      // Edge 12 (Spartan)
      // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

      // Edge 13
      // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

      var msie = ua.indexOf('MSIE ');
      if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
      }

      var trident = ua.indexOf('Trident/');
      if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
      }

      var edge = ua.indexOf('Edge/');
      if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
      }

      // other browser
      return false;
    }
  }
})); // <-- in this case access using import EventBus

/***/ }),
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(37);





// Facebook Analytics
(function (d, s, id) {
  /* eslint one-var: 0 */
  // console.log('init FB in application.js')
  var js,
      fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) {
    return;
  }
  js = d.createElement(s);js.id = id;
  js.src = '//connect.facebook.net/en_US/sdk.js';
  fjs.parentNode.insertBefore(js, fjs);
})(document, 'script', 'facebook-jssdk');

var FBControl = {
  install: function install(Vue, options) {
    var _this = this;

    if (options && options.awaitAsyncTime) {
      this.awaitAsyncTime = options.awaitAsyncTime;
    }

    if (options && options.appId) {
      this.appId = options.appId;
    }

    if (options && options.version) {
      this.version = options.version;
    }

    if (!window.FB) {
      // the following is template from FB developers
      // with compliance for ESlint
      window.fbAsyncInit = function () {
        _this.init(_this.appId, _this.version);
      };
    } else {
      this.init(this.appId, this.version);
    }
  },

  awaitAsyncTime: 100,
  init: function init(appId, version) {
    /* global FB */
    FB.init({
      appId: appId,
      xfbml: true,
      version: version
    });
    window.FB = FB;
    Object.defineProperty(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].prototype, '$FB', { value: FB });
    return FB;
  },
  getFB: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                var failsafe = 100;

                // repeats
                var repeat = setInterval(function () {
                  // console.log('getFB pending...' + Vue.$FB + ',' + window.FB)
                  if (__WEBPACK_IMPORTED_MODULE_3_vue__["default"].$FB !== undefined) {
                    // console.log('getFB later with Vue.$FB')
                    resolve(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].$FB);
                    clearInterval(repeat);
                  } else if (window.FB !== undefined) {
                    // console.log('getFB later with window.FB')
                    resolve(window.FB);
                    clearInterval(repeat);
                  }

                  // failsafe in case infinite load
                  failsafe--;
                  if (failsafe <= 0) {
                    clearInterval(repeat);
                  }
                }, _this2.awaitAsyncTime);
              });

            case 2:
              return _context.abrupt('return', _context.sent);

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function getFB() {
      return _ref.apply(this, arguments);
    }

    return getFB;
  }(),
  logEvent: function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(name) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].$FB !== undefined)) {
                _context2.next = 4;
                break;
              }

              // console.log('logging event logged now with Vue.$FB')
              __WEBPACK_IMPORTED_MODULE_3_vue__["default"].$FB.AppEvents.logEvent(name);
              _context2.next = 13;
              break;

            case 4:
              if (!(window.FB !== undefined)) {
                _context2.next = 8;
                break;
              }

              // console.log('logging event logged now with window.FB')
              window.FB.AppEvents.logEvent(name);
              _context2.next = 13;
              break;

            case 8:
              if (this.awaitAsyncTime) {
                _context2.next = 11;
                break;
              }

              console.error('Invalid await async time');
              return _context2.abrupt('return');

            case 11:
              _context2.next = 13;
              return this.getFB().then(function (FB) {
                // console.log('logging event logged awaited with window.FB')
                FB.AppEvents.logEvent(name);
              }).catch(function (error) {
                console.error('Internal error in FBControl failsafe', error);
              });

            case 13:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function logEvent(_x) {
      return _ref2.apply(this, arguments);
    }

    return logEvent;
  }(),
  logPageView: function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].$FB !== undefined)) {
                _context3.next = 4;
                break;
              }

              __WEBPACK_IMPORTED_MODULE_3_vue__["default"].$FB.AppEvents.logPageView();
              _context3.next = 13;
              break;

            case 4:
              if (!(window.FB !== undefined)) {
                _context3.next = 8;
                break;
              }

              window.FB.AppEvents.logPageView();
              _context3.next = 13;
              break;

            case 8:
              if (this.awaitAsyncTime) {
                _context3.next = 11;
                break;
              }

              console.error('Invalid await async time');
              return _context3.abrupt('return');

            case 11:
              _context3.next = 13;
              return this.getFB().then(function (FB) {
                FB.AppEvents.logPageView();
              }).catch(function (error) {
                console.error('Internal error in FBControl failsafe', error);
              });

            case 13:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, this);
    }));

    function logPageView() {
      return _ref3.apply(this, arguments);
    }

    return logPageView;
  }()
};

/* harmony default export */ __webpack_exports__["a"] = (FBControl);

/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis__ = __webpack_require__(156);



/* harmony default export */ __webpack_exports__["a"] = ({
  isSecured: true,
  baseUrl: '//noctorus.studio/october/singulo/',
  baseUrlCaptcha: '//noctorus.studio/php/',
  about: function about(name) {
    var _this = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      name = name === undefined ? 'all' : name;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('about/' + name).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  carousel: function carousel(name) {
    var _this2 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      name = name === undefined ? 'all' : name;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this2.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this2.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('carousel/' + name).then(function (data) {
        // reject({ error: 'error' })
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  company: function company(name) {
    var _this3 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      name = name === undefined ? 'all' : name;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this3.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this3.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('company/' + name).then(function (data) {
        // reject({ error: 'error' })
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  gallery: function gallery(name) {
    var _this4 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      name = name === undefined ? 'all' : name;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this4.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this4.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('gallery/' + name).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  eventDetail: function eventDetail(showId) {
    var _this5 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this5.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this5.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('event/show/' + showId).then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  eventPrevious: function eventPrevious() {
    var _this6 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this6.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this6.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('event/previous').then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  eventUpcoming: function eventUpcoming() {
    var _this7 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this7.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this7.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('event/upcoming').then(function (data) {
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  email: function email(type, recaptcha, name, lname, bname, phone, _email, message, files) {
    var _this8 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this8.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this8.baseUrl;
      var params = {
        type: type,
        recaptcha: recaptcha,

        name: name,
        lname: lname,
        email: _email,
        phone: phone,
        message: message
      };
      if (bname !== undefined) {
        params['bname'] = bname;
      }
      if (files !== undefined) {
        params['files'] = files;
      }
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].post('email', params).then(function (data) {
        // reject({ error: 'error' })
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  subscribe: function subscribe(name, email) {
    var _this9 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this9.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this9.baseUrl;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].post('email/subscribe', { name: name, email: email }).then(function (data) {
        // reject({ error: 'error' })
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  getRecaptcha: function getRecaptcha() {
    var _this10 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].forceSecure = _this10.isSecured;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].baseUrl = _this10.baseUrlCaptcha;
      __WEBPACK_IMPORTED_MODULE_1__apis__["a" /* default */].get('captcha.php').then(function (data) {
        // reject({ error: 'error' })
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
});

/***/ }),
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(710)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(833),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(704)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(827),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(677)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(798),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(834),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__controllers_EventBus__ = __webpack_require__(42);






/* harmony default export */ __webpack_exports__["a"] = ({

  forceSecure: false, // true = autodetect, false = always secured
  baseUrl: '//noctorus.studio/october/',
  getProtocol: function getProtocol() {
    var protocol = window.location.protocol;
    if (!protocol || protocol.length <= 0) {
      protocol = 'http:';
    }
    if (this.forceSecure) {
      protocol = 'https:';
    }
    return protocol;
  },


  // callback format: (result, data, error)
  post: function post(path, data, noJson) {
    var _this = this;

    // context.$http.interceptors.push(function (request, next) {
    //   request.headers.set('Access-Control-Allow-Origin', '*')
    //   next()
    // })

    __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.merge(data, {
      client_id: 1,
      client_secret: 'n4FdG7FaF14ka2id8WySAwHTtgdAGwBQTqovmeW0'
    });

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(_this.getProtocol() + _this.baseUrl + path, data).then(function (response) {
        // console.log('response')
        // console.log(response)
        if (!response.data) {
          // EventBus.$emit('unauthenticated')
          // callback(false, { error: 'Invalid response', code: 400 })
          reject({ error: 'Invalid response', code: 400 });
          return;
        }

        if (noJson) {
          resolve(response.data);
          return;
        }

        // validate if proper JSON
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(response.data) !== 'object') {
          console.log(response);
          reject({ error: 'Invalid JSON data', code: 400 });
          return;
        }

        if (response.data.error) {
          reject({ error: response.data.error.msg, code: response.data.error.code });
          return;
        }

        // EventBus.$emit('authenticated', response.data)
        // callback(true)
        resolve(response.data);
      }).catch(function (error) {
        // console.log('error')
        // console.log(error)
        if (!error) {
          reject({ error: 'Blank error response', code: 400 });
          return;
        }

        // console.log(error)
        if (!error.response || !error.response.data) {
          // EventBus.$emit('unauthenticated')
          // callback(context, false, { error: 'Invalid error response', code: 400 })
          reject({ error: 'Invalid error response', code: 400 });
          return;
        }

        // validate if proper JSON
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(error.response.data) !== 'object') {
          console.error(error.response);
          reject({ error: 'Invalid JSON error', code: 400 });
          return;
        }

        if (error.response.data.code === 401) {
          __WEBPACK_IMPORTED_MODULE_4__controllers_EventBus__["a" /* default */].$emit('unauthenticated');
        }

        // EventBus.$emit('unauthenticated')
        // callback(context, false, error.response.data)
        reject(error.response.data);
      });
    });

    // context.$http.post(LOGIN_URL, creds, {
    //   headers: {
    //     // 'Access-Control-Allow-Methods': '*'
    //   }
    // }).then(data => {
    //   console.log(data)
    //   localStorage.setItem('id_token', data.id_token)
    //   localStorage.setItem('access_token', data.access_token)
    //
    //   this.user.authenticated = true
    //
    //   // Redirect to a specified route
    //   if (redirect) {
    //     console.log('redirected')
    //     // router.go(redirect)
    //   }
    // }, err => {
    //   console.log('error login')
    //   console.log(err)
    //   context.error = err
    // })
  },
  get: function get(path, params, noJson) {
    var _this2 = this;

    noJson = noJson !== undefined ? noJson : false;
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(_this2.getProtocol() + _this2.baseUrl + path, { params: params }, {
        headers: {
          'HTTP_ORIGIN': 'http://localhost:8080'
        }
      }).then(function (response) {
        // console.log('response')
        // console.log(response)
        if (!response.data) {
          // EventBus.$emit('unauthenticated')
          // callback(false, { error: 'Invalid response', code: 400 })
          reject({ error: 'Invalid response', code: 400 });
          return;
        }

        if (noJson) {
          resolve(response.data);
          return;
        }

        // validate if proper JSON
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(response.data) !== 'object') {
          reject({ error: 'Invalid JSON data', code: 400 });
          return;
        }

        if (response.data.error) {
          reject({ error: response.data.error.msg, code: response.data.error.code });
          return;
        }

        // EventBus.$emit('authenticated', response.data)
        // callback(true)
        resolve(response.data);
      }).catch(function (error) {
        // console.log('error')
        // console.log(error)
        if (!error) {
          reject({ error: 'Blank error response', code: 400 });
          return;
        }

        // console.log(error)
        if (!error.response || !error.response.data) {
          // EventBus.$emit('unauthenticated')
          // callback(context, false, { error: 'Invalid error response', code: 400 })
          reject({ error: 'Invalid error response', code: 400 });
          return;
        }

        // validate if proper JSON
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(error.response.data) !== 'object') {
          reject({ error: 'Invalid JSON error', code: 400 });
          return;
        }

        if (error.response.data.code === 401) {
          __WEBPACK_IMPORTED_MODULE_4__controllers_EventBus__["a" /* default */].$emit('unauthenticated');
        }

        // EventBus.$emit('unauthenticated')
        // callback(context, false, error.response.data)
        reject(error.response.data);
      });
    });
  }
});

/***/ }),
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAnCAYAAAAcsCj6AAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QgWCScySQ35bwAAAtNJREFUWMPdmE1IVVEQx3+m2CKpFgYFUbTSoFZFixckyHHxlqEERXCCPhepuTDMs/Ua0aJAy0UtuqQLsdCFHxiXyoIiqFUg0qJSIqiFotQiM2szyul073v33Xd10cBbnJkz8z8zZ96cmVuyebiL9aQNrDOVxdnkB95+oB44AlQBlSKaBaaACeChVuZtPlsluULqB14G6ARqYjowAbRrZV4UBOgH3kbgOnARKCkwar+BbqBVK/Mj7x36gbcFGAcaE4AhOo3AuNiK9tAPvHJgDKiNOPkb4BEwI7xdQB1wMOJwj4GsVmYxKmmuRYANAm1amXchMuMHXhVwFTjqyGrFZss/HvqBdwh46YR5CTirlbkXM5tPAXccR5aBjFbmlXuHHSF32hwXDED2NofkScdfSSMhqXM29mtlbheaMaLT77CVH3jVtocNzoZloL2IgtIuNmyqtwHdP/aEVuZ9UjTRfeqwa2zAakf4JIWy+cxZ77UBtznCjykAuhGqtAFL1+AVKQ0pHKuGPzjCHSkAbnfWMzagG+8DKQC6Np7bgMOOMOsH3takSKKbddjDNuAI8MUSbrLrXwK6JDZW6CswugqolVkCbjlKbX7gHU7gXQa44rC7tTI/3WzsAhasdTkwKO1FXLB9wJDortCC2A59D41daIW+Aa3AXYlEGFAZcEa6hAr3+dLKdEa9hzeAC8BOi1cB9ACX/cDrlYyeFtluaaxOAntCzvIJuJmzp/EDrwEYSKkrPKaVGchZUbQyDyRri6URFyxXCTsHzBUBNic24nXeWpnPQFMRgM1iI36rr5XplRQvlIa0MveTzhanrYyMQ9Oik2yY0crMSvuxGANsEWgQneTTk1bmtdTGfNQie4sf17QyPUBfji19cTu8Ql7288BkCH9SZOkOpFqZ79LqzVvseaBeZOlPwFqZKeAE8Et+x4W3diO3VmZUxrEmrcxYwbPcf/9R4Q8a/dS0GhCghAAAAABJRU5ErkJggg=="

/***/ }),
/* 322 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDIwMDEwOTA0Ly9FTiIKICJodHRwOi8vd3d3LnczLm9yZy9UUi8yMDAxL1JFQy1TVkctMjAwMTA5MDQvRFREL3N2ZzEwLmR0ZCI+CjxzdmcgdmVyc2lvbj0iMS4wIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiB3aWR0aD0iMTAyNC4wMDAwMDBwdCIgaGVpZ2h0PSIxMDI0LjAwMDAwMHB0IiB2aWV3Qm94PSIwIDAgMTAyNC4wMDAwMDAgMTAyNC4wMDAwMDAiCiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWlkWU1pZCBtZWV0Ij4KPG1ldGFkYXRhPgpDcmVhdGVkIGJ5IHBvdHJhY2UgMS4xNSwgd3JpdHRlbiBieSBQZXRlciBTZWxpbmdlciAyMDAxLTIwMTcKPC9tZXRhZGF0YT4KPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsMTAyNC4wMDAwMDApIHNjYWxlKDAuMTAwMDAwLC0wLjEwMDAwMCkiCmZpbGw9IiMzMDM0MzQiIHN0cm9rZT0ibm9uZSI+CjxwYXRoIGQ9Ik02ODMgODY0MyBjLTkwIC0yIC0xNjMgLTYgLTE2MyAtMTAgMCAtMTIgNDUxMyAtNzg4MyA0NTIwIC03ODgzIDcgMAo0NTEwIDc4ODEgNDUxMCA3ODk0IDAgNiAtODUzNCA1IC04ODY3IC0xeiBtNTI0NCAtOTYxIGwxOTQzIC03IC0xNDIzIC0yNTU3CmMtNzgyIC0xNDA3IC0xNDI0IC0yNTU4IC0xNDI3IC0yNTU4IC00IDAgLTI4MjEgNTEwOCAtMjgyOCA1MTI4IC0yIDcgMjY1IDcKMzczNSAtNnogbTI5NTYgLTcxIGMtMTgzIC0zMjggLTMzNDkgLTU4OTEgLTMzNTMgLTU4OTEgLTkgMCAtNDY0IDc1NSAtNDY0Cjc3MCAwIDggNjQ4IDExNzkgMTQzOSAyNjAyIGwxNDQwIDI1ODcgNDg4IDEgNDg5IDAgLTM5IC02OXoiLz4KPC9nPgo8L3N2Zz4K"

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(684)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(806),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(705)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(828),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_masonry_layout__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_masonry_layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_masonry_layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_imagesloaded__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_imagesloaded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_imagesloaded__);





var attributesMap = {
  'column-width': 'columnWidth',
  'transition-duration': 'transitionDuration',
  'item-selector': 'itemSelector',
  'origin-left': 'originLeft',
  'origin-top': 'originTop',
  'fit-width': 'fitWidth',
  'stamp': 'stamp',
  'gutter': 'gutter'
};
var EVENT_ADD = 'vuemasonry.itemAdded';
var EVENT_REMOVE = 'vuemasonry.itemRemoved';
var EVENT_IMAGE_LOADED = 'vuemasonry.imageLoaded';

var stringToBool = function stringToBool(val) {
  return (val + '').toLowerCase() === 'true';
};

var collectOptions = function collectOptions(attrs) {
  var res = {};
  var attributesArray = Array.prototype.slice.call(attrs);
  attributesArray.forEach(function (attr) {
    if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(attributesMap).indexOf(attr.name) > -1) {
      res[attributesMap[attr.name]] = attr.name.indexOf('origin') > -1 ? stringToBool(attr.value) : attr.value;
    }
  });
  return res;
};

var Events = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({});

// NoctorusCode: changed install method
// export const VueMasonryPlugin = function () {}

function install(Vue, options) {
  Vue.redrawVueMasonry = function () {
    Events.$emit(EVENT_ADD);
  };

  Vue.directive('masonry', {
    props: ['transitionDuration', ' itemSelector'],

    inserted: function inserted(el, nodeObj) {
      if (!__WEBPACK_IMPORTED_MODULE_2_masonry_layout___default.a) {
        throw new Error('Masonry plugin is not defined. Please check it\'s connected and parsed correctly.');
      }
      var masonry = new __WEBPACK_IMPORTED_MODULE_2_masonry_layout___default.a(el, collectOptions(el.attributes));
      var masonryDraw = function masonryDraw() {
        masonry.reloadItems();
        masonry.layout();
      };
      Vue.nextTick(function () {
        masonryDraw();
      });

      Events.$on(EVENT_ADD, function (eventData) {
        masonryDraw();
      });
      Events.$on(EVENT_REMOVE, function (eventData) {
        masonryDraw();
      });
      Events.$on(EVENT_IMAGE_LOADED, function (eventData) {
        masonryDraw();
      });
    }
  });

  Vue.directive('masonryTile', {

    inserted: function inserted(el) {
      Events.$emit(EVENT_ADD, {
        'element': el
      });

      /* eslint-disable no-new */
      new __WEBPACK_IMPORTED_MODULE_3_imagesloaded___default.a(el, function () {
        Events.$emit(EVENT_IMAGE_LOADED, {
          'element': el
        });
      });
    },
    beforeDestroy: function beforeDestroy(el) {
      Events.$emit(EVENT_REMOVE, {
        'element': el
      });
    }
  });
}

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = install;
/**
 * Created by lingchenxuan on 16-11-9.
 * https://github.com/ibufu/vue2-scrollspy
 */
var scrollSections = [];

var bodyScrollEl = {};

// For ff, ie
Object.defineProperty(bodyScrollEl, 'scrollTop', {
  get: function get() {
    return document.body.scrollTop || document.documentElement.scrollTop;
  },
  set: function set(val) {
    document.body.scrollTop = val;
    document.documentElement.scrollTop = val;
  }
});

function init(el) {
  scrollSections = [];
  var sections = el.children;
  if (sections[0] && sections[0].offsetParent !== el) {
    el[scrollSpyContext].eventEl = window;
    el[scrollSpyContext].scrollEl = bodyScrollEl;
  }

  for (var i = 0; i < sections.length; i++) {
    if (sections[i].offsetTop >= 0) {
      scrollSections.push(sections[i].offsetTop);
    }
  }
}

var scrollSpyContext = '@@scrollSpyContext';

function install(Vue) {
  Vue.directive('scroll-spy', {
    bind: function bind(el, binding, vnode) {
      function onScroll() {
        var _el$scrollSpyContext = el[scrollSpyContext],
            scrollEl = _el$scrollSpyContext.scrollEl,
            expression = _el$scrollSpyContext.expression;

        var pos = scrollEl.scrollTop;
        var i = 0;
        while (pos >= scrollSections[i]) {
          i++;
        }
        vnode.context.$data[expression] = i ? i - 1 : 0;
      }

      function scrollToIndex(index) {
        console.log('scroll!!!!');
        var scrollEl = el[scrollSpyContext].scrollEl;

        var current = scrollEl.scrollTop;
        var target = scrollSections[index];
        var time = 200;
        var steps = 30;
        var timems = parseInt(time / steps);
        var gap = target - current;

        var _loop = function _loop(i) {
          var pos = current + gap / steps * i;
          setTimeout(function () {
            scrollEl.scrollTop = pos;
          }, timems * i);
        };

        for (var i = 0; i <= steps; i++) {
          _loop(i);
        }
      }
      vnode.context.$scrollToIndex = scrollToIndex;

      el[scrollSpyContext] = {
        onScroll: onScroll,
        expression: binding.expression,
        eventEl: el,
        scrollEl: el
      };
    },
    inserted: function inserted(el) {
      init(el);

      var _el$scrollSpyContext2 = el[scrollSpyContext],
          eventEl = _el$scrollSpyContext2.eventEl,
          onScroll = _el$scrollSpyContext2.onScroll;

      eventEl.addEventListener('scroll', onScroll);
    },
    componentUpdated: function componentUpdated(el) {
      init(el);
    },
    unbind: function unbind(el) {
      var _el$scrollSpyContext3 = el[scrollSpyContext],
          eventEl = _el$scrollSpyContext3.eventEl,
          onScroll = _el$scrollSpyContext3.onScroll;

      eventEl.removeEventListener('scroll', onScroll);
    }
  });
}

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persist__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex_persist___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuex_persist__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);







__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* default */]);

var state = {
  count: 0,
  authentication: undefined
};

var getters = {
  evenOrOdd: function evenOrOdd(state) {
    return state.count % 2 === 0 ? 'even' : 'odd';
  },
  isAuthenticated: function isAuthenticated(state) {
    if (!state.authentication || state.authentication === undefined) {
      return false;
    }

    var data = state.authentication;
    if (!data || !data.expires_in || !data.token_type || !data.access_token || !data.refresh_token) {
      return false;
    }

    return true;
  },
  authenticatedUsername: function authenticatedUsername(state) {
    if (!state.authentication) {
      return '';
    }
    return state.authentication.email;
  },
  authenticatedAuthorization: function authenticatedAuthorization(state) {
    if (!state.authentication || !state.authentication.access_token || !state.authentication.token_type) {
      return undefined;
    }
    return state.authentication.token_type + ' ' + state.authentication.access_token;
  }
};

var mutations = {
  increment: function increment(state) {
    state.count++;
  },
  decrement: function decrement(state) {
    state.count--;
  },
  authenticated: function authenticated(state, data) {
    // console.log('mutation:authenticated')
    // console.log(data)
    state.authentication = data;
  },
  unauthenticated: function unauthenticated(state) {
    // console.log('mutation:unauthenticated')
    state.authentication = undefined;
  }
};

var actions = {
  increment: function increment(_ref) {
    var commit = _ref.commit;
    return commit('increment');
  },
  decrement: function decrement(_ref2) {
    var commit = _ref2.commit;
    return commit('decrement');
  },
  incrementIfOdd: function incrementIfOdd(_ref3) {
    var commit = _ref3.commit,
        state = _ref3.state;

    if ((state.count + 1) % 2 === 0) {
      commit('increment');
    }
  },
  incrementAsync: function incrementAsync(_ref4) {
    var commit = _ref4.commit;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      setTimeout(function () {
        commit('increment');
        resolve();
      }, 1000);
    });
  },
  authenticated: function authenticated(_ref5, data) {
    var commit = _ref5.commit;

    // console.log('actions:authenticated')
    // console.log(data)

    if (!data || !data.expires_in || !data.token_type || !data.access_token || !data.refresh_token) {
      console.error('actions:authenticated:invalid authentication data', data);
      return;
    }

    // set header & update cookie
    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.post['Authorization'] = data.token_type + ' ' + data.access_token;
    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.get['Authorization'] = data.token_type + ' ' + data.access_token;
    return commit('authenticated', data);
  },
  unauthenticated: function unauthenticated(_ref6) {
    var commit = _ref6.commit;

    // console.log('actions:unauthenticated')

    // remove header & clear cookie
    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.post['Authorization'] = undefined;
    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.get['Authorization'] = undefined;
    return commit('unauthenticated');
  }
};

// authentication cookie store to store persistent storage
var authCookieStore = new __WEBPACK_IMPORTED_MODULE_3_vuex_persist___default.a({
  key: 'authorization',
  restoreState: function restoreState(key, storage) {
    // console.log('cookie:restoreState')
    // console.log(key)
    // console.log(state)
    var data = __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.getJSON(key);
    state.authentication = data;
    if (!data || !data.token_type || !data.access_token) {
      console.error('Invalid authorization');
      return __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.getJSON(key);
    }

    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.post['Authorization'] = data.token_type + ' ' + data.access_token;
    __WEBPACK_IMPORTED_MODULE_5_axios___default.a.defaults.headers.get['Authorization'] = data.token_type + ' ' + data.access_token;

    // hopefully the following doesn't simply bind to override
    return __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.getJSON(key);
  },
  saveState: function saveState(key, state, storage) {
    // console.log('cookie:saveState')
    // console.log(key)
    // console.log(state)
    if (!state.authentication || state.authentication === undefined || !state.authentication.expires_in || state.authentication.expires_in === undefined || !state.authentication.access_token || state.authentication.access_token === undefined || !state.authentication.refresh_token || state.authentication.refresh_token === undefined || !state.authentication.token_type || state.authentication.token_type === undefined) {
      __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.remove(key);
      return;
    }

    var expires = state.authentication.expires_in / 60 / 60 / 24;
    console.log('cookie authentication expires in: ' + expires);
    return __WEBPACK_IMPORTED_MODULE_4_js_cookie___default.a.set(key, state.authentication, {
      expires: expires
    });
  },
  reducer: function reducer(state) {
    // console.log('cookie:reducer')
    // console.log(state)
    return { authentication: state.authentication };
  },
  filter: function filter(mutation) {
    // console.log('cookie:filter, mutation.type=' + mutation.type)
    return mutation.type === 'authenticated' || mutation.type === 'unauthenticated';
  }
});

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* default */].Store({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
  plugins: [authCookieStore.plugin]
}));

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_meta__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_meta___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_meta__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Landing__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Landing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Landing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_About__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_About___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_About__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Contact__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_Contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Showcase__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_Showcase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_Showcase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_NotFound__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_NotFound___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_NotFound__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Home__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_auth_Register__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_auth_Register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_auth_Register__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_auth_Login__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_auth_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_auth_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_auth_Verify__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_auth_Verify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_auth_Verify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_auth_Users__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_auth_Users___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_auth_Users__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_auth_Projects__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_auth_Projects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_auth_Projects__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_showcase_LayoutGallery__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_showcase_LayoutGallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__pages_showcase_LayoutGallery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_showcase_LayoutMasonry__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_showcase_LayoutMasonry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__pages_showcase_LayoutMasonry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_showcase_LayoutMasonryInstagram__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_showcase_LayoutMasonryInstagram___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__pages_showcase_LayoutMasonryInstagram__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_showcase_ApiPlaces__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_showcase_ApiPlaces___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__pages_showcase_ApiPlaces__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_showcase_ApiYoutube__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_showcase_ApiYoutube___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__pages_showcase_ApiYoutube__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_misc_PrivacyPolicy__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_misc_PrivacyPolicy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__pages_misc_PrivacyPolicy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_misc_TermsOfService__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_misc_TermsOfService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__pages_misc_TermsOfService__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_misc_TermsAndPrivacy__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_misc_TermsAndPrivacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__pages_misc_TermsAndPrivacy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_test_Blogs__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_test_Blogs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__pages_test_Blogs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_test_Components__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_test_Components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__pages_test_Components__);































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_meta___default.a);

var vueRouter = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'landing',
    id: 0,
    title: 'Landing',
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Landing___default.a
  }, {
    path: '/about',
    name: 'about',
    id: 1,
    title: 'About',
    component: __WEBPACK_IMPORTED_MODULE_4__pages_About___default.a
  }, {
    path: '/contact',
    name: 'contact',
    id: 2,
    title: 'Contact',
    component: __WEBPACK_IMPORTED_MODULE_5__pages_Contact___default.a
  }, {
    path: '/showcase/:type',
    name: 'showcase',
    id: 3,
    title: 'Showcase',
    component: __WEBPACK_IMPORTED_MODULE_6__pages_Showcase___default.a
  }, {
    path: '*',
    name: 'notfound',
    id: -1,
    title: 'Not Found',
    component: __WEBPACK_IMPORTED_MODULE_7__pages_NotFound___default.a
  },
  // showcase
  {
    path: '/layout-gallery',
    name: 'layout-gallery',
    id: 11,
    title: 'Dynamic Gallery',
    component: __WEBPACK_IMPORTED_MODULE_14__pages_showcase_LayoutGallery___default.a
  }, {
    path: '/layout-masonry',
    name: 'layout-masonry',
    id: 12,
    title: 'Masonry Layout',
    component: __WEBPACK_IMPORTED_MODULE_15__pages_showcase_LayoutMasonry___default.a
  }, {
    path: '/layout-masonry-instagram',
    name: 'layout-masonry-instagram',
    id: 13,
    title: 'Masonry Instagram Layout',
    component: __WEBPACK_IMPORTED_MODULE_16__pages_showcase_LayoutMasonryInstagram___default.a
  }, {
    path: '/api-places',
    name: 'api-places',
    id: 14,
    title: 'Places API',
    component: __WEBPACK_IMPORTED_MODULE_17__pages_showcase_ApiPlaces___default.a
  }, {
    path: '/api-youtube',
    name: 'api-youtube',
    id: 15,
    title: 'Youtube API',
    component: __WEBPACK_IMPORTED_MODULE_18__pages_showcase_ApiYoutube___default.a
  },
  // auth
  {
    path: '/home',
    name: 'home',
    id: 101,
    title: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_8__pages_Home___default.a
  }, {
    path: '/register',
    name: 'register',
    id: 101,
    title: 'Register',
    component: __WEBPACK_IMPORTED_MODULE_9__pages_auth_Register___default.a
  }, {
    path: '/login',
    name: 'login',
    id: 102,
    title: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_10__pages_auth_Login___default.a
  }, {
    path: '/verify',
    name: 'verify',
    id: 103,
    title: 'Verify',
    component: __WEBPACK_IMPORTED_MODULE_11__pages_auth_Verify___default.a
  }, {
    path: '/users',
    name: 'users',
    id: 202,
    title: 'Users',
    component: __WEBPACK_IMPORTED_MODULE_12__pages_auth_Users___default.a
  }, {
    path: '/projects',
    name: 'projects',
    id: 203,
    title: 'Projects',
    component: __WEBPACK_IMPORTED_MODULE_13__pages_auth_Projects___default.a
  },
  // misc
  {
    path: '/privacy',
    name: 'privacy',
    id: 901,
    title: 'Privacy',
    component: __WEBPACK_IMPORTED_MODULE_19__pages_misc_PrivacyPolicy___default.a
  }, {
    path: '/terms',
    name: 'terms',
    id: 902,
    title: 'Terms of Service',
    component: __WEBPACK_IMPORTED_MODULE_20__pages_misc_TermsOfService___default.a
  }, {
    path: '/privacypolicy',
    name: 'privacypolicy',
    id: 903,
    title: 'Terms of Service &amp; Privacy Policy',
    component: __WEBPACK_IMPORTED_MODULE_21__pages_misc_TermsAndPrivacy___default.a
  },
  // testing only
  {
    path: '/blogs',
    name: 'blogs',
    id: 911,
    title: 'Blogs',
    component: __WEBPACK_IMPORTED_MODULE_22__pages_test_Blogs___default.a
  }, {
    path: '/components',
    name: 'components',
    id: 912,
    title: 'Components',
    component: __WEBPACK_IMPORTED_MODULE_23__pages_test_Components___default.a
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (vueRouter);

/***/ }),
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var __cov_0GTwwl$GMPTkkuRWFDyc4w = (Function('return this'))();
if (!__cov_0GTwwl$GMPTkkuRWFDyc4w.__coverage__) { __cov_0GTwwl$GMPTkkuRWFDyc4w.__coverage__ = {}; }
__cov_0GTwwl$GMPTkkuRWFDyc4w = __cov_0GTwwl$GMPTkkuRWFDyc4w.__coverage__;
if (!(__cov_0GTwwl$GMPTkkuRWFDyc4w['/home/fahrenq/code/v-img/lib/ImgScreen.vue'])) {
   __cov_0GTwwl$GMPTkkuRWFDyc4w['/home/fahrenq/code/v-img/lib/ImgScreen.vue'] = {"path":"/home/fahrenq/code/v-img/lib/ImgScreen.vue","s":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0,"32":0,"33":0,"34":0,"35":0,"36":0,"37":0,"38":0,"39":0,"40":0,"41":0,"42":0,"43":0},"b":{"1":[0,0],"2":[0,0],"3":[0,0],"4":[0,0],"5":[0,0],"6":[0,0],"7":[0,0],"8":[0,0],"9":[0,0],"10":[0,0],"11":[0,0],"12":[0,0],"13":[0,0],"14":[0,0],"15":[0,0],"16":[0,0],"17":[0,0],"18":[0,0],"19":[0,0]},"f":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0},"fnMap":{"1":{"name":"(anonymous_1)","line":1,"loc":{"start":{"line":1,"column":1},"end":{"line":1,"column":13}}},"2":{"name":"render","line":13,"loc":{"start":{"line":13,"column":25},"end":{"line":13,"column":43}}},"3":{"name":"click","line":14,"loc":{"start":{"line":14,"column":225},"end":{"line":14,"column":248}}},"4":{"name":"data","line":20,"loc":{"start":{"line":20,"column":8},"end":{"line":20,"column":24}}},"5":{"name":"close","line":31,"loc":{"start":{"line":31,"column":11},"end":{"line":31,"column":28}}},"6":{"name":"next","line":37,"loc":{"start":{"line":37,"column":10},"end":{"line":37,"column":26}}},"7":{"name":"prev","line":45,"loc":{"start":{"line":45,"column":10},"end":{"line":45,"column":26}}},"8":{"name":"showUI","line":53,"loc":{"start":{"line":53,"column":12},"end":{"line":53,"column":30}}},"9":{"name":"(anonymous_9)","line":60,"loc":{"start":{"line":60,"column":34},"end":{"line":60,"column":46}}},"10":{"name":"created","line":65,"loc":{"start":{"line":65,"column":11},"end":{"line":65,"column":30}}},"11":{"name":"(anonymous_11)","line":68,"loc":{"start":{"line":68,"column":37},"end":{"line":68,"column":50}}},"12":{"name":"(anonymous_12)","line":76,"loc":{"start":{"line":76,"column":38},"end":{"line":76,"column":50}}},"13":{"name":"(anonymous_13)","line":79,"loc":{"start":{"line":79,"column":41},"end":{"line":79,"column":53}}}},"statementMap":{"1":{"start":{"line":1,"column":0},"end":{"line":11,"column":5}},"2":{"start":{"line":2,"column":2},"end":{"line":10,"column":3}},"3":{"start":{"line":3,"column":4},"end":{"line":5,"column":2130}},"4":{"start":{"line":5,"column":2130},"end":{"line":5,"column":2154}},"5":{"start":{"line":5,"column":2154},"end":{"line":9,"column":5}},"6":{"start":{"line":6,"column":6},"end":{"line":6,"column":37}},"7":{"start":{"line":8,"column":6},"end":{"line":8,"column":54}},"8":{"start":{"line":9,"column":5},"end":{"line":9,"column":29}},"9":{"start":{"line":14,"column":4},"end":{"line":14,"column":19}},"10":{"start":{"line":14,"column":19},"end":{"line":14,"column":47}},"11":{"start":{"line":14,"column":47},"end":{"line":14,"column":75}},"12":{"start":{"line":14,"column":75},"end":{"line":18,"column":1683}},"13":{"start":{"line":15,"column":10},"end":{"line":17,"column":11}},"14":{"start":{"line":16,"column":12},"end":{"line":16,"column":24}},"15":{"start":{"line":17,"column":11},"end":{"line":17,"column":23}},"16":{"start":{"line":21,"column":4},"end":{"line":27,"column":6}},"17":{"start":{"line":32,"column":6},"end":{"line":32,"column":71}},"18":{"start":{"line":33,"column":6},"end":{"line":33,"column":23}},"19":{"start":{"line":34,"column":6},"end":{"line":34,"column":33}},"20":{"start":{"line":35,"column":6},"end":{"line":35,"column":25}},"21":{"start":{"line":39,"column":6},"end":{"line":43,"column":7}},"22":{"start":{"line":40,"column":8},"end":{"line":40,"column":33}},"23":{"start":{"line":42,"column":8},"end":{"line":42,"column":35}},"24":{"start":{"line":47,"column":6},"end":{"line":51,"column":7}},"25":{"start":{"line":48,"column":8},"end":{"line":48,"column":33}},"26":{"start":{"line":50,"column":8},"end":{"line":50,"column":56}},"27":{"start":{"line":54,"column":6},"end":{"line":54,"column":23}},"28":{"start":{"line":58,"column":6},"end":{"line":58,"column":35}},"29":{"start":{"line":59,"column":6},"end":{"line":59,"column":28}},"30":{"start":{"line":60,"column":6},"end":{"line":62,"column":15}},"31":{"start":{"line":61,"column":8},"end":{"line":61,"column":32}},"32":{"start":{"line":66,"column":4},"end":{"line":66,"column":22}},"33":{"start":{"line":68,"column":4},"end":{"line":75,"column":7}},"34":{"start":{"line":70,"column":6},"end":{"line":70,"column":63}},"35":{"start":{"line":70,"column":48},"end":{"line":70,"column":63}},"36":{"start":{"line":72,"column":6},"end":{"line":72,"column":62}},"37":{"start":{"line":72,"column":48},"end":{"line":72,"column":62}},"38":{"start":{"line":74,"column":6},"end":{"line":74,"column":62}},"39":{"start":{"line":74,"column":48},"end":{"line":74,"column":62}},"40":{"start":{"line":76,"column":4},"end":{"line":78,"column":7}},"41":{"start":{"line":77,"column":6},"end":{"line":77,"column":21}},"42":{"start":{"line":79,"column":4},"end":{"line":81,"column":7}},"43":{"start":{"line":80,"column":6},"end":{"line":80,"column":22}}},"branchMap":{"1":{"line":2,"type":"if","locations":[{"start":{"line":2,"column":2},"end":{"line":2,"column":2}},{"start":{"line":2,"column":2},"end":{"line":2,"column":2}}]},"2":{"line":3,"type":"binary-expr","locations":[{"start":{"line":3,"column":15},"end":{"line":3,"column":28}},{"start":{"line":3,"column":32},"end":{"line":3,"column":72}}]},"3":{"line":5,"type":"if","locations":[{"start":{"line":5,"column":2154},"end":{"line":5,"column":2154}},{"start":{"line":5,"column":2154},"end":{"line":5,"column":2154}}]},"4":{"line":14,"type":"binary-expr","locations":[{"start":{"line":14,"column":56},"end":{"line":14,"column":68}},{"start":{"line":14,"column":72},"end":{"line":14,"column":74}}]},"5":{"line":14,"type":"cond-expr","locations":[{"start":{"line":14,"column":165},"end":{"line":18,"column":1669}},{"start":{"line":18,"column":1672},"end":{"line":18,"column":1680}}]},"6":{"line":15,"type":"if","locations":[{"start":{"line":15,"column":10},"end":{"line":15,"column":10}},{"start":{"line":15,"column":10},"end":{"line":15,"column":10}}]},"7":{"line":18,"type":"cond-expr","locations":[{"start":{"line":18,"column":84},"end":{"line":18,"column":211}},{"start":{"line":18,"column":214},"end":{"line":18,"column":222}}]},"8":{"line":18,"type":"cond-expr","locations":[{"start":{"line":18,"column":425},"end":{"line":18,"column":903}},{"start":{"line":18,"column":906},"end":{"line":18,"column":914}}]},"9":{"line":18,"type":"binary-expr","locations":[{"start":{"line":18,"column":382},"end":{"line":18,"column":395}},{"start":{"line":18,"column":399},"end":{"line":18,"column":422}}]},"10":{"line":18,"type":"cond-expr","locations":[{"start":{"line":18,"column":1030},"end":{"line":18,"column":1509}},{"start":{"line":18,"column":1512},"end":{"line":18,"column":1520}}]},"11":{"line":18,"type":"binary-expr","locations":[{"start":{"line":18,"column":987},"end":{"line":18,"column":1000}},{"start":{"line":18,"column":1004},"end":{"line":18,"column":1027}}]},"12":{"line":39,"type":"if","locations":[{"start":{"line":39,"column":6},"end":{"line":39,"column":6}},{"start":{"line":39,"column":6},"end":{"line":39,"column":6}}]},"13":{"line":47,"type":"if","locations":[{"start":{"line":47,"column":6},"end":{"line":47,"column":6}},{"start":{"line":47,"column":6},"end":{"line":47,"column":6}}]},"14":{"line":70,"type":"if","locations":[{"start":{"line":70,"column":6},"end":{"line":70,"column":6}},{"start":{"line":70,"column":6},"end":{"line":70,"column":6}}]},"15":{"line":70,"type":"binary-expr","locations":[{"start":{"line":70,"column":10},"end":{"line":70,"column":26}},{"start":{"line":70,"column":30},"end":{"line":70,"column":46}}]},"16":{"line":72,"type":"if","locations":[{"start":{"line":72,"column":6},"end":{"line":72,"column":6}},{"start":{"line":72,"column":6},"end":{"line":72,"column":6}}]},"17":{"line":72,"type":"binary-expr","locations":[{"start":{"line":72,"column":10},"end":{"line":72,"column":26}},{"start":{"line":72,"column":30},"end":{"line":72,"column":46}}]},"18":{"line":74,"type":"if","locations":[{"start":{"line":74,"column":6},"end":{"line":74,"column":6}},{"start":{"line":74,"column":6},"end":{"line":74,"column":6}}]},"19":{"line":74,"type":"binary-expr","locations":[{"start":{"line":74,"column":10},"end":{"line":74,"column":26}},{"start":{"line":74,"column":30},"end":{"line":74,"column":46}}]}}};
}
__cov_0GTwwl$GMPTkkuRWFDyc4w = __cov_0GTwwl$GMPTkkuRWFDyc4w['/home/fahrenq/code/v-img/lib/ImgScreen.vue'];
__cov_0GTwwl$GMPTkkuRWFDyc4w.s['1']++;(function(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['1']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['2']++;if(document){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['1'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['3']++;var head=(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['2'][0]++,document.head)||(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['2'][1]++,document.getElementsByTagName('head')[0]),style=document.createElement('style'),css=' *[data-v-5928e1c7] { -webkit-box-sizing: border-box; box-sizing: border-box; } .fullscreen-v-img[data-v-5928e1c7] { height: 100%; width: 100%; position: fixed; top: 0; left: 0; overflow: hidden; background-color: rgba(0, 0, 0, .7); -ms-touch-action: none; touch-action: none; } .content-v-img img[data-v-5928e1c7] { width: auto; height: auto; max-width: 100%; max-height: 100%; position: absolute; top: 0; left: 0; right: 0; bottom: 0; margin: auto; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; user-select: none; } .header-v-img[data-v-5928e1c7] { position: absolute; width: 100%; background-color: rgba(0, 0, 0, .3); height: 50px; z-index: 9999; } .count-v-img[data-v-5928e1c7] { font-family: \'Avenir\', Helvetica, Arial, sans-serif; font-size: 15px; color: white; margin-left: 10px; line-height: 50px; } .close-v-img[data-v-5928e1c7] { float: right; margin-right: 10px; font-family: \'Avenir\', Helvetica, Arial, sans-serif; color: #E5E6EB; font-size: 30px; line-height: 50px; cursor: pointer; -webkit-transition: color .4s ease-in-out; transition: color .4s ease-in-out; } .close-v-img[data-v-5928e1c7]:hover { color: white; } .prev-v-img svg[data-v-5928e1c7], .next-v-img svg[data-v-5928e1c7] { margin: 5px auto; } .prev-v-img[data-v-5928e1c7], .next-v-img[data-v-5928e1c7] { color: white; width: 35px; height: 35px; position: absolute; top: 50%; margin-top: -12.5px; font-size: 15px; font-family: \'Avenir\', Helvetica, Arial, sans-serif; text-align: center; background-color: rgba(0, 0, 0, .3); z-index: 1000; opacity: .3; -webkit-transition: opacity .3s ease-in-out; transition: opacity .3s ease-in-out; cursor: pointer; } .prev-v-img[data-v-5928e1c7]:hover, .next-v-img[data-v-5928e1c7]:hover { opacity: 1; } .prev-v-img[data-v-5928e1c7] { left: 10px; } .next-v-img[data-v-5928e1c7] { right: 10px; } .v-img-fade-enter[data-v-5928e1c7], .v-img-fade-leave-to[data-v-5928e1c7] { opacity: 0; } .v-img-fade-enter-active[data-v-5928e1c7], .v-img-fade-leave-active[data-v-5928e1c7] { -webkit-transition: opacity .3s ease-in-out; transition: opacity .3s ease-in-out; } .body-fs-v-img {} ';__cov_0GTwwl$GMPTkkuRWFDyc4w.s['4']++;style.type='text/css';__cov_0GTwwl$GMPTkkuRWFDyc4w.s['5']++;if(style.styleSheet){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['3'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['6']++;style.styleSheet.cssText=css;}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['3'][1]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['7']++;style.appendChild(document.createTextNode(css));}__cov_0GTwwl$GMPTkkuRWFDyc4w.s['8']++;head.appendChild(style);}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['1'][1]++;}}());var ImgScreen = {render:function render(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['2']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['9']++;var _vm=this;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['10']++;var _h=_vm.$createElement;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['11']++;var _c=(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['4'][0]++,_vm._self._c)||(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['4'][1]++,_h);__cov_0GTwwl$GMPTkkuRWFDyc4w.s['12']++;return _c('transition',{attrs:{'appear':'','name':'v-img-fade'}},[!_vm.closed?(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['5'][0]++,_c('div',{staticClass:'fullscreen-v-img',on:{'click':function click($event){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['3']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['13']++;if($event.target!==$event.currentTarget){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['6'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['14']++;return null;}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['6'][1]++;}__cov_0GTwwl$GMPTkkuRWFDyc4w.s['15']++;_vm.close();}}},[_c('div',{staticClass:'header-v-img'},[_vm.images.length>1?(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['7'][0]++,_c('span',{staticClass:'count-v-img'},[_vm._v(_vm._s(_vm.currentImageIndex+1)+'/'+_vm._s(_vm.images.length)+' ')])):(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['7'][1]++,_vm._e()),_c('span',{staticClass:'close-v-img',on:{'click':_vm.close}},[_vm._v('\xD7')])]),_c('transition',{attrs:{'appear':'','name':'v-img-fade'}},[(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['9'][0]++,_vm.visibleUI)&&(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['9'][1]++,_vm.images.length!==1)?(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['8'][0]++,_c('span',{staticClass:'prev-v-img',on:{'click':_vm.prev}},[_c('svg',{attrs:{'width':'25','height':'25','viewBox':'0 0 1792 1915','xmlns':'http://www.w3.org/2000/svg'}},[_c('path',{attrs:{'d':'M1664 896v128q0 53-32.5 90.5t-84.5 37.5h-704l293 294q38 36 38 90t-38 90l-75 76q-37 37-90 37-52 0-91-37l-651-652q-37-37-37-90 0-52 37-91l651-650q38-38 91-38 52 0 90 38l75 74q38 38 38 91t-38 91l-293 293h704q52 0 84.5 37.5t32.5 90.5z','fill':'#fff'}})])])):(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['8'][1]++,_vm._e())]),_c('transition',{attrs:{'appear':'','name':'v-img-fade'}},[(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['11'][0]++,_vm.visibleUI)&&(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['11'][1]++,_vm.images.length!==1)?(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['10'][0]++,_c('span',{staticClass:'next-v-img',on:{'click':_vm.next}},[_c('svg',{attrs:{'width':'25','height':'25','viewBox':'0 0 1792 1915','xmlns':'http://www.w3.org/2000/svg'}},[_c('path',{attrs:{'d':'M1600 960q0 54-37 91l-651 651q-39 37-91 37-51 0-90-37l-75-75q-38-38-38-91t38-91l293-293h-704q-52 0-84.5-37.5t-32.5-90.5v-128q0-53 32.5-90.5t84.5-37.5h704l-293-294q-38-36-38-90t38-90l75-75q38-38 90-38 53 0 91 38l651 651q37 35 37 90z','fill':'#fff'}})])])):(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['10'][1]++,_vm._e())]),_c('div',{staticClass:'content-v-img'},[_c('img',{attrs:{'src':_vm.images[_vm.currentImageIndex]},on:{'click':_vm.next}})])],1)):(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['5'][1]++,_vm._e())]);},staticRenderFns:[],_scopeId:'data-v-5928e1c7',data:function data(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['4']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['16']++;return{images:[],visibleUI:true,currentImageIndex:0,closed:true,uiTimeout:null};},methods:{close:function close(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['5']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['17']++;document.querySelector('body').classList.remove('body-fs-v-img');__cov_0GTwwl$GMPTkkuRWFDyc4w.s['18']++;this.images=[];__cov_0GTwwl$GMPTkkuRWFDyc4w.s['19']++;this.currentImageIndex=0;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['20']++;this.closed=true;},next:function next(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['6']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['21']++;if(this.currentImageIndex+1<this.images.length){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['12'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['22']++;this.currentImageIndex++;}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['12'][1]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['23']++;this.currentImageIndex=0;}},prev:function prev(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['7']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['24']++;if(this.currentImageIndex>0){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['13'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['25']++;this.currentImageIndex--;}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['13'][1]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['26']++;this.currentImageIndex=this.images.length-1;}},showUI:function showUI(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['8']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['27']++;var _this=this;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['28']++;clearTimeout(this.uiTimeout);__cov_0GTwwl$GMPTkkuRWFDyc4w.s['29']++;this.visibleUI=true;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['30']++;this.uiTimeout=setTimeout(function(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['9']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['31']++;_this.visibleUI=false;},3500);}},created:function created(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['10']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['32']++;var _this2=this;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['33']++;window.addEventListener('keyup',function(e){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['11']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['34']++;if((__cov_0GTwwl$GMPTkkuRWFDyc4w.b['15'][0]++,e.keyCode===27)||(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['15'][1]++,e.keyCode===81)){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['14'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['35']++;_this2.close();}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['14'][1]++;}__cov_0GTwwl$GMPTkkuRWFDyc4w.s['36']++;if((__cov_0GTwwl$GMPTkkuRWFDyc4w.b['17'][0]++,e.keyCode===39)||(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['17'][1]++,e.keyCode===76)){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['16'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['37']++;_this2.next();}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['16'][1]++;}__cov_0GTwwl$GMPTkkuRWFDyc4w.s['38']++;if((__cov_0GTwwl$GMPTkkuRWFDyc4w.b['19'][0]++,e.keyCode===37)||(__cov_0GTwwl$GMPTkkuRWFDyc4w.b['19'][1]++,e.keyCode===72)){__cov_0GTwwl$GMPTkkuRWFDyc4w.b['18'][0]++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['39']++;_this2.prev();}else{__cov_0GTwwl$GMPTkkuRWFDyc4w.b['18'][1]++;}});__cov_0GTwwl$GMPTkkuRWFDyc4w.s['40']++;window.addEventListener('scroll',function(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['12']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['41']++;_this2.close();});__cov_0GTwwl$GMPTkkuRWFDyc4w.s['42']++;window.addEventListener('mousemove',function(){__cov_0GTwwl$GMPTkkuRWFDyc4w.f['13']++;__cov_0GTwwl$GMPTkkuRWFDyc4w.s['43']++;_this2.showUI();});}};

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var __cov_WuSw60ZQZcI1aW7neh6dWA = (Function('return this'))();
if (!__cov_WuSw60ZQZcI1aW7neh6dWA.__coverage__) { __cov_WuSw60ZQZcI1aW7neh6dWA.__coverage__ = {}; }
__cov_WuSw60ZQZcI1aW7neh6dWA = __cov_WuSw60ZQZcI1aW7neh6dWA.__coverage__;
if (!(__cov_WuSw60ZQZcI1aW7neh6dWA['/home/fahrenq/code/v-img/lib/index.js'])) {
   __cov_WuSw60ZQZcI1aW7neh6dWA['/home/fahrenq/code/v-img/lib/index.js'] = {"path":"/home/fahrenq/code/v-img/lib/index.js","s":{"1":0,"2":0,"3":0,"4":0,"5":0,"6":0,"7":0,"8":0,"9":0,"10":0,"11":0,"12":0,"13":0,"14":0,"15":0,"16":0,"17":0,"18":0,"19":0,"20":0,"21":0,"22":0,"23":0,"24":0,"25":0,"26":0,"27":0,"28":0,"29":0,"30":0,"31":0},"b":{"1":[0,0],"2":[0,0],"3":[0,0],"4":[0,0],"5":[0,0],"6":[0,0],"7":[0,0],"8":[0,0],"9":[0,0],"10":[0,0],"11":[0,0],"12":[0,0]},"f":{"1":0,"2":0,"3":0,"4":0},"fnMap":{"1":{"name":"install","line":6,"loc":{"start":{"line":6,"column":14},"end":{"line":6,"column":36}}},"2":{"name":"bind","line":10,"loc":{"start":{"line":10,"column":10},"end":{"line":10,"column":37}}},"3":{"name":"(anonymous_3)","line":45,"loc":{"start":{"line":45,"column":35},"end":{"line":45,"column":47}}},"4":{"name":"(anonymous_4)","line":52,"loc":{"start":{"line":52,"column":43},"end":{"line":52,"column":56}}}},"statementMap":{"1":{"start":{"line":6,"column":0},"end":{"line":61,"column":2}},"2":{"start":{"line":7,"column":2},"end":{"line":7,"column":37}},"3":{"start":{"line":9,"column":2},"end":{"line":60,"column":5}},"4":{"start":{"line":12,"column":6},"end":{"line":12,"column":29}},"5":{"start":{"line":13,"column":6},"end":{"line":13,"column":23}},"6":{"start":{"line":14,"column":6},"end":{"line":14,"column":38}},"7":{"start":{"line":17,"column":6},"end":{"line":21,"column":7}},"8":{"start":{"line":18,"column":8},"end":{"line":18,"column":48}},"9":{"start":{"line":19,"column":8},"end":{"line":19,"column":39}},"10":{"start":{"line":20,"column":8},"end":{"line":20,"column":45}},"11":{"start":{"line":24,"column":6},"end":{"line":24,"column":59}},"12":{"start":{"line":25,"column":6},"end":{"line":27,"column":7}},"13":{"start":{"line":26,"column":8},"end":{"line":26,"column":63}},"14":{"start":{"line":29,"column":6},"end":{"line":29,"column":70}},"15":{"start":{"line":29,"column":16},"end":{"line":29,"column":70}},"16":{"start":{"line":32,"column":6},"end":{"line":32,"column":31}},"17":{"start":{"line":35,"column":6},"end":{"line":35,"column":29}},"18":{"start":{"line":36,"column":6},"end":{"line":41,"column":7}},"19":{"start":{"line":37,"column":8},"end":{"line":37,"column":52}},"20":{"start":{"line":38,"column":8},"end":{"line":38,"column":50}},"21":{"start":{"line":39,"column":8},"end":{"line":39,"column":60}},"22":{"start":{"line":40,"column":8},"end":{"line":40,"column":65}},"23":{"start":{"line":45,"column":6},"end":{"line":58,"column":9}},"24":{"start":{"line":46,"column":8},"end":{"line":46,"column":70}},"25":{"start":{"line":48,"column":8},"end":{"line":48,"column":133}},"26":{"start":{"line":49,"column":8},"end":{"line":56,"column":9}},"27":{"start":{"line":50,"column":10},"end":{"line":50,"column":39}},"28":{"start":{"line":52,"column":10},"end":{"line":54,"column":14}},"29":{"start":{"line":53,"column":12},"end":{"line":53,"column":48}},"30":{"start":{"line":55,"column":10},"end":{"line":55,"column":63}},"31":{"start":{"line":57,"column":8},"end":{"line":57,"column":37}}},"branchMap":{"1":{"line":14,"type":"binary-expr","locations":[{"start":{"line":14,"column":18},"end":{"line":14,"column":29}},{"start":{"line":14,"column":33},"end":{"line":14,"column":37}}]},"2":{"line":17,"type":"if","locations":[{"start":{"line":17,"column":6},"end":{"line":17,"column":6}},{"start":{"line":17,"column":6},"end":{"line":17,"column":6}}]},"3":{"line":18,"type":"binary-expr","locations":[{"start":{"line":18,"column":17},"end":{"line":18,"column":37}},{"start":{"line":18,"column":41},"end":{"line":18,"column":47}}]},"4":{"line":19,"type":"binary-expr","locations":[{"start":{"line":19,"column":14},"end":{"line":19,"column":31}},{"start":{"line":19,"column":35},"end":{"line":19,"column":38}}]},"5":{"line":20,"type":"binary-expr","locations":[{"start":{"line":20,"column":16},"end":{"line":20,"column":35}},{"start":{"line":20,"column":39},"end":{"line":20,"column":44}}]},"6":{"line":24,"type":"binary-expr","locations":[{"start":{"line":24,"column":44},"end":{"line":24,"column":49}},{"start":{"line":24,"column":53},"end":{"line":24,"column":57}}]},"7":{"line":25,"type":"if","locations":[{"start":{"line":25,"column":6},"end":{"line":25,"column":6}},{"start":{"line":25,"column":6},"end":{"line":25,"column":6}}]},"8":{"line":25,"type":"binary-expr","locations":[{"start":{"line":25,"column":10},"end":{"line":25,"column":23}},{"start":{"line":25,"column":27},"end":{"line":25,"column":44}}]},"9":{"line":29,"type":"if","locations":[{"start":{"line":29,"column":6},"end":{"line":29,"column":6}},{"start":{"line":29,"column":6},"end":{"line":29,"column":6}}]},"10":{"line":36,"type":"if","locations":[{"start":{"line":36,"column":6},"end":{"line":36,"column":6}},{"start":{"line":36,"column":6},"end":{"line":36,"column":6}}]},"11":{"line":49,"type":"if","locations":[{"start":{"line":49,"column":8},"end":{"line":49,"column":8}},{"start":{"line":49,"column":8},"end":{"line":49,"column":8}}]},"12":{"line":53,"type":"binary-expr","locations":[{"start":{"line":53,"column":19},"end":{"line":53,"column":38}},{"start":{"line":53,"column":42},"end":{"line":53,"column":47}}]}}};
}
__cov_WuSw60ZQZcI1aW7neh6dWA = __cov_WuSw60ZQZcI1aW7neh6dWA['/home/fahrenq/code/v-img/lib/index.js'];
__cov_WuSw60ZQZcI1aW7neh6dWA.s['1']++;var install=function install(Vue){__cov_WuSw60ZQZcI1aW7neh6dWA.f['1']++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['2']++;var screen=Vue.extend(ImgScreen);__cov_WuSw60ZQZcI1aW7neh6dWA.s['3']++;Vue.directive('img',{bind:function bind(el,binding){__cov_WuSw60ZQZcI1aW7neh6dWA.f['2']++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['4']++;var cursor='pointer';__cov_WuSw60ZQZcI1aW7neh6dWA.s['5']++;var src=el.src;__cov_WuSw60ZQZcI1aW7neh6dWA.s['6']++;var group=(__cov_WuSw60ZQZcI1aW7neh6dWA.b['1'][0]++,binding.arg)||(__cov_WuSw60ZQZcI1aW7neh6dWA.b['1'][1]++,null);__cov_WuSw60ZQZcI1aW7neh6dWA.s['7']++;if(typeof binding.value!=='undefined'){__cov_WuSw60ZQZcI1aW7neh6dWA.b['2'][0]++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['8']++;cursor=(__cov_WuSw60ZQZcI1aW7neh6dWA.b['3'][0]++,binding.value.cursor)||(__cov_WuSw60ZQZcI1aW7neh6dWA.b['3'][1]++,cursor);__cov_WuSw60ZQZcI1aW7neh6dWA.s['9']++;src=(__cov_WuSw60ZQZcI1aW7neh6dWA.b['4'][0]++,binding.value.src)||(__cov_WuSw60ZQZcI1aW7neh6dWA.b['4'][1]++,src);__cov_WuSw60ZQZcI1aW7neh6dWA.s['10']++;group=(__cov_WuSw60ZQZcI1aW7neh6dWA.b['5'][0]++,binding.value.group)||(__cov_WuSw60ZQZcI1aW7neh6dWA.b['5'][1]++,group);}else{__cov_WuSw60ZQZcI1aW7neh6dWA.b['2'][1]++;}__cov_WuSw60ZQZcI1aW7neh6dWA.s['11']++;el.setAttribute('data-vue-img-group',(__cov_WuSw60ZQZcI1aW7neh6dWA.b['6'][0]++,group)||(__cov_WuSw60ZQZcI1aW7neh6dWA.b['6'][1]++,null));__cov_WuSw60ZQZcI1aW7neh6dWA.s['12']++;if((__cov_WuSw60ZQZcI1aW7neh6dWA.b['8'][0]++,binding.value)&&(__cov_WuSw60ZQZcI1aW7neh6dWA.b['8'][1]++,binding.value.src)){__cov_WuSw60ZQZcI1aW7neh6dWA.b['7'][0]++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['13']++;el.setAttribute('data-vue-img-src',binding.value.src);}else{__cov_WuSw60ZQZcI1aW7neh6dWA.b['7'][1]++;}__cov_WuSw60ZQZcI1aW7neh6dWA.s['14']++;if(!src){__cov_WuSw60ZQZcI1aW7neh6dWA.b['9'][0]++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['15']++;console.error('v-img element missing src parameter.');}else{__cov_WuSw60ZQZcI1aW7neh6dWA.b['9'][1]++;}__cov_WuSw60ZQZcI1aW7neh6dWA.s['16']++;el.style.cursor=cursor;__cov_WuSw60ZQZcI1aW7neh6dWA.s['17']++;var vm=window.vueImg;__cov_WuSw60ZQZcI1aW7neh6dWA.s['18']++;if(!vm){__cov_WuSw60ZQZcI1aW7neh6dWA.b['10'][0]++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['19']++;var element=document.createElement('div');__cov_WuSw60ZQZcI1aW7neh6dWA.s['20']++;element.setAttribute('id','imageScreen');__cov_WuSw60ZQZcI1aW7neh6dWA.s['21']++;document.querySelector('body').appendChild(element);__cov_WuSw60ZQZcI1aW7neh6dWA.s['22']++;vm=window.vueImg=new screen().$mount('#imageScreen');}else{__cov_WuSw60ZQZcI1aW7neh6dWA.b['10'][1]++;}__cov_WuSw60ZQZcI1aW7neh6dWA.s['23']++;el.addEventListener('click',function(){__cov_WuSw60ZQZcI1aW7neh6dWA.f['3']++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['24']++;document.querySelector('body').classList.add('body-fs-v-img');__cov_WuSw60ZQZcI1aW7neh6dWA.s['25']++;var images=[].concat(toConsumableArray(document.querySelectorAll('img[data-vue-img-group="'+group+'"]')));__cov_WuSw60ZQZcI1aW7neh6dWA.s['26']++;if(images.length==0){__cov_WuSw60ZQZcI1aW7neh6dWA.b['11'][0]++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['27']++;Vue.set(vm,'images',[src]);}else{__cov_WuSw60ZQZcI1aW7neh6dWA.b['11'][1]++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['28']++;Vue.set(vm,'images',images.map(function(e){__cov_WuSw60ZQZcI1aW7neh6dWA.f['4']++;__cov_WuSw60ZQZcI1aW7neh6dWA.s['29']++;return(__cov_WuSw60ZQZcI1aW7neh6dWA.b['12'][0]++,e.dataset.vueImgSrc)||(__cov_WuSw60ZQZcI1aW7neh6dWA.b['12'][1]++,e.src);}));__cov_WuSw60ZQZcI1aW7neh6dWA.s['30']++;Vue.set(vm,'currentImageIndex',images.indexOf(el));}__cov_WuSw60ZQZcI1aW7neh6dWA.s['31']++;Vue.set(vm,'closed',false);});}});};

/* harmony default export */ __webpack_exports__["a"] = (install);
//# sourceMappingURL=v-img.mjs.map


/***/ }),
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(699)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(821),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(707)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(830),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(698)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(820),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(701)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(824),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(695)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(817),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(803),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios_dist_axios__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios_dist_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios_dist_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookie__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_scrollto__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__controllers_ScrollSpy__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_infinite_scroll__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_infinite_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_infinite_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_multiple_back_top__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_multiple_back_top___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_multiple_back_top__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_masonry_layout_masonry__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_masonry_layout_masonry___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_masonry_layout_masonry__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__controllers_Masonry__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_v_img__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_buefy__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_buefy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_buefy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_buefy_lib_buefy_css__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_buefy_lib_buefy_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_buefy_lib_buefy_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_aos__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_aos___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_aos__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_aos_dist_aos_css__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_aos_dist_aos_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_aos_dist_aos_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_material_design_icons_iconfont_material_icons_css__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_material_design_icons_iconfont_material_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_material_design_icons_iconfont_material_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_app_scss__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__styles_app_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__styles_app_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_slick_carousel_slick_slick_css__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_slick_carousel_slick_slick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_slick_carousel_slick_slick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_slick_carousel_slick_slick_theme_css__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_slick_carousel_slick_slick_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_slick_carousel_slick_slick_theme_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__App__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__controllers_Store__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__router__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__controllers_FBControl__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_analytics__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_disqus_VueDisqus_vue__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_disqus_VueDisqus_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vue_disqus_VueDisqus_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_FormError__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_FormError___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_FormError__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_FormInput__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_FormInput___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_FormInput__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_SideBar__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_SideBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_SideBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_SectionComment__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_SectionComment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_SectionComment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_moment__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$ajax = __WEBPACK_IMPORTED_MODULE_3_axios_dist_axios___default.a;


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_lodash___default.a);
Object.defineProperty(__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype, '$lodash', { value: __WEBPACK_IMPORTED_MODULE_4_lodash___default.a });


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_cookie___default.a);


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_scrollto___default.a, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  cancelable: true,
  onDone: false,
  onCancel: false
});


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7__controllers_ScrollSpy__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_infinite_scroll___default.a);


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_9_vue_multiple_back_top___default.a.name, __WEBPACK_IMPORTED_MODULE_9_vue_multiple_back_top___default.a);



__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_11__controllers_Masonry__["a" /* default */]);


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_v_img__["a" /* default */]);

// Buefy Components UI

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_buefy___default.a);



__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_aos___default.a);


// Material Design Icons


// load Bulma, override Bulma
// override font-awesome & common styles UI


// Carousel







// scroll to top for each route change
__WEBPACK_IMPORTED_MODULE_23__router__["a" /* default */].beforeEach(function (to, from, next) {
  window.scrollTo(0, 0);
  next();
});

// FB

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_24__controllers_FBControl__["a" /* default */], {
  appId: '782732588553167',
  version: 'v2.9'
});

// GA

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_25_vue_analytics___default.a, {
  id: 'UA-3206163-1',
  router: __WEBPACK_IMPORTED_MODULE_23__router__["a" /* default */]
});

// Disqus


// Modules





__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('form-error', __WEBPACK_IMPORTED_MODULE_27__components_FormError___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('form-input', __WEBPACK_IMPORTED_MODULE_28__components_FormInput___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('side-bar', __WEBPACK_IMPORTED_MODULE_29__components_SideBar___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('vue-disqus', __WEBPACK_IMPORTED_MODULE_26_vue_disqus_VueDisqus_vue___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].component('section-comment', __WEBPACK_IMPORTED_MODULE_30__components_SectionComment___default.a);


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('datetime', function (value, format) {
  format = format && format.slice(1, format.length - 1);
  if (!value) {
    return '0';
  }
  console.log(value);
  // return moment(new Date(value)).format(format || 'HH:mm - YYYY-MM-DD')
  return __WEBPACK_IMPORTED_MODULE_31_moment___default()(new Date(value)).format(format || 'h:mm A - D MMM YYYY');
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_22__controllers_Store__["a" /* default */],
  router: __WEBPACK_IMPORTED_MODULE_23__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_21__App___default.a },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_15_aos___default.a.init({
      duration: 1600
    });
  }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vue-disqus',
  props: {
    shortname: {
      type: String,
      required: true
    },
    identifier: {
      type: String,
      required: false
    },
    url: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    },
    remote_auth_s3: {
      type: String,
      required: false
    },
    api_key: {
      type: String,
      required: false
    },
    sso_config: {
      type: Object,
      required: false
    }
  },
  mounted: function mounted() {
    if (window.DISQUS) {
      this.reset(window.DISQUS);
      return;
    }
    this.init();
  },

  methods: {
    reset: function reset(dsq) {
      var self = this;
      dsq.reset({
        reload: true,
        config: function config() {
          this.page.identifier = self.identifier || self.$route.path || window.location.pathname;
          this.page.url = self.url || self.$el.baseURI;
          if (self.title) {
            this.page.title = self.title;
          }
          if (self.remote_auth_s3) {
            this.page.remote_auth_s3 = self.remote_auth_s3;
          }
          if (self.key) {
            this.page.api_key = self.key;
          }
          if (self.sso_config) {
            this.sso = self.sso_config;
          }
        }
      });
    },
    init: function init() {
      var _this = this;

      var self = this;
      window.disqus_config = function () {
        this.page.identifier = self.identifier || self.$route.path || window.location.pathname;
        this.page.url = self.url || self.$el.baseURI;
        if (self.title) {
          this.page.title = self.title;
        }
        if (self.remote_auth_s3) {
          this.page.remote_auth_s3 = self.remote_auth_s3;
        }
        if (self.api_key) {
          this.page.api_key = self.api_key;
        }
        if (self.sso_config) {
          this.sso = self.sso_config;
        }
      };
      setTimeout(function () {
        var d = document,
            s = d.createElement('script');
        s.type = 'text/javascript';
        s.async = true;
        s.setAttribute('id', 'embed-disqus');
        s.setAttribute('data-timestamp', +new Date());
        s.src = '//' + _this.shortname + '.disqus.com/embed.js';(d.head || d.body).appendChild(s);
      }, 0);
    }
  }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__remove_polyfill__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__remove_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__remove_polyfill__);

//
//
//
//
//
//
//
//
//
//
//




/**
 * Get the dimensions of `$ele` ele.
 * @param {HTMLElement} $ele
 * @return {object} Object with `width` and `height` properties.
 */
function getSize($ele) {
  var $clone = $ele.cloneNode(true);
  var size = {};

  $clone.style.display = 'block';
  $clone.style.visibility = 'hidden';
  $clone.style.position = 'absolute';
  $ele.parentNode.insertBefore($clone, $ele);
  size.width = $clone.offsetWidth;
  size.height = $clone.offsetHeight;
  $clone.remove();

  return size;
}

/**
 * Set dropdown position.
 * @param {HTMLElement} $link - Html element will show the dropdown when it is pressed.
 * @param {HTMLElement} $dd - Dropdown html element.
 * @param {array} position - Dropdown position.
 */
function _setPosition($link, $dd, position, margin) {
  var refSize = getSize($link);
  var cornerPos = {};
  var outStyle = {};
  var origin = {};

  var _position = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(position, 4),
      p1 = _position[0],
      p2 = _position[1],
      p3 = _position[2],
      p4 = _position[3];

  var rect = $link.getBoundingClientRect();
  var refPos = { top: 0, left: 0 };
  var dpSize = getSize($dd);
  var parentPosition = document.defaultView.getComputedStyle($link.offsetParent).position;

  switch (parentPosition.toLowerCase()) {
    case 'fixed':
      refPos.left = rect.left - $link.offsetParent.offsetLeft;
      refPos.top = rect.top - $link.offsetParent.offsetTop;
      break;

    case 'absolute':
      var parentRect = $link.offsetParent.getBoundingClientRect();
      refPos.left = rect.left - parentRect.left;
      refPos.top = rect.top - parentRect.top;
      break;

    default:
      refPos.left = rect.left - $link.offsetParent.offsetLeft + window.pageXOffset;
      refPos.top = rect.top - $link.offsetParent.offsetTop + window.pageYOffset;
  }

  cornerPos.left = refPos.left;
  switch (p1) {
    case 'center':
      cornerPos.left += refSize.width / 2;
      break;

    case 'right':
      cornerPos.left += refSize.width;
      break;
  }

  cornerPos.top = refPos.top;
  switch (p2) {
    case 'center':
      cornerPos.top += refSize.height / 2;
      break;
    case 'bottom':
      cornerPos.top += refSize.height;
      break;
  }

  switch (p3) {
    case 'left':
      outStyle.left = Math.round(cornerPos.left);
      origin.left = 'left';
      break;

    case 'center':
      outStyle.left = Math.round(cornerPos.left - dpSize.width / 2);
      origin.left = 'center';
      break;

    default:
      outStyle.left = Math.round(cornerPos.left - dpSize.width);
      origin.left = 'right';
  }

  switch (p4) {
    case 'top':
      outStyle.top = Math.round(cornerPos.top);
      origin.top = 'top';
      break;

    case 'center':
      outStyle.top = Math.round(cornerPos.top - dpSize.height / 2);
      origin.top = 'center';
      break;

    default:
      outStyle.top = Math.round(cornerPos.top - dpSize.height);
      origin.top = 'bottom';
  }

  outStyle.left = outStyle.left + margin[0] + 'px';
  outStyle.top = outStyle.top + margin[1] + 'px';
  outStyle.transformOrigin = origin.left + ' ' + origin.top;
  outStyle.position = 'absolute';
  return outStyle;
}

var getWindow = function getWindow() {
  return window.document;
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'VueMyDropdown',

  data: function data() {
    return {
      ddStyle: {}
    };
  },


  props: {
    // Dropdown visibility.
    visible: {
      required: true,
      type: Boolean
    },

    // Dropdown position.
    position: {
      required: false,
      type: Array,
      default: function _default() {
        return ['right', 'top', 'left', 'top'];
      }
    },

    // Dropdown animation.
    animation: {
      required: false,
      type: String,
      default: 'ani-slide'
    }
  },

  methods: {
    open: function open() {
      var _this = this;

      this.setPosition();
      getWindow().addEventListener('resize', this.resizeEvent);
      setTimeout(function () {
        return getWindow().addEventListener('click', _this.clickOutEvent);
      }, 10);
    },
    close: function close() {
      getWindow().removeEventListener('resize', this.resizeEvent);
      getWindow().removeEventListener('click', this.clickOutEvent);
    },
    resizeEvent: function resizeEvent() {
      this.setPosition();
    },
    clickOutEvent: function clickOutEvent(evt) {
      var $dd = this.$el.children[1];
      if (evt.target !== $dd && !$dd.contains(evt.target)) {
        this.$emit('clickout', evt);
      }
    },
    setPosition: function setPosition() {
      var $link = this.$el.children[0];
      var $dd = this.$el.children[1];
      this.ddStyle = _setPosition($link, $dd, this.position, [0, 0]);
      this.$emit('positioned', this.ddStyle);
    }
  },

  watch: {
    visible: function visible(isVisible) {
      if (isVisible) {
        this.open();
      } else {
        this.close();
      }
    }
  },

  mounted: function mounted() {
    if (this.visible) {
      this.open();
    }
  },
  destroyed: function destroyed() {
    getWindow().removeEventListener('resize', this.resizeEvent);
    getWindow().removeEventListener('click', this.clickOutEvent);
  }
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
//
//
//
//
//




// Check if request comes from browser and is not server rendered
if (typeof window !== 'undefined') {
  var slick = __webpack_require__(729);
}

/* harmony default export */ __webpack_exports__["default"] = ({

  props: {
    options: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },

  mounted: function mounted() {
    this.create();
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('unslick');
  },


  methods: {
    create: function create() {
      var $slick = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el);

      $slick.on('afterChange', this.onAfterChange);
      $slick.on('beforeChange', this.onBeforeChange);
      $slick.on('breakpoint', this.onBreakpoint);
      $slick.on('destroy', this.onDestroy);
      $slick.on('edge', this.onEdge);
      $slick.on('init', this.onInit);
      $slick.on('reInit', this.onReInit);
      $slick.on('setPosition', this.onSetPosition);
      $slick.on('swipe', this.onSwipe);
      $slick.on('lazyLoaded', this.onLazyLoaded);
      $slick.on('lazyLoadError', this.onLazyLoadError);

      $slick.slick(this.options);
    },
    destroy: function destroy() {
      var $slick = __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el);

      $slick.off('afterChange', this.onAfterChange);
      $slick.off('beforeChange', this.onBeforeChange);
      $slick.off('breakpoint', this.onBreakpoint);
      $slick.off('destroy', this.onDestroy);
      $slick.off('edge', this.onEdge);
      $slick.off('init', this.onInit);
      $slick.off('reInit', this.onReInit);
      $slick.off('setPosition', this.onSetPosition);
      $slick.off('swipe', this.onSwipe);
      $slick.off('lazyLoaded', this.onLazyLoaded);
      $slick.off('lazyLoadError', this.onLazyLoadError);
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('unslick');
    },
    reSlick: function reSlick() {
      this.destroy();
      this.create();
    },
    next: function next() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickNext');
    },
    prev: function prev() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickPrev');
    },
    pause: function pause() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickPause');
    },
    play: function play() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickPlay');
    },
    goTo: function goTo(index, dontAnimate) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickGoTo', index, dontAnimate);
    },
    currentSlide: function currentSlide() {
      return __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickCurrentSlide');
    },
    add: function add(element, index, addBefore) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickAdd', element, index, addBefore);
    },
    remove: function remove(index, removeBefore) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickRemove', index, removeBefore);
    },
    filter: function filter(filterData) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickFilter', filterData);
    },
    unfilter: function unfilter() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickUnfilter');
    },
    getOption: function getOption(option) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickGetOption', option);
    },
    setOption: function setOption(option, value, refresh) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('slickSetOption', option, value, refresh);
    },
    setPosition: function setPosition() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()(this.$el).slick('setPosition');
    },


    // Events
    onAfterChange: function onAfterChange(event, slick, currentSlide) {
      this.$emit('afterChange', event, slick, currentSlide);
    },
    onBeforeChange: function onBeforeChange(event, slick, currentSlide, nextSlide) {
      this.$emit('beforeChange', event, slick, currentSlide, nextSlide);
    },
    onBreakpoint: function onBreakpoint(event, slick, breakpoint) {
      this.$emit('breakpoint', event, slick, breakpoint);
    },
    onDestroy: function onDestroy(event, slick) {
      this.$emit('destroy', event, slick);
    },
    onEdge: function onEdge(event, slick, direction) {
      this.$emit('edge', event, slick, direction);
    },
    onInit: function onInit(event, slick) {
      this.$emit('init', event, slick);
    },
    onReInit: function onReInit(event, slick) {
      this.$emit('reInit', event, slick);
    },
    onSetPosition: function onSetPosition(event, slick) {
      this.$emit('setPosition', event, slick);
    },
    onSwipe: function onSwipe(event, slick, direction) {
      this.$emit('swipe', event, slick, direction);
    },
    onLazyLoaded: function onLazyLoaded(event, slick, image, imageSource) {
      this.$emit('lazyLoaded', event, slick, image, imageSource);
    },
    onLazyLoadError: function onLazyLoadError(event, slick, image, imageSource) {
      this.$emit('lazyLoadError', event, slick, image, imageSource);
    }
  }

});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'PulseLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '15px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        width: this.size,
        height: this.size,
        margin: this.margin,
        borderRadius: this.radius,
        display: 'inline-block',
        animationName: 'v-pulseStretchDelay',
        animationDuration: '0.75s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'cubic-bezier(.2,.68,.18,1.08)',
        animationFillMode: 'both'
      },
      spinnerDelay1: {
        animationDelay: '0.12s'
      },
      spinnerDelay2: {
        animationDelay: '0.24s'
      },
      spinnerDelay3: {
        animationDelay: '0.36s'
      }
    };
  }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NavBarOverlay_vue__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_NavBarOverlay_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_NavBarOverlay_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Footer_vue__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Footer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_PulseLoader_vue__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_PulseLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_PulseLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FBChatNow_vue__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_FBChatNow_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_FBChatNow_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(41);

//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue'




// import EventBus from '@/controllers/EventBus'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  metaInfo: {
    title: 'noctorus',
    titleTemplate: '%s | noctorus.studio'
  },
  components: {
    NavbarOverlay: __WEBPACK_IMPORTED_MODULE_1__components_NavBarOverlay_vue___default.a,
    FooterMain: __WEBPACK_IMPORTED_MODULE_2__components_Footer_vue___default.a,
    FbChatNow: __WEBPACK_IMPORTED_MODULE_4__components_FBChatNow_vue___default.a,
    PulseLoader: __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_PulseLoader_vue___default.a
  },
  data: function data() {
    return {};
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* mapGetters */])(['isAuthenticated']),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    sample: function sample(data) {}
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapActions */])(['authenticated', 'unauthenticated'])),
  beforeCreate: function beforeCreate() {},
  created: function created() {
    console.log('created App.vue');
    // EventBus.$off('authenticated')
    // EventBus.$on('authenticated', (data) => {
    //   this.authenticated(data)
    // })
    // EventBus.$off('unauthenticated')
    // EventBus.$on('unauthenticated', () => {
    //   this.unauthenticated()
    // })
  },
  beforeMount: function beforeMount() {
    console.log('beforeMount App.vue');
    window.addEventListener('load', function () {
      // console.log('beforeMount App.vue')
      // // https://developer.mozilla.org/en-US/docs/Web/API/CSS_Object_Model/Determining_the_dimensions_of_elements
      // console.log('win width:' + window.innerWidth)
      // console.log('app width:' + this.$el.clientWidth)
    });
  },
  mounted: function mounted() {
    // // console.log('mounted App.vue')
    // window.fbAsyncInit = function () {
    //   /* global FB */
    //   FB.init({
    //     appId: '782732588553167',
    //     xfbml: true,
    //     version: 'v2.7'
    //   })
    //   window.FB = FB
    //   Object.defineProperty(Vue.prototype, '$FB', { value: FB })
    //   this.$FB.AppEvents.logPageView()
    //   console.log('init FB with ID in App.vue')
    // }.bind(this)
  }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_showcase_gap_png__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_showcase_gap_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_showcase_gap_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_showcase_doritos_png__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_showcase_doritos_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_showcase_doritos_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_showcase_keyg_png__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_showcase_keyg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_showcase_keyg_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_showcase_komaneko_png__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_showcase_komaneko_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_showcase_komaneko_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_showcase_lastingimpressions_png__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_showcase_lastingimpressions_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_showcase_lastingimpressions_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_slick__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_lightbox__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_lightbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_lightbox__);
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'carousel-slick',
  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_5_vue_slick___default.a,
    Lightbox: __WEBPACK_IMPORTED_MODULE_6_vue_lightbox___default.a
  },
  data: function data() {
    return {
      slickOptions: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        responsive: [{
          breakpoint: 1008,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        }, {
          // 768 = tablet (not break yet)
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true
          }
        }, {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true
          }
        }]
      },
      images: [{
        title: 'Lasting Impressions - http://lastingimpressions.noctorus.studio',
        src: __WEBPACK_IMPORTED_MODULE_4__assets_showcase_lastingimpressions_png___default.a,
        link: 'http://lastingimpressions.noctorus.studio',
        album: 'current'
      }, {
        title: 'Gap',
        src: __WEBPACK_IMPORTED_MODULE_0__assets_showcase_gap_png___default.a,
        link: '',
        album: 'current'
      }, {
        title: 'Doritos',
        src: __WEBPACK_IMPORTED_MODULE_1__assets_showcase_doritos_png___default.a,
        link: '',
        album: 'current'
      }, {
        title: 'keyG',
        src: __WEBPACK_IMPORTED_MODULE_2__assets_showcase_keyg_png___default.a,
        link: '',
        album: 'current'
      }, {
        title: 'Komaneko',
        src: __WEBPACK_IMPORTED_MODULE_3__assets_showcase_komaneko_png___default.a,
        link: '',
        album: 'current'
      }]
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    next: function next() {
      this.$refs.slick.next();
    },
    prev: function prev() {
      this.$refs.slick.prev();
    },
    reInit: function reInit() {
      this.$refs.slick.reSlick();
    }
  }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormDynamix__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_FormDynamix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_FormDynamix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DivColumns__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_DivColumns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_DivColumns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__apis_Singulo__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_recaptcha__ = __webpack_require__(325);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contactsection',
  mixins: [__WEBPACK_IMPORTED_MODULE_3_vuelidate__["validationMixin"]],
  components: {
    DivColumns: __WEBPACK_IMPORTED_MODULE_2__components_DivColumns___default.a,
    FormDynamix: __WEBPACK_IMPORTED_MODULE_1__components_FormDynamix___default.a,
    VueRecaptcha: __WEBPACK_IMPORTED_MODULE_6_vue_recaptcha__["a" /* default */]
  },
  data: function data() {
    return {
      isDesktop: true,
      isIE: __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].detectIE(),
      noPrint: true,
      isPrint: false,
      isPrintPdf: false,
      isRerender: false,
      // captcha: '',
      // session: '',
      // captchaImage: undefined,
      recaptcha: undefined,
      recaptchaKey: '6LfeGUAUAAAAAJO6iFz_2d4E0hWiyJ7B6K7k6QsG',
      names: ['name', 'lname', 'business', 'phone', 'email', 'message'],
      models: {
        recaptcha: undefined,
        name: '',
        lname: '',
        business: '',
        phone: '',
        email: '',
        message: ''
      },
      attributes: {
        name: {
          title: 'First Name',
          column: 'is-6'
        },
        lname: {
          title: 'Last Name',
          column: 'is-6'
        },
        business: {
          title: 'Business Name (optional)'
        },
        phone: {
          title: 'Phone Number',
          column: 'is-6'
        },
        email: {
          title: 'Email',
          column: 'is-6'
        },
        message: {
          type: 'textarea',
          title: 'Message',
          curLength: 0,
          maxLength: 500
        }
      },
      // captcha: '',
      // captchaImage: undefined,
      // session: '',
      feedback: false,
      loading: false,
      navEmail: __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._data._navEmail
    };
  },
  validations: {
    models: {
      recaptcha: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"] },
      name: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"] },
      lname: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"] },
      business: {},
      phone: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"], numeric: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["numeric"] },
      email: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"], email: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["email"], minLength: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["minLength"])(4) },
      message: { required: __WEBPACK_IMPORTED_MODULE_4_vuelidate_lib_validators__["required"] }
    }
  },
  mounted: function mounted() {
    // on event resize
    this.isDesktop = window.innerWidth >= 768;
    window.addEventListener('resize', function (event) {
      // console.log('on viewport change')
      this.isDesktop = event.target.innerWidth >= 768;
    }.bind(this));
  },
  methods: {
    onRecaptcha: function onRecaptcha(info) {
      console.log('recaptcha');
      console.log(info);
      if (info && info.status) {
        this.models.recaptcha = info.status === 'ok' ? info.response : undefined;
        if (info.status !== 'ok') {
          // console.log('FormDynamix:recaptcha():' + info.status)
        }
      }
    },

    onClear: function onClear() {
      this.isRerender = true;
      this.models.recaptcha = undefined;

      this.models.name = '';
      this.models.lname = '';
      this.models.business = '';
      this.models.phone = '';
      this.models.email = '';
      this.models.message = '';

      this.$nextTick(function () {
        this.isRerender = false;
      });
    },

    onSend: function onSend(formInfo) {
      var _this = this;

      // $v.models.$touch()
      var _self = this;
      // console.log('ContactSection:onSend(): $v / models')
      // console.log(formInfo)

      // var models = formInfo.models
      if (formInfo.vuelidate.$invalid) {
        _self.feedback = 'Form contains errors, please recheck.';
        // _self.$toast.open({
        //   duration: 5000,
        //   message: 'Please fill in all fields to proceed.',
        //   position: 'is-bottom',
        //   type: 'is-warning'
        // })
        return;
      }

      if (!this.models.recaptcha) {
        _self.feedback = 'Invalid recaptcha, please validate again.';
        return;
      }
      _self.feedback = false;

      var models = formInfo.models;

      // console.log('-- send form --')
      // console.log(models)
      // console.log(models.name)
      // console.log(models.lname)
      // console.log(models.business)
      // console.log(models.phone)
      // console.log(models.email)
      // console.log(models.message)

      // if (formInfo) {
      //   return
      // }

      _self.loading = true;
      __WEBPACK_IMPORTED_MODULE_5__apis_Singulo__["a" /* default */].email('contact', models.recaptcha, models.name, models.lname, models.business, models.phone, models.email, models.message).then(function (data) {
        _self.loading = false;

        if (!data || data && data.status !== 'ok') {
          _self.feedback = 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail;
          return;
        }

        _this.$v.models.$reset();
        _this.onClear();

        // _self.captcha = ''
        // _self.session = '' // open up to maintain session

        _self.$toast.open({
          message: 'Your request has been successfully submitted. Thank you for your enquiry.',
          position: 'is-bottom',
          type: 'is-success'
        });
        _self.feedback = 'Your request has been successfully submitted. Thank you for your enquiry.';
      }).catch(function (error) {
        // this.error = error.error
        // console.log(error)
        // _self.captcha = ''

        // invalid validate
        if (error && error.status === 'invalid_validate') {
          _self.feedback = 'Invalid data, please recheck input.';
          _self.loading = false;
          return;
        }

        // invalid recaptcha
        if (error && error.status === 'invalid_recaptcha') {
          _self.feedback = 'Invalid recaptcha, please kindly refresh and try again.';
          _self.loading = false;
          return;
        }

        // _self.$toast.open({
        //   duration: 5000,
        //   message: 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail,
        //   position: 'is-bottom',
        //   type: 'is-warning'
        // })
        _self.feedback = 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail;
        _self.loading = false;
      });
    }
  }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DivContainer__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DivColumns__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DivColumns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__DivColumns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GalleryDynamix__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GalleryDynamix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__GalleryDynamix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_project_logo_adamlobo_svg__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_project_logo_adamlobo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_project_logo_adamlobo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_project_logo_idlycity_svg__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_project_logo_idlycity_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_project_logo_idlycity_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_project_logo_lastingimpressions_svg__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_project_logo_lastingimpressions_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_project_logo_lastingimpressions_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_project_logo_icmarc_png__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_project_logo_icmarc_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_project_logo_icmarc_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_project_logo_vr_png__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_project_logo_vr_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_project_logo_vr_png__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'section-project-list',
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_0__DivContainer___default.a,
    DivColumns: __WEBPACK_IMPORTED_MODULE_1__DivColumns___default.a,
    GalleryDynamix: __WEBPACK_IMPORTED_MODULE_2__GalleryDynamix___default.a
  },
  data: function data() {
    return {
      quoteContent: '',
      workList: [{
        name: 'Adam Lobo',
        link: 'http://adamlobo.tv',
        logo: __WEBPACK_IMPORTED_MODULE_3__assets_project_logo_adamlobo_svg___default.a
      }, {
        name: 'Idly City',
        link: 'https://idlycity.noctorus.studio',
        logo: __WEBPACK_IMPORTED_MODULE_4__assets_project_logo_idlycity_svg___default.a
      }, {
        name: 'Shopify Setup',
        link: 'http://shop.lasting-impressions.com.my',
        logo: __WEBPACK_IMPORTED_MODULE_5__assets_project_logo_lastingimpressions_svg___default.a
      }, {
        name: 'Web Game',
        link: 'https://icmarc.noctorus.studio/',
        logo: __WEBPACK_IMPORTED_MODULE_6__assets_project_logo_icmarc_png___default.a
      }, {
        name: 'VR',
        link: 'https://vrcard.noctorus.studio/',
        logo: __WEBPACK_IMPORTED_MODULE_7__assets_project_logo_vr_png___default.a
      }]
    };
  },

  computed: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {}
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'section-quote',
  components: {},
  data: function data() {
    return {
      quoteContent: ''
    };
  },

  computed: {
    quoteContentUrl: function quoteContentUrl() {
      return 'https://twitter.com/intent/tweet?text=' + encodeURI(this.quoteContent);
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.refreshQuote();
  },

  methods: {
    refreshQuote: function refreshQuote() {
      var quotes = ['Don\'t complain about the snow on your neighbour\'s roof when your own doorstep is unclean. — Confucious', 'A great man shows his greatness by the way he treats little men. ― Thomas Carlyle', 'I can\'t imagine a man really enjoying a book and reading it only once. ― C.S. Lewis', 'If I find in myself a desire which no experience in this world can satisfy, the most probable explanation is that I was made for another world. ― C.S. Lewis', 'They that be whole need not a physician, but they that are sick.', 'Every kingdom divided against itself is brought to desolation, and every city or house divided against itself shall not stand.', 'He is no fool who gives what he cannot keep to gain that which he cannot lose. ― Jim Elliot', 'The journey of a thousand miles begins with a single step. ― Laozi', 'Give a man a fish and you feed him for a day. Teach him how to fish and you feed him for a lifetime.', 'No! Try not. Do... or do not. There is no try. ― Yoda', 'A neutron walks into a bar and asks how much for a drink. The barman replies for you no charge. ― Sheldon Cooper', 'Sheldon: \'Well, this is confusing for me. But I don\'t want to stand in the way of your happiness. So, I will condemn you internally while maintaining an outward appearance of acceptance.\'', 'My fists are not up here because I am milking a giant invisible cow. ― Sheldon Cooper', 'Almost every successful person begins with two beliefs...the future can be better than the present, and I have the power to make it so. ― Zig Ziglar', 'Remember that failure is an event, not a person. ― Zig Ziglar', 'The more you complain about your problems, the more problems you will have to complain about. ― Zig Ziglar', 'Far too many people have no idea what they can do because all they\'ve been told is what they can\'t do. ― Zig Ziglar', 'The master has failed more times than the beginner has even tried. ― Zig Ziglar', 'Your character should always be stronger than your circumstances. ― Zig Ziglar', 'All our dreams can come true if we have the courage to pursue them. ― Walt Disney', 'Done is better than perfect. - Anonymous'];
      var randomNumber = Math.floor(Math.random() * quotes.length);
      this.quoteContent = quotes[randomNumber];
      console.log(this.quoteContent);
    }
  }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'section-service-list',
  components: {},
  data: function data() {
    return {
      quoteContent: ''
    };
  },

  computed: {
    quoteContentUrl: function quoteContentUrl() {
      return 'https://twitter.com/intent/tweet?text=' + encodeURI(this.quoteContent);
    }
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {}
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'div-columns',
  props: ['div-style', 'full', 'column-num', 'padding-top', 'padding-bottom', 'background-color', 'text-align'],
  components: {},
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    this.refresh();
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    refresh: function refresh() {}
  }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'div-container',
  props: ['full', 'columnNum', 'paddingTop', 'paddingBottom', 'backgroundColor'],
  components: {},
  data: function data() {
    return {};
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {
    this.refresh();
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    refresh: function refresh() {}
  }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_FBControl__ = __webpack_require__(75);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      show: false,
      fButtonClass: 'slideUp',
      fBoxStyle: {
        overflow: 'hidden',
        height: '0px',
        padding: 0,
        margin: 0,
        display: 'none'
      },
      fCounting: 0,
      intervalSlideUp: undefined,
      intervalSlideDown: undefined,
      logged: 'not_logged',
      FB: undefined
    };
  },
  props: {},
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__controllers_FBControl__["a" /* default */].getFB().then(function (FB) {
      console.log('getting FB@!!');
      console.log(FB);
      _this.FB = FB;
    }).catch(function (error) {
      console.log('no FB@!!');
      console.log(error);
    });
  },

  methods: {
    onShowToggle: function onShowToggle() {
      this.show = !this.show;
      if (this.show) {
        this.fButtonClass = 'slideDown';
      } else {
        this.fButtonClass = 'slideUp';
      }
    },
    onCountDownSlideUp: function onCountDownSlideUp() {
      var _this2 = this;

      // on init
      this.fButtonClass = 'slideDown';
      this.fBoxStyle.display = 'block';

      // start counting up
      this.intervalSlideUp = setInterval(function () {
        _this2.fCounting += 15;
        _this2.fBoxStyle.height = _this2.fCounting + 'px';
        if (_this2.fCounting >= 350) {
          _this2.fCounting = 350;
          _this2.fBoxStyle.height = _this2.fCounting + 'px';
          if (_this2.intervalSlideUp) {
            clearInterval(_this2.intervalSlideUp);
            _this2.intervalSlideUp = undefined;
          }
          if (_this2.intervalSlideDown) {
            clearInterval(_this2.intervalSlideDown);
            _this2.intervalSlideDown = undefined;
          }

          // on complete
          _this2.fBoxStyle.overflow = 'inherit';
          return;
        }
      }, 10);
    },
    onCountDownSlideDown: function onCountDownSlideDown() {
      var _this3 = this;

      // on init
      this.fBoxStyle.overflow = 'hidden';

      // start counting down
      this.intervalSlideDown = setInterval(function () {
        _this3.fCounting -= 15;
        _this3.fBoxStyle.height = _this3.fCounting + 'px';
        if (_this3.fCounting < 0) {
          _this3.fCounting = 0;
          _this3.fBoxStyle.height = _this3.fCounting + 'px';
          if (_this3.intervalSlideUp) {
            clearInterval(_this3.intervalSlideUp);
            _this3.intervalSlideUp = undefined;
          }
          if (_this3.intervalSlideDown) {
            clearInterval(_this3.intervalSlideDown);
            _this3.intervalSlideDown = undefined;
          }

          // on complete
          _this3.fBoxStyle.display = 'none';
          _this3.fButtonClass = 'slideUp';
          return;
        }
      }, 10);
    }
  }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_FBControl__ = __webpack_require__(75);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      logged: 'not_logged',
      FB: undefined
    };
  },
  props: {},
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__controllers_FBControl__["a" /* default */].getFB().then(function (FB) {
      console.log('getting FB@!!');
      console.log(FB);
      _this.FB = FB;
      _this.FB.login(_this.check_login);
    }).catch(function (error) {
      console.log('no FB@!!');
      console.log(error);
    });
  },

  methods: {
    cancelled: function cancelled(response) {
      console.log('fb: cancelled');
      // FB.login(this.check_login);
      this.logged = 'cancelled';
    },
    logged_in: function logged_in(response) {
      console.log('fb: logged_in');
      this.logged = 'logged';
      this.$emit('fb-logged');
      console.log(response);
      // var token = 'EAALH5CHlE88BAHZA8bGBD0uaTrsZA4CAkEiQQ7eLXlyxdWpgFBAgbRTYcwwEdTaZC7EYKm4TZBI549Pq4IKlFmZCZAtamgZBZAZCrv0XQ4Ohl7EgJs5rv8eaLbrpFF1zH4GAQe6ZCaLuefOWTwV0D1IWElcWpv9sAd9kU7I1PzY54vXQZDZD'
      // this.FB.api('/me/messages?access_token=' + token, {
      //   receipient: {
      //     id: '418381418548219'
      //   },
      //   message: {
      //     text: 'hello123'
      //   }
      // }, function (response) {
      //   console.log('fb: message success')
      //   console.log(response)
      // }, function (error) {
      //   console.log('fb: message error')
      //   console.log(error)
      // })
    },
    login: function login() {
      console.log('fb: login');
      this.FB.login(this.check_login);
    },
    check_login: function check_login(response) {
      var _this2 = this;

      if (response.status === 'connected') {
        console.log('fb: check_login: connected');
        this.logged_in(response);
      } else {
        console.log('fb: check_login: not connected, retry');
        this.FB.login(function (response) {
          if (response.status === 'connected') {
            _this2.logged_in(response);
            return;
          }
          _this2.cancelled(response);
        });
      }
    }
  }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'footer',
  components: {},
  data: function data() {
    return {};
  },

  methods: {
    sample: function sample(data) {}
  },
  created: function created() {},
  beforeMount: function beforeMount() {},
  mounted: function mounted() {}
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_recaptcha__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__apis_Singulo__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lightbox__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lightbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_lightbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FormUpload__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_FormUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_FormUpload__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'section-sign-up-team',
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default.a,
    Lightbox: __WEBPACK_IMPORTED_MODULE_4_vue_lightbox___default.a,
    VueRecaptcha: __WEBPACK_IMPORTED_MODULE_2_vue_recaptcha__["a" /* default */],
    FormUpload: __WEBPACK_IMPORTED_MODULE_5__components_FormUpload___default.a
  },
  watch: {},
  props: ['type', 'feedback', 'loading', 'names', 'models', 'attributes', 'vuelidate', 'no-print', // disable print function
  'is-print', // check if current state is printable
  'is-print-pdf', 'is-rerender'],
  data: function data() {
    return {
      isDesktop: true,
      isIE: __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].detectIE(),
      items: [],
      // captcha: '', // use back model's captcha for validation
      captchaImage: undefined,
      session: '',
      recaptchaKey: '6LfeGUAUAAAAAJO6iFz_2d4E0hWiyJ7B6K7k6QsG',
      // feedback: false, // capture from external due to send function
      // loading: false,
      navEmail: __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._data._navEmail
    };
  },
  created: function created() {
    // console.log('FormDynamix:created(): $v / models')
    // console.log(this.vuelidate)
    // console.log(this.models)
    this.init();
  },
  mounted: function mounted() {
    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));

    // this.onRecaptcha(data => {
    //   this.captchaImage = data.data
    //   this.session = data.id
    // })

    // console.log('FormDynamix:mounted(): $v / models')
    // console.log(this.vuelidate)
    // console.log(this.models)
  },
  methods: {
    init: function init() {
      // console.log('FormDynamix:init()')
      if (this.vuelidate) {
        if (this.vuelidate.models) {
          for (var i = 0; i < this.names.length; i++) {
            var name = this.names[i];
            if (this.vuelidate.models[name]) {
              if (!this.attributes[name]) {
                this.$set(this.attributes, name, {
                  type: 'text',
                  title: 'Invalid'
                });
              }

              // assign default type
              if (this.attributes[name] && !this.attributes[name].type) {
                this.attributes[name].type = 'text';
              }
              // if (this.attributes[name] && !this.attributes[name].title) {
              //   this.attributes[name].title = 'Invalid'
              // }

              // text area custom type
              if (this.attributes[name] && this.attributes[name].type === 'textarea') {
                if (!this.attributes[name].hasOwnProperty('onInput')) {
                  this.attributes[name].onInput = function (model, params) {
                    if (model) {
                      params.curLength = model.length;
                    }
                  };
                }
                if (!this.attributes[name].curLength) {
                  this.attributes[name].curLength = 0;
                }
                if (!this.attributes[name].maxLength) {
                  this.attributes[name].maxLength = 500;
                }
              }

              // check box custom type
              if (this.attributes[name] && this.attributes[name].type === 'checkbox') {}

              // console.log('initializing:' + name)
              // console.log(this.attributes[name])
              this.$set(this.vuelidate.models[name], 'name', name);
              this.$set(this.vuelidate.models[name], 'attributes', this.attributes[name]);
              this.items.push(this.vuelidate.models[name]);
            }
          }
        }
      }
    },
    onRecaptcha: function onRecaptcha(onRecaptchaSuccess) {
      __WEBPACK_IMPORTED_MODULE_3__apis_Singulo__["a" /* default */].getRecaptcha().then(function (data) {
        // console.log('get recaptcha')
        // console.log(data)
        if (onRecaptchaSuccess) {
          onRecaptchaSuccess(data);
        }
      }).catch(function (error) {
        console.error('get recaptcha error', error);
      });
    },
    onRenderRecaptcha: function onRenderRecaptcha(id) {
      this.$emit('recaptcha', { status: 'init' });
    },
    onExpiredRecaptcha: function onExpiredRecaptcha() {
      this.$emit('recaptcha', { status: 'expired' });
    },
    onVerifyRecaptcha: function onVerifyRecaptcha(response) {
      // console.log(response)
      if (response && response.length > 0) {
        this.$emit('recaptcha', { status: 'ok', response: response });
      }
    },
    onResetRecaptcha: function onResetRecaptcha() {
      this.$refs.recaptcha.reset();
      this.$emit('recaptcha', { status: 'reset' });
    },
    onApplicationChanged: function onApplicationChanged(applicationType) {
      console.log('application type changed: ' + applicationType);
    },
    onFilesChanged: function onFilesChanged(data) {
      // console.log('-- onFilesChanged --')
      // console.log(data)
      this.$emit('files-changed', data);
      // update model
      if (data.fieldName) {
        // this.models[data.fieldName] = data.files
        if (data.files && data.files.length > 0) {
          this.models[data.fieldName] = data.files;
          this.$set(this.models, data.fieldName, data.files);
        } else {
          this.models[data.fieldName] = undefined;
          this.$set(this.models, data.fieldName, undefined);
        }
      }
    },
    onFilesError: function onFilesError(error) {
      // console.log('-- onFilesError --')
      // console.log(error)
      this.$emit('files-error', error);
    },
    onSend: function onSend(vuelidate) {
      vuelidate.models.$touch();
      // var _self = this
      // console.log(vuelidate)
      // console.log(this.models)
      this.$emit('send', { vuelidate: vuelidate, models: this.models, session: this.session, captcha: this.models.captcha });
    }
  }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['error'],
  computed: {
    infos: function infos() {
      var infos = [];
      for (var i = 0; i < this.error.length; i++) {
        infos.push({
          message: this.error[i]
        });
      }
      return infos;
    }
  }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue'
/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    type: {
      default: 'text'
    },
    name: {
      default: 'invalid'
    },
    mdi: {
      default: 'error_outline'
    },
    placeholder: {
      default: 'invalid'
    },
    value: {
      default: 'invalid'
    },
    error: {
      default: undefined
    },
    required: {
      default: true
    },
    disabled: {
      default: false
    },
    autofocus: {
      default: false
    }
  },
  data: function data() {
    return {
      model: ''
      // value: 'invalid@invalid.com'
      // name: 'invalid',
      // type: 'invalid',
      // fa: 'error',
      // placeholder: 'invalid',
      // error: undefined
    };
  },

  computed: {},
  methods: {
    onInput: function onInput(event) {
      this.model = event.target.value;
      this.$emit('onInput', { name: this.name, value: this.model });
    }
  },
  created: function created() {},
  mounted: function mounted() {},

  watch: {
    value: function value(val, old) {
      // to tally with external value
      this.model = this.value;

      // do not echo back!
      // this.$emit('onInput', { name: this.name, value: val })
    },
    model: function model(val, old) {
      // do not echo back!
      // this.$emit('onInput', { name: this.name, value: val })
    }
  }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { Upload } from '@/apis/Upload'

var STATUS_INITIAL = 0;
var STATUS_SAVING = 1;
var STATUS_SUCCESS = 2;
var STATUS_FAILED = 3;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  props: ['vuelidate', 'is-dirty', 'is-required'],
  data: function data() {
    return {
      rerender: false,
      uploadedFiles: [],
      uploadError: undefined,
      currentStatus: undefined,
      uploadFieldName: 'files',
      fileCount: 0,
      dragging: false,
      data: {
        status: 'ok',
        files: []
      }
    };
  },

  computed: {
    isInitial: function isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving: function isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess: function isSuccess() {
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed: function isFailed() {
      return this.currentStatus === STATUS_FAILED;
    }
  },
  methods: {
    reset: function reset() {
      var vm = this;
      vm.rerender = false;
      vm.$nextTick(function () {
        vm.rerender = true;
      });

      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFiles = [];
      this.uploadError = undefined;
      this.$emit('files-changed', {
        status: 'initial',
        fieldName: this.uploadFieldName,
        files: [],
        formData: undefined
      });
    },
    save: function save(formData) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING;

      var data = {
        status: 'ok',
        fieldName: this.uploadFieldName,
        files: []
      };
      var index = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(formData.entries()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var pair = _step.value;

          var dataInfo = {
            index: index,
            preview: undefined,
            file: pair[1],
            formData: formData
          };
          data.files[index] = dataInfo;
          this.getFilePreview(dataInfo, function (index, url) {
            data.files[index].preview = url;
          });
          index++;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      data.formData = formData;
      this.uploadedFiles = data.files;
      this.currentStatus = STATUS_SUCCESS;
      this.$emit('files-changed', data);

      // var vm = this
      // Upload(formData)
      //   .then(data => {
      //     // console.log('-- data --')
      //     // console.log(data)
      //     // vm.uploadedFiles = [].concat(data)
      //     data.fieldName = vm.uploadFieldName
      //
      //     for (var i = 0; i < data.files.length; i++) {
      //       var fileInfo = data.files[i]
      //       fileInfo.index = i
      //       fileInfo.preview = undefined
      //       vm.getFilePreview(fileInfo, (index, url) => {
      //         // console.log('-- data url --')
      //         // console.log(index)
      //         data.files[index].preview = url
      //         // vm.$set(data.files[index], 'preview', url)
      //       })
      //     }
      //
      //     if (data.files) {
      //       vm.uploadedFiles = data.files
      //     } else {
      //       vm.uploadedFiles = []
      //     }
      //     vm.currentStatus = STATUS_SUCCESS
      //     vm.$emit('files-changed', data)
      //   })
      //   .catch(error => {
      //     // console.log('-- error --')
      //     // console.log(error)
      //     vm.uploadedFiles = []
      //     vm.uploadError = error.response
      //     vm.currentStatus = STATUS_FAILED
      //     vm.$emit('files-error', error)
      //   })
    },
    filesChange: function filesChange(fieldName, fileList) {
      // console.log('-- files change --')
      // console.log(fieldName)
      // console.log(fileList)
      // console.log(Array(fileList).keys())

      var formData = new FormData();
      if (!fileList.length) return;

      this.fileCount = fileList.length;

      var errMessage;
      if (fileList.length > 3) {
        errMessage = 'Please do not upload more than 3 photos.';
        this.uploadError = errMessage;
        this.currentStatus = STATUS_FAILED;
        this.$emit('files-error', {
          status: 'invalid_count',
          message: errMessage
        });
        return;
      }

      for (var x = 0; x < fileList.length; x++) {
        var file = fileList[x];
        if (file.size > 5242880) {
          errMessage = 'File(s) size exceeded 5MB! // ' + file.size;
          this.uploadError = errMessage;
          this.currentStatus = STATUS_FAILED;
          this.$emit('files-error', {
            status: 'invalid_size',
            message: errMessage
          });
          return;
        }

        if (!/\.(jpe?g|png|gif)$/i.test(file.name)) {
          errMessage = 'Invalid file(s) format.';
          this.uploadError = errMessage;
          this.currentStatus = STATUS_FAILED;
          this.$emit('files-error', {
            status: 'invalid_format',
            message: errMessage
          });
          return;
        }
      }

      for (var i = 0; i < fileList.length; i++) {
        formData.append(fieldName + '[' + i + ']', fileList[i], fileList[i].name);
      }

      // for (var pair of formData.entries()) {
      //   console.log('-- part --')
      //   console.log(pair[0])
      //   console.log(pair[1])
      // }
      this.save(formData);
    },
    getFilePreview: function getFilePreview(fileInfo, onComplete) {
      var file = fileInfo.file;
      var reader = new window.FileReader();
      reader.onload = function (event) {
        // console.log('-- onload --')
        // console.log(event)
        var imageDataUrl = event.target.result;
        fileInfo.preview = imageDataUrl;
        if (onComplete) {
          onComplete(fileInfo.index, imageDataUrl);
        }
      };
      reader.readAsDataURL(file);
    }
  },
  mounted: function mounted() {
    this.reset();
  }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_project1_jpg__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_project1_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_project1_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project2_jpg__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project2_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_project2_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_project3_jpg__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_project3_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_project3_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_project4_jpg__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_project4_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_project4_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_project5_jpg__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_project5_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_project5_jpg__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Singulo from '@/apis/Singulo'





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      error: null,
      imagesLoaded: [{
        image: {
          path: __WEBPACK_IMPORTED_MODULE_0__assets_project1_jpg___default.a
        },
        url_1: 'http://lasting-impressions.com.my'
      }, {
        image: {
          path: __WEBPACK_IMPORTED_MODULE_1__assets_project2_jpg___default.a
        },
        url_1: 'https://bosshogcookoff.com'
      }, {
        image: {
          path: __WEBPACK_IMPORTED_MODULE_2__assets_project3_jpg___default.a
        },
        url_1: 'http://intourlive.com'
      }, {
        image: {
          path: __WEBPACK_IMPORTED_MODULE_3__assets_project4_jpg___default.a
        },
        url_1: 'https://deltatpc.com'
      }, {
        image: {
          path: __WEBPACK_IMPORTED_MODULE_4__assets_project5_jpg___default.a
        },
        url_1: 'https://allaboutthesweetsbakery.com'
      }],
      images: [],
      segments: []
    };
  },

  methods: {
    arraySplice: function arraySplice(curr, num) {
      var first = [];
      var second = [];
      if (num > curr.length) {
        num = curr.length;
      }
      for (var i = 0; i < curr.length; i++) {
        if (i < num) {
          first.push(curr[i]);
        } else {
          second.push(curr[i]);
        }
      }
      return {
        curr: curr,
        splice: first,
        remain: second
      };
    },
    updateUI: function updateUI(images) {
      this.segments = [];
      var variation = 14;
      var spliceMap = [3, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5];
      // types of grid:
      //
      // 0,1,2,3,4,5,6
      //
      // 310: ... or .-- or --.  0 // 1 // 2
      // 320: |-- or --|         3 // 4
      //      |--    --|
      // 330: ==. or .==         5 // 6
      //        .    .
      //
      // 7,8,9,10,11,12,13
      //
      // 410: --| or ..|  7 // 8
      //      ..|    __|
      //   or |__ or |..  9 // 10
      //      |..    |__
      // 510: ..| or |..  11 // 12   or .|.  // 13
      //      ..|    |..                .|.
      //
      var failsafe = 100;
      // var selection = 0
      var selection = Math.floor(Math.random() * variation); // first selection
      var selectionSplice = spliceMap[selection];
      console.log('splice=' + selection + ',' + selectionSplice);

      while (images.length > 0 && failsafe > 0) {
        failsafe--;
        if (failsafe < 80) {
          console.error('invalid territory');
          break;
        }

        var spliced = this.arraySplice(images, selectionSplice);
        if (spliced.splice.length <= 0) {
          break;
        }

        // do not let remain === 1 case, reshuffle
        if (spliced.remain.length === 1) {
          console.error('splice=' + selection + ',' + selectionSplice + ', spliced=' + spliced.splice.length + ' remain=' + spliced.remain.length);
          selection = Math.floor(Math.random() * variation);
          selectionSplice = spliceMap[selection];
          continue;
        }

        this.segments.push({
          selection: selection,
          items: spliced.splice
        });
        console.log('splice=' + selection + ',' + selectionSplice + ', spliced=' + spliced.splice.length + ' remain=' + spliced.remain.length);
        images = spliced.remain;

        selection = Math.floor(Math.random() * variation); // next selection
        // selection++
        // if (selection >= variation) {
        //   selection = 0
        // }
        selectionSplice = spliceMap[selection];
      }

      // check if last splice is valid type or not
      var segmentLast = this.segments[this.segments.length - 1];
      if (segmentLast.items.length !== spliceMap[segmentLast.selection]) {
        var invalid = true;
        for (var i = 0; i < 40; i++) {
          selection = Math.floor(Math.random() * variation); // next selection
          if (segmentLast.items.length === spliceMap[selection]) {
            console.warn('reassign last splice to ' + selection);
            segmentLast.selection = selection;
            invalid = false;
            break;
          }
        }

        if (invalid) {
          console.error('invalid last splice');
          segmentLast.selection = variation;
        }
      }

      if (images.length <= 0) {
        console.log('images spliced correctly');
      }
    },
    refresh: function refresh() {
      // Singulo.gallery()
      // .then(data => {
      //   console.log('get gallery')
      //   console.log(data)
      //   this.images = data
      //   this.updateUI(data)
      // })
      // .catch(error => {
      //   console.log('invalid get gallery', error)
      //   this.error = error.error
      // })
      this.images = this.imagesLoaded;
      this.updateUI(this.images);
    }
  },
  beforeCreate: function beforeCreate() {},
  created: function created() {
    console.log('created Gallery.vue');
  },
  mounted: function mounted() {
    console.log('mounted Gallery.vue');
    this.$scrollTo(0);
    this.refresh();
  }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import _ from 'lodash'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'header-prop',
  props: ['title', 'subtitle'],
  data: function data() {
    return {};
  },
  mounted: function mounted() {}
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_Auth__ = __webpack_require__(28);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import EventBus from '@/controllers/EventBus'

// import Instafetch from '@/controllers/Instafetch'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'masonry-instagram',
  components: {},
  data: function data() {
    return {
      isDesktop: true,
      itemsCache: [],
      items: [],
      itemsLoading: false,
      itemsEnded: false,
      itemsHasNext: false,
      itemsHasNextToken: undefined,
      itemsMax: 48,
      error: undefined
    };
  },

  computed: {},
  watch: {},
  created: function created() {
    // console.log('created MasonryInstagram.vue')
  },
  mounted: function mounted() {
    // console.log('mounted MasonryInstagram.vue')
    // window.GA('send', 'pageview')

    // on event resize
    this.isDesktop = window.innerWidth >= 768;
    window.addEventListener('resize', function (event) {
      // console.log('on viewport change')
      this.isDesktop = event.target.innerWidth >= 768;
    }.bind(this));

    // refresh masonry
    this.refresh();

    // var callbackInstagram = function (data) {
    //   console.log(data)
    // }
    // var fetcher = new Instafetch('15794449.23ef492.b92d5f8be35a469ebfaeceb6b259b3d7')
    // // var fetcher = new Instafetch('23ef492f142645d7892ae61d3697f3a6')
    // fetcher.fetch({
    //   // user: 15794449,
    //   tag: 'adamlobotv',
    //   limit: 88,
    //   callback: callbackInstagram
    //   // params: '9gagBlock'
    // })
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    parseInstagramImageLink: function parseInstagramImageLink(link) {
      var linkOut = link.replace(/(https*:\/\/.*\/.*)\/.*\/.*\/.*(\/.*)/g, '$1$2');
      return linkOut;
    },

    getItems: function getItems(onComplete) {
      var _this = this;

      this.itemsLoading = true;
      this.error = undefined;
      __WEBPACK_IMPORTED_MODULE_0__apis_Auth__["a" /* default */].instagramUser('adamlob0', this.itemsHasNextToken).then(function (data) {
        // console.log('get gallery')
        // console.log(data)
        _this.itemsHasNext = data.hasNextPage;
        _this.itemsHasNextToken = data.maxId;
        onComplete(data.items);
        _this.itemsLoading = false;
      }).catch(function (error) {
        // console.log('invalid get gallery', error)
        _this.items = [];
        _this.error = error.error;
        _this.error = 'Unable to load, please kindly visit our Instagram account <a href="https://www.instagram.com/intourlive" target="_blank">here</a>.';
        _this.itemsLoading = false;
      });
    },
    refresh: function refresh() {
      var _this2 = this;

      this.getItems(function (items) {
        _this2.items = items;
      });
    },
    loadMore: function loadMore() {
      // return if exceed (showcase purpose)
      if (!this.itemsHasNext) {
        this.itemsEnded = true;
        this.$emit('onItemsEnded', {});
        return;
      }

      if (!this.itemsEnded) {
        this.getItems(function (items) {
          this.items = this.items.concat(items);
          if (this.items.length > this.itemsMax) {
            this.items = this.items.slice(0, this.itemsMax);
            this.itemsEnded = true;
            this.$emit('onItemsEnded', {});
          }
        }.bind(this));
      }
    }
  }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_DivContainer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_my_dropdown__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_my_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_my_dropdown__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navbarfull',
  components: {
    DivContainer: __WEBPACK_IMPORTED_MODULE_1__components_DivContainer___default.a,
    Dropdown: __WEBPACK_IMPORTED_MODULE_2_vue_my_dropdown___default.a
  },
  props: ['toggle'],
  data: function data() {
    return {
      isDesktop: true,
      showNav: false,
      isLanding: false,
      isAffix: false,
      scrollOffset: 500,
      scrollPos: 0, // for vue2-scrollspy
      navMain: __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._data._navMain,
      visible: false
    };
  },

  computed: {},
  watch: {
    toggle: function toggle(val) {
      this.showNav = val;
    },
    '$route.name': function $routeName(val) {
      // in case route change, revert value to 0
      // this.isLanding = false
      // this.isAffix = false
      this.scrollPos = 0;
    }
  },
  beforeCreate: function beforeCreate() {
    // in this function
    // modification to data will not invoke
  },
  created: function created() {
    var _this = this;

    // initial init for landing and affix (mobile/desktop)
    this.isLanding = window.innerWidth >= 1008 && this.$route.name === 'landing';
    this.isAffix = document.body.scrollTop > this.scrollOffset || document.documentElement.scrollTop > this.scrollOffset;

    // on event change hook
    this.$router.afterHooks.push(function (to, from) {
      // console.log('route change get!!')
      if (to && to.name) {
        _this.isLanding = to.name === 'landing';
      }
    });

    // on event resize
    window.addEventListener('resize', function (event) {
      // console.log('on viewport change')
      this.isLanding = event.target.innerWidth >= 1008 && this.$route.name === 'landing';
    }.bind(this));

    window.addEventListener('scroll', function (event) {
      // console.log('on scroll')
      // console.log(event)
      this.isAffix = document.body.scrollTop > this.scrollOffset || document.documentElement.scrollTop > this.scrollOffset;
    }.bind(this));
  },
  beforeMount: function beforeMount() {},
  mounted: function mounted() {
    // on event resize
    this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].$on('isDesktopChanged', function () {
      this.isDesktop = __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._isDesktop;
    }.bind(this));

    // EventBus.$on('scroll-pos-change', (data) => {
    //   if (data &&
    //     data.name &&
    //     data.name === 'landing') {
    //     if (data.scrollPos === 0) {
    //       this.scrollPos = 0
    //     } else if (data.scrollPos >= 1 && data.scrollPos < 3) {
    //       this.scrollPos = 1
    //     } else {
    //       this.scrollPos = 2
    //     }
    //   }
    // })
  },

  methods: {
    onMouseOverSubnav: function onMouseOverSubnav($event, subnav) {
      if (subnav) {
        this.visible = true;
      }
    },
    onMouseOutSubnav: function onMouseOutSubnav($event, subnav) {
      if (subnav) {
        this.visible = false;
      }
    },
    onDropdownPosition: function onDropdownPosition($event) {
      console.log('onDropdownPosition');
      console.log($event);
      this.dropdownPosition = $event;
      $event.top = '90px !important';
    },
    onScrollTo: function onScrollTo(name, target) {
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } });
      } else {
        this.$scrollTo('#' + target);
      }
    },

    onToggle: function onToggle() {
      this.showNav = !this.showNav;
      var className = 'modal-open';
      var root = document.documentElement;
      root.className = '';
      if (this.showNav) {
        root.className += className;
      } else {
        root.className -= className;
      }
      this.$emit('onToggle', this.showNav);
    }
  }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavBarFull_vue__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NavBarFull_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__NavBarFull_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'topsection',
  components: {
    'NavbarFull': __WEBPACK_IMPORTED_MODULE_1__NavBarFull_vue___default.a
  },
  data: function data() {
    return {
      toggle: false,
      navMain: __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._data._navMain,
      navEmail: __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */]._data._navEmail
    };
  },

  computed: {
    navFacebook: function navFacebook() {
      return __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].getSocialNav('facebook');
    }
  },
  watch: {
    toggle: function toggle(val) {
      // console.log('toggle changed to: ' + val)
    }
  },
  methods: {
    onlink: function onlink(el) {
      this.toggle = !this.toggle;
      var root = document.documentElement;
      root.className = '';

      this.$scrollTo(el);
    },

    onScrollTo: function onScrollTo($event, name, target) {
      $event.preventDefault();
      if (this.$route.name !== name) {
        this.$router.replace({ name: name, query: { anchor: target } });
      } else {
        this.toggle = !this.toggle;
        var root = document.documentElement;
        root.className = '';

        // this.$scrollTo(el)
        this.$scrollTo('#' + target, { offset: -50 });
      }
    },
    onPressSubnav: function onPressSubnav($event, navItem) {
      $event.preventDefault();
      navItem.subnavOpen = !navItem.subnavOpen;
    }
  }
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_particles_js__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_particles_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_particles_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'vue-particles',
  props: {
    color: {
      type: String,
      default: '#dedede'
    },
    particleOpacity: {
      type: Number,
      default: 0.7
    },
    particlesNumber: {
      type: Number,
      default: 80
    },
    shapeType: {
      type: String,
      default: 'circle'
    },
    particleSize: {
      type: Number,
      default: 4
    },
    linesColor: {
      type: String,
      default: '#dedede'
    },
    linesWidth: {
      type: Number,
      default: 1
    },
    lineLinked: {
      type: Boolean,
      default: true
    },
    lineOpacity: {
      type: Number,
      default: 0.4
    },
    linesDistance: {
      type: Number,
      default: 150
    },
    moveSpeed: {
      type: Number,
      default: 3
    },
    moveDirection: {
      type: String,
      default: 'none'
    },
    hoverEffect: {
      type: Boolean,
      default: true
    },
    hoverMode: {
      type: String,
      default: 'grab'
    },
    clickEffect: {
      type: Boolean,
      default: true
    },
    clickMode: {
      type: String,
      default: 'push'
    }
  },
  mounted: function mounted() {
    var _this = this;

    // import particle.js only on client-side
    // require('particle.js')
    this.$nextTick(function () {
      _this.initParticleJS(_this.color, _this.particleOpacity, _this.particlesNumber, _this.shapeType, _this.particleSize, _this.linesColor, _this.linesWidth, _this.lineLinked, _this.lineOpacity, _this.linesDistance, _this.moveSpeed, _this.moveDirection, _this.hoverEffect, _this.hoverMode, _this.clickEffect, _this.clickMode);
    });
  },

  methods: {
    initParticleJS: function initParticleJS(color, particleOpacity, particlesNumber, shapeType, particleSize, linesColor, linesWidth, lineLinked, lineOpacity, linesDistance, moveSpeed, moveDirection, hoverEffect, hoverMode, clickEffect, clickMode) {
      particlesJS('particles-js', {
        "particles": {
          "number": {
            "value": particlesNumber,
            "density": {
              "enable": true,
              "value_area": 800
            }
          },
          "color": {
            "value": color
          },
          "shape": {
            // circle, edge, triangle, polygon, star, image
            "type": shapeType,
            "stroke": {
              "width": 0,
              "color": "#192231"
            },
            "polygon": {
              "nb_sides": 5
            }
          },
          "opacity": {
            "value": particleOpacity,
            "random": false,
            "anim": {
              "enable": false,
              "speed": 1,
              "opacity_min": 0.1,
              "sync": false
            }
          },
          "size": {
            "value": particleSize,
            "random": true,
            "anim": {
              "enable": false,
              "speed": 40,
              "size_min": 0.1,
              "sync": false
            }
          },
          "line_linked": {
            "enable": lineLinked,
            "distance": linesDistance,
            "color": linesColor,
            "opacity": lineOpacity,
            "width": linesWidth
          },
          "move": {
            "enable": true,
            "speed": moveSpeed,
            "direction": moveDirection,
            "random": false,
            "straight": false,
            "out_mode": "out",
            "bounce": false,
            "attract": {
              "enable": false,
              "rotateX": 600,
              "rotateY": 1200
            }
          }
        },
        "interactivity": {
          "detect_on": "canvas",
          "events": {
            "onhover": {
              "enable": hoverEffect,
              "mode": hoverMode
            },
            "onclick": {
              "enable": clickEffect,
              "mode": clickMode
            },
            "onresize": {

              "enable": true,
              "density_auto": true,
              "density_area": 400

            }
          },
          "modes": {
            "grab": {
              "distance": 140,
              "line_linked": {
                "opacity": 1
              }
            },
            "bubble": {
              "distance": 400,
              "size": 40,
              "duration": 2,
              "opacity": 8,
              "speed": 3
            },
            "repulse": {
              "distance": 200,
              "duration": 0.4
            },
            "push": {
              "particles_nb": 4
            },
            "remove": {
              "particles_nb": 2
            }
          }
        },
        "retina_detect": true
      });
    }
  }
  /* eslint-disable */

});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['error'],
  computed: {
    infos: function infos() {
      var infos = [];
      for (var i = 0; i < this.error.length; i++) {
        infos.push({
          message: this.error[i]
        });
      }
      return infos;
    }
  }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import _ from 'lodash'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'sidebar',
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.activeLink = to.path;
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.activeLink = to.path;
    next();
  },

  // mounted () {
  //   console.log('Component mounted.')
  //   let match = _.chain(this.$route.matched).sortBy(n => n.path.length).last().value()
  //   this.activeLink = match.path
  // },
  data: function data() {
    return {
      activeLink: null
    };
  }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_Singulo__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slick__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_lightbox__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_lightbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_lightbox__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'landing',
  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_1_vue_slick___default.a,
    Lightbox: __WEBPACK_IMPORTED_MODULE_2_vue_lightbox___default.a
  },
  data: function data() {
    return {
      isDesktop: true,
      slickOptions: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        fade: true,
        speed: 1000,
        swipe: false,
        swipeToSlide: false,
        touchMove: false,
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: false,
        pauseOnFocus: false,
        pauseOnDotsHover: false,
        focusOnSelect: false,
        responsive: [{
          breakpoint: 1008,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        }, {
          // 768 = tablet (not break yet)
          breakpoint: 769,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true
          }
        }, {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true
          }
        }]
      },
      items: [],
      itemsEnded: false,
      error: undefined,
      loading: true,
      scrollPos: 0
    };
  },

  computed: {},
  watch: {},
  created: function created() {
    // console.log('created TopSection.vue')
  },
  mounted: function mounted() {
    // console.log('mounted TopSection.vue')
    // window.GA('send', 'pageview')

    // on event resize
    this.isDesktop = window.innerWidth >= 768;
    window.addEventListener('resize', function (event) {
      // console.log('on viewport change')
      this.isDesktop = event.target.innerWidth >= 768;
    }.bind(this));

    this.refresh();
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this),

    next: function next() {
      if (this.$refs.slick) {
        this.$refs.slick.next();
      }
    },
    prev: function prev() {
      if (this.$refs.slick) {
        this.$refs.slick.prev();
      }
    },
    reInit: function reInit() {
      if (this.$refs.slick) {
        this.$refs.slick.reSlick();
      }
    },

    getItems: function getItems(onComplete) {
      var _this = this;

      this.loading = true;
      this.error = undefined;
      __WEBPACK_IMPORTED_MODULE_0__apis_Singulo__["a" /* default */].carousel().then(function (data) {
        // console.log(data)
        onComplete(data);
        _this.$nextTick(function () {
          this.reInit();
        });
        _this.reInit();
        _this.loading = false;
      }).catch(function (error) {
        _this.error = error;
        _this.error = 'Unable to load, please kindly refresh the page.';
        _this.loading = false;
      });
    },
    refresh: function refresh() {
      var _this2 = this;

      this.getItems(function (items) {
        _this2.items = items;
      });
    },
    renderYtSubscribeButton: function renderYtSubscribeButton(channel) {
      /* global gapi */
      var container = document.getElementById('yt-button-container-render');
      var options = {
        'channel': channel,
        'layout': 'full'
      };
      gapi.ytsubscribe.render(container, options);
    }
  }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Particles__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Particles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Particles__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderProp__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_HeaderProp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_HeaderProp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CarouselSlick__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CarouselSlick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_CarouselSlick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ContentProjectListSection__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ContentProjectListSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_ContentProjectListSection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ContactSection__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ContactSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ContactSection__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'about',
  metaInfo: {
    title: 'about'
  },
  components: {
    VueParticles: __WEBPACK_IMPORTED_MODULE_0__components_Particles___default.a,
    HeaderProp: __WEBPACK_IMPORTED_MODULE_1__components_HeaderProp___default.a,
    CarouselSlick: __WEBPACK_IMPORTED_MODULE_2__components_CarouselSlick___default.a,
    ContactSection: __WEBPACK_IMPORTED_MODULE_4__components_ContactSection___default.a,
    ContentProjectListSection: __WEBPACK_IMPORTED_MODULE_3__components_ContentProjectListSection___default.a
  },
  data: function data() {
    return {
      scrollPos: 0
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {}
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HeaderProp__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_HeaderProp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_HeaderProp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ContactSection__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_ContactSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_ContactSection__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contact',
  metaInfo: {
    title: 'contact'
  },
  components: {
    HeaderProp: __WEBPACK_IMPORTED_MODULE_0__components_HeaderProp___default.a,
    ContactSection: __WEBPACK_IMPORTED_MODULE_1__components_ContactSection___default.a
  },
  data: function data() {
    return {
      scrollPos: 0
    };
  },

  computed: {},
  watch: {},
  created: function created() {},
  mounted: function mounted() {},

  methods: {}
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  metaInfo: {
    title: 'home'
  },
  data: function data() {
    return {};
  },
  created: function created() {},
  mounted: function mounted() {
    this.refresh();
  },

  methods: {
    refresh: function refresh() {}
  }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__controllers_FBControl__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FBLogin__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FBLogin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_FBLogin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TopSection__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_TopSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_TopSection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ContentServiceListSection__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ContentServiceListSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_ContentServiceListSection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ContentProjectListSection__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ContentProjectListSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_ContentProjectListSection__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContentQuoteSection__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContentQuoteSection___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_ContentQuoteSection__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'landing',
  metaInfo: {
    title: 'home'
  },
  components: {
    FbLogin: __WEBPACK_IMPORTED_MODULE_2__components_FBLogin___default.a,
    TopSection: __WEBPACK_IMPORTED_MODULE_3__components_TopSection___default.a,
    ContentServiceListSection: __WEBPACK_IMPORTED_MODULE_4__components_ContentServiceListSection___default.a,
    ContentProjectListSection: __WEBPACK_IMPORTED_MODULE_5__components_ContentProjectListSection___default.a,
    ContentQuoteSection: __WEBPACK_IMPORTED_MODULE_6__components_ContentQuoteSection___default.a
  },
  data: function data() {
    return {
      scrollPos: 0,
      quoteContent: ''
    };
  },

  computed: {
    quoteContentUrl: function quoteContentUrl() {
      return 'https://twitter.com/intent/tweet?text=' + encodeURI(this.quoteContent);
    }
  },
  watch: {
    scrollPos: function scrollPos(val) {
      __WEBPACK_IMPORTED_MODULE_0__controllers_EventBus__["a" /* default */].$emit('scroll-pos-change', { name: 'landing', scrollPos: val });
    }
  },
  created: function created() {},
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__controllers_FBControl__["a" /* default */].logPageView();
    __WEBPACK_IMPORTED_MODULE_1__controllers_FBControl__["a" /* default */].logEvent('debugNoctorus');

    if (this.$route.query && this.$route.query.anchor) {
      setTimeout(function () {
        this.$scrollTo('#' + this.$route.query.anchor);
      }.bind(this), 1000);
    }

    // window.GA('send', 'pageview')
  },

  methods: {
    onScrollTo: function (name) {
      this.$scrollTo('#' + name);
    }.bind(this)
  }
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'notfound',
  metaInfo: {
    title: 'error 404 - not found'
  },
  components: {}
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_lightbox__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_lightbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_lightbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivColumns__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_DivColumns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_DivColumns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HeaderProp__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_HeaderProp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_HeaderProp__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'showcase',
  components: {
    DivColumns: __WEBPACK_IMPORTED_MODULE_1__components_DivColumns___default.a,
    HeaderProp: __WEBPACK_IMPORTED_MODULE_2__components_HeaderProp___default.a,
    Lightbox: __WEBPACK_IMPORTED_MODULE_0_vue_lightbox___default.a
  },
  metaInfo: {
    title: 'showcase'
  },
  data: function data() {
    return {
      projects: [{
        name: 'komaneko',
        title: 'Komaneko',
        link: 'https://itunes.apple.com/us/app/interactive-childrens-book-komaneko-personalized-for/id830219665?mt=8',
        linkLabel: 'iTunes',
        images: []
      }, {
        name: 'duckchat',
        title: 'DuckChat',
        link: 'https://appadvice.com/app/duckchat/1159258005',
        linkLabel: 'AppAdvice',
        images: []
      }, {
        name: 'shortkard',
        title: 'ShortKard',
        linkLabel: 'not deployed',
        images: []
      }, {
        name: 'bloodknight',
        title: 'Relationship Management',
        linkLabel: 'internal use',
        images: []
      }]
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.refresh();
  },

  methods: {
    refresh: function refresh() {
      this.projects.forEach(function (project) {
        for (var i = 1; i <= 7; i++) {
          var imageInfo = {};
          imageInfo.path = './static/showcase-ios/' + project.name + '-' + ('00' + i).slice(-2) + '.png';
          project.images.push(imageInfo);
        }
      });
    }
  }
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_Auth__ = __webpack_require__(28);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      rememberMe: false,
      credentials: {
        email: 'admin@noctorus.net',
        password: '123456'
      },
      isLoading: false,
      error: '',
      errors: []
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.error = '';
      this.errors = [];
      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_1__apis_Auth__["a" /* default */].login(this.credentials).then(function (data) {
        _this.isLoading = false;
        _this.$router.push('/dashboard');
      }).catch(function (error) {
        console.error('login failed', error);
        if (error.error && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(error.error) === 'object') {
          _this.errors = error.error;
        } else if (error.error && typeof error.error === 'string') {
          _this.error = error.error;
        }

        _this.isLoading = false;
      });
    },
    onInput: function onInput(_ref) {
      var name = _ref.name,
          value = _ref.value;

      if (!name || !this.credentials.hasOwnProperty(name)) {
        console.error('invalid update key: ' + name);
        return;
      }
      this.credentials[name] = value;
    }
  },
  created: function created() {
    console.log('created login.vue');
  }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_Auth__ = __webpack_require__(28);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      tableData: [],
      checkedRows: [],
      selected: {},
      isBordered: false,
      isStriped: false,
      isNarrowed: false,
      isCheckable: false,
      isLoading: false,
      hasMobileCards: true,
      isPaginated: true,
      error: undefined
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['evenOrOdd', 'isAuthenticated']),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    test: function test() {}
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['authenticated', 'unauthenticated'])),
  beforeCreate: function beforeCreate() {},
  created: function created() {
    var _this = this;

    console.log('created Users.vue');

    this.isLoading = true;
    __WEBPACK_IMPORTED_MODULE_2__apis_Auth__["a" /* default */].projects(this.credentials).then(function (data) {
      console.log('get projects');
      console.log(data);
      _this.tableData = data.data;
      _this.isLoading = false;
    }).catch(function (error) {
      console.log('invalid get projects', error);
      _this.error = error.error;
      _this.isLoading = false;
    });
  }
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_Auth__ = __webpack_require__(28);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      rememberMe: false,
      credentials: {
        email: '',
        name: '',
        password: '',
        password_confirmation: ''
      },
      isLoading: false,
      error: '',
      errors: []
    };
  },

  methods: {
    submit: function submit() {
      var _this = this;

      this.error = '';
      this.errors = [];
      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_1__apis_Auth__["a" /* default */].register(this.credentials).then(function (data) {
        _this.isLoading = false;
        // data:
        // {
        // "data":
        // {
        // "identifier":1,
        // "name":"admin",
        // "email":"admin@noctorus.net",
        // "isVerified":0,
        // "creationDate":"2017-07-27 14:53:57",
        // "modifiedDate":"","deletedDate":null
        // }
        // }
        // need token?
        _this.$router.push('/login?verify=true');
      }).catch(function (error) {
        console.error('register failed', error);
        if (error.error && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(error.error) === 'object') {
          _this.errors = error.error;
        } else if (error.error && typeof error.error === 'string') {
          _this.error = error.error;
        }

        _this.isLoading = false;
      });
    },
    onInput: function onInput(_ref) {
      var name = _ref.name,
          value = _ref.value;

      if (!name || !this.credentials.hasOwnProperty(name)) {
        console.error('invalid update key: ' + name);
        return;
      }
      this.credentials[name] = value;
    }
  },
  created: function created() {
    console.log('created Register.vue');
  }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_Auth__ = __webpack_require__(28);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      tableData: [],
      checkedRows: [],
      selected: {},
      isBordered: false,
      isStriped: false,
      isNarrowed: false,
      isCheckable: false,
      isLoading: false,
      hasMobileCards: true,
      isPaginated: true,
      error: undefined
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['evenOrOdd', 'isAuthenticated']),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    test: function test() {}
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['authenticated', 'unauthenticated'])),
  beforeCreate: function beforeCreate() {},
  created: function created() {
    var _this = this;

    console.log('created Users.vue');

    this.isLoading = true;
    __WEBPACK_IMPORTED_MODULE_2__apis_Auth__["a" /* default */].users(this.credentials).then(function (data) {
      console.log('get users');
      console.log(data);
      _this.tableData = data.data;
      _this.isLoading = false;
    }).catch(function (error) {
      console.log('invalid get users', error);
      _this.error = error.error;
      _this.isLoading = false;
    });
  }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apis_Auth__ = __webpack_require__(28);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    // token: {
    //   default: '123'
    // }
  },
  data: function data() {
    return {
      rememberMe: false,
      token: '',
      isLoading: true,
      error: '',
      errors: [],
      success: ''
    };
  },

  methods: {
    submit: function submit(token) {
      var _this = this;

      console.log('submitting token... ' + token);

      this.error = '';
      this.errors = [];
      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_1__apis_Auth__["a" /* default */].verify(token).then(function (data) {
        _this.isLoading = false;
        _this.success = 'Verified successfully!';
        // this.$router.push('/home')
      }).catch(function (error) {
        console.error('login failed', error);
        if (error.error && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(error.error) === 'object') {
          _this.errors = error.error;
        } else if (error.error && typeof error.error === 'string') {
          _this.error = error.error + ' Please verify using token or resend verification token again.';
        }

        _this.isLoading = false;
      });
    },
    proceed: function proceed() {
      this.$route.push('/login');
    },
    onInput: function onInput(_ref) {
      var name = _ref.name,
          value = _ref.value;

      if (!name) {
        console.error('invalid update key: ' + name);
        return;
      }
      this.token = value;
    }
  },
  created: function created() {},
  mounted: function mounted() {
    if (!this.$route.query.token || typeof this.$route.query.token !== 'string' || this.$route.query.token.length <= 0) {
      this.isLoading = false;
      return;
    }

    this.token = this.$route.query.token;
    this.submit(this.$route.query.token);
  }
});

/***/ }),
/* 412 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 413 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 414 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(41);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import auth from '@/apis/Auth'
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      error: undefined
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['evenOrOdd', 'isAuthenticated']),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    test: function test() {}
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['authenticated', 'unauthenticated'])),
  beforeCreate: function beforeCreate() {},
  created: function created() {
    console.log('created ApiPlaces.vue');
  }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apis_Auth__ = __webpack_require__(28);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint no-unused-vars: off */

// import auth from '@/apis/Auth'
// import Youtube from 'youtube-api'
// const Youtube = require('youtube-api')
// const fs = require('fs')
// const readJson = require('r-json')
// const Lien = require('lien')
// const Logger = require('bug-killer')
// const opn = require('opn')
// const prettyBytes = require('pretty-bytes')
/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      error: undefined
    };
  },

  methods: {
    test: function test() {}
  },
  beforeCreate: function beforeCreate() {},
  created: function created() {
    console.log('created ApiYoutube.vue');
  },
  mounted: function mounted() {
    console.log('mounted ApiYoutube.vue');
    // Youtube.authenticate({
    //   type: 'key',
    //   key: 'AIzaSyBm43-gK1svcMQ7ULIOPOCOkdv1NX77TxM'
    // })
    // var params = {
    //   term: 'search',
    //   part: 'snippet',
    //   channelId: 'UCLXo7UDZvByw2ixzpQCufnA',
    //   order: 'date',
    //   type: 'video',
    //   videoSyndicated: true,
    //   maxResults: 50,
    //   key: 'AIzaSyBm43-gK1svcMQ7ULIOPOCOkdv1NX77TxM'
    // }
    // apis.get('https://www.googleapis.com/youtube/v3/search?part=snippet&channelId=UCLXo7UDZvByw2ixzpQCufnA&order=date&type=video&videoSyndicated=true&maxResults=50&key=AIzaSyBm43-gK1svcMQ7ULIOPOCOkdv1NX77TxM')
    var params = {
      term: 'playlistItems',
      part: 'snippet',
      playlistId: 'UUy4ssRxw_k0XdiH31OxVHmA',
      maxResults: 12,
      key: 'AIzaSyBm43-gK1svcMQ7ULIOPOCOkdv1NX77TxM'
    };
    __WEBPACK_IMPORTED_MODULE_0__apis_Auth__["a" /* default */].youtube(params.term, params).then(function (data) {
      console.log('Youtube Response');
      console.log(data);
    }).catch(function (error) {
      console.log('Youtube Error');
      console.log(error);
    });
  }
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_Auth__ = __webpack_require__(28);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      error: null,
      images: [],
      segments: []
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['evenOrOdd', 'isAuthenticated']),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    arraySplice: function arraySplice(curr, num) {
      var first = [];
      var second = [];
      if (num > curr.length) {
        num = curr.length;
      }
      for (var i = 0; i < curr.length; i++) {
        if (i < num) {
          first.push(curr[i]);
        } else {
          second.push(curr[i]);
        }
      }
      return {
        curr: curr,
        splice: first,
        remain: second
      };
    },
    updateUI: function updateUI(images) {
      this.segments = [];
      var variation = 14;
      var spliceMap = [3, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5];
      // types of grid:
      //
      // 0,1,2,3,4,5,6
      //
      // 310: ... or .-- or --.  0 // 1 // 2
      // 320: |-- or --|         3 // 4
      //      |--    --|
      // 330: ==. or .==         5 // 6
      //        .    .
      //
      // 7,8,9,10,11,12,13
      //
      // 410: --| or ..|  7 // 8
      //      ..|    __|
      //   or |__ or |..  9 // 10
      //      |..    |__
      // 510: ..| or |..  11 // 12   or .|.  // 13
      //      ..|    |..                .|.
      //
      var failsafe = 100;
      // var selection = 0
      var selection = Math.floor(Math.random() * variation); // first selection
      var selectionSplice = spliceMap[selection];
      console.log('splice=' + selection + ',' + selectionSplice);
      while (images.length > 0 && failsafe > 0) {
        failsafe--;
        if (failsafe < 80) {
          console.error('invalid territory');
        }

        var spliced = this.arraySplice(images, selectionSplice);
        if (spliced.splice.length <= 0) {
          break;
        }

        this.segments.push({
          selection: selection,
          images: spliced.splice
        });
        images = spliced.remain;
        console.log('splice=' + selection + ',' + selectionSplice + ', spliced=' + spliced.splice.length + ' remain=' + spliced.remain.length + ' images=' + images.length);

        selection = Math.floor(Math.random() * variation); // next selection
        // selection++
        // if (selection >= variation) {
        //   selection = 0
        // }
        selectionSplice = spliceMap[selection];
      }

      // check if last splice is valid type or not
      var segmentLast = this.segments[this.segments.length - 1];
      if (segmentLast.images.length !== spliceMap[segmentLast.selection]) {
        var invalid = true;
        for (var i = 0; i < 30; i++) {
          selection = Math.floor(Math.random() * variation); // next selection
          if (segmentLast.images.length === spliceMap[selection]) {
            console.warn('reassign last splice to ' + selection);
            segmentLast.selection = selection;
            invalid = false;
            break;
          }
        }

        if (invalid) {
          console.error('invalid last splice');
          segmentLast.selection = variation;
        }
      }

      if (images.length <= 0) {
        console.log('images spliced correctly');
      }
    },
    refresh: function refresh() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__apis_Auth__["a" /* default */].gallery().then(function (data) {
        console.log('get gallery');
        console.log(data);
        _this.images = data;
        _this.updateUI(data);
      }).catch(function (error) {
        console.log('invalid get gallery', error);
        _this.error = error.error;
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['authenticated', 'unauthenticated'])),
  beforeCreate: function beforeCreate() {},
  created: function created() {
    console.log('created Gallery.vue');
  },
  mounted: function mounted() {
    console.log('mounted Gallery.vue');
    this.$scrollTo(0);
    this.refresh();
  }
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_Auth__ = __webpack_require__(28);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      images: [],
      error: undefined
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['evenOrOdd', 'isAuthenticated']),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    test: function test() {},

    refresh: function refresh() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__apis_Auth__["a" /* default */].gallery().then(function (data) {
        console.log('get gallery');
        console.log(data);
        _this.images = data;
      }).catch(function (error) {
        console.log('invalid get gallery', error);
        _this.images = [];
        _this.error = error.error;
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['authenticated', 'unauthenticated'])),
  beforeCreate: function beforeCreate() {},
  created: function created() {
    console.log('created LayoutMasonry.vue');
  },
  mounted: function mounted() {
    console.log('mounted LayoutMasonry.vue');
    this.$scrollTo(0);
    this.refresh();
  }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__apis_Auth__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MasonryInstagram__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_MasonryInstagram___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_MasonryInstagram__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'layoutmasonryinstagram',
  components: {
    MasonryInstagram: __WEBPACK_IMPORTED_MODULE_3__components_MasonryInstagram___default.a
  },
  data: function data() {
    return {
      images: [],
      error: undefined
    };
  },

  computed: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])(['evenOrOdd', 'isAuthenticated']),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    test: function test() {},

    refresh: function refresh() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__apis_Auth__["a" /* default */].gallery().then(function (data) {
        console.log('get gallery');
        console.log(data);
        _this.images = data;
      }).catch(function (error) {
        console.log('invalid get gallery', error);
        _this.images = [];
        _this.error = error.error;
      });
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(['authenticated', 'unauthenticated'])),
  beforeCreate: function beforeCreate() {},
  created: function created() {
    console.log('created LayoutMasonry.vue');
  },
  mounted: function mounted() {
    console.log('mounted LayoutMasonry.vue');
    this.$scrollTo(0);
    this.refresh();
  }
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_slick__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    Slick: __WEBPACK_IMPORTED_MODULE_0_vue_slick___default.a
  },
  data: function data() {
    return {
      slickOptions: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        dots: true,
        responsive: [{
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: false,
            dots: true
          }
        }, {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true
          }
        }]
      },
      images: [{
        title: 'The best image1',
        src: './src/assets/sports.1.jpg',
        desc: '',
        other: ''
      }, {
        title: 'The best image2',
        src: './src/assets/sports.2.jpg',
        desc: '',
        other: ''
      }, {
        title: 'The best image3',
        src: './src/assets/sports.3.jpg',
        desc: '',
        other: ''
      }, {
        title: 'The best image4',
        src: './src/assets/sports.4.jpg',
        desc: '',
        other: ''
      }]
    };
  },

  methods: {
    next: function next() {
      this.$refs.slick.next();
    },
    prev: function prev() {
      this.$refs.slick.prev();
    },
    reInit: function reInit() {
      this.$refs.slick.reSlick();
    }
  },
  created: function created() {
    console.log('created Blogs.vue');
  }
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      wrapperList: [{
        id: 1,
        class: 'columns',
        componentList: [{
          id: 101,
          class: 'column',
          itemList: [{
            class: 'box',
            content: {
              type: 'title',
              title: 'Title Here',
              subtitle: 'Subtitle Here'
            }
          }]
        }]
      }]
    };
  },

  methods: {
    addComponents: function addComponents(wrapperListObj, count) {
      for (var i = count; i > 0; i--) {
        var columnsObj = {
          class: 'columns',
          componentList: []
        };
        this.addComponent(columnsObj.componentList, 1);
        wrapperListObj.push(columnsObj);
      }
    },
    addComponent: function addComponent(componentListObj, column) {
      for (var i = column; i > 0; i--) {
        var columnObj = {
          class: 'column',
          itemList: []
          // columnsObj.componentList.push(columnObj)
        };componentListObj.push(columnObj);
        for (var j = 1; j > 0; j--) {
          var itemObj = {
            class: 'box',
            content: {
              type: 'title',
              title: 'Title Here',
              subtitle: 'Subtitle Here'
            }
          };
          columnObj.itemList.push(itemObj);
        }
      }
    }
  },
  created: function created() {
    console.log('created Components.vue');
  }
});

/***/ }),
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 675 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 676 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 677 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 680 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 681 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 682 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 684 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 685 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 687 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 688 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 689 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 690 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 691 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 692 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 693 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 694 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 695 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 696 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 697 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 698 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 699 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 700 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 701 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 702 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 703 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 704 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 705 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 706 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 707 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 708 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 709 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 710 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 711 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 712 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 713 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 714 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 715 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 716 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 717 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 718 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 205,
	"./af.js": 205,
	"./ar": 212,
	"./ar-dz": 206,
	"./ar-dz.js": 206,
	"./ar-kw": 207,
	"./ar-kw.js": 207,
	"./ar-ly": 208,
	"./ar-ly.js": 208,
	"./ar-ma": 209,
	"./ar-ma.js": 209,
	"./ar-sa": 210,
	"./ar-sa.js": 210,
	"./ar-tn": 211,
	"./ar-tn.js": 211,
	"./ar.js": 212,
	"./az": 213,
	"./az.js": 213,
	"./be": 214,
	"./be.js": 214,
	"./bg": 215,
	"./bg.js": 215,
	"./bn": 216,
	"./bn.js": 216,
	"./bo": 217,
	"./bo.js": 217,
	"./br": 218,
	"./br.js": 218,
	"./bs": 219,
	"./bs.js": 219,
	"./ca": 220,
	"./ca.js": 220,
	"./cs": 221,
	"./cs.js": 221,
	"./cv": 222,
	"./cv.js": 222,
	"./cy": 223,
	"./cy.js": 223,
	"./da": 224,
	"./da.js": 224,
	"./de": 227,
	"./de-at": 225,
	"./de-at.js": 225,
	"./de-ch": 226,
	"./de-ch.js": 226,
	"./de.js": 227,
	"./dv": 228,
	"./dv.js": 228,
	"./el": 229,
	"./el.js": 229,
	"./en-au": 230,
	"./en-au.js": 230,
	"./en-ca": 231,
	"./en-ca.js": 231,
	"./en-gb": 232,
	"./en-gb.js": 232,
	"./en-ie": 233,
	"./en-ie.js": 233,
	"./en-nz": 234,
	"./en-nz.js": 234,
	"./eo": 235,
	"./eo.js": 235,
	"./es": 237,
	"./es-do": 236,
	"./es-do.js": 236,
	"./es.js": 237,
	"./et": 238,
	"./et.js": 238,
	"./eu": 239,
	"./eu.js": 239,
	"./fa": 240,
	"./fa.js": 240,
	"./fi": 241,
	"./fi.js": 241,
	"./fo": 242,
	"./fo.js": 242,
	"./fr": 245,
	"./fr-ca": 243,
	"./fr-ca.js": 243,
	"./fr-ch": 244,
	"./fr-ch.js": 244,
	"./fr.js": 245,
	"./fy": 246,
	"./fy.js": 246,
	"./gd": 247,
	"./gd.js": 247,
	"./gl": 248,
	"./gl.js": 248,
	"./gom-latn": 249,
	"./gom-latn.js": 249,
	"./he": 250,
	"./he.js": 250,
	"./hi": 251,
	"./hi.js": 251,
	"./hr": 252,
	"./hr.js": 252,
	"./hu": 253,
	"./hu.js": 253,
	"./hy-am": 254,
	"./hy-am.js": 254,
	"./id": 255,
	"./id.js": 255,
	"./is": 256,
	"./is.js": 256,
	"./it": 257,
	"./it.js": 257,
	"./ja": 258,
	"./ja.js": 258,
	"./jv": 259,
	"./jv.js": 259,
	"./ka": 260,
	"./ka.js": 260,
	"./kk": 261,
	"./kk.js": 261,
	"./km": 262,
	"./km.js": 262,
	"./kn": 263,
	"./kn.js": 263,
	"./ko": 264,
	"./ko.js": 264,
	"./ky": 265,
	"./ky.js": 265,
	"./lb": 266,
	"./lb.js": 266,
	"./lo": 267,
	"./lo.js": 267,
	"./lt": 268,
	"./lt.js": 268,
	"./lv": 269,
	"./lv.js": 269,
	"./me": 270,
	"./me.js": 270,
	"./mi": 271,
	"./mi.js": 271,
	"./mk": 272,
	"./mk.js": 272,
	"./ml": 273,
	"./ml.js": 273,
	"./mr": 274,
	"./mr.js": 274,
	"./ms": 276,
	"./ms-my": 275,
	"./ms-my.js": 275,
	"./ms.js": 276,
	"./my": 277,
	"./my.js": 277,
	"./nb": 278,
	"./nb.js": 278,
	"./ne": 279,
	"./ne.js": 279,
	"./nl": 281,
	"./nl-be": 280,
	"./nl-be.js": 280,
	"./nl.js": 281,
	"./nn": 282,
	"./nn.js": 282,
	"./pa-in": 283,
	"./pa-in.js": 283,
	"./pl": 284,
	"./pl.js": 284,
	"./pt": 286,
	"./pt-br": 285,
	"./pt-br.js": 285,
	"./pt.js": 286,
	"./ro": 287,
	"./ro.js": 287,
	"./ru": 288,
	"./ru.js": 288,
	"./sd": 289,
	"./sd.js": 289,
	"./se": 290,
	"./se.js": 290,
	"./si": 291,
	"./si.js": 291,
	"./sk": 292,
	"./sk.js": 292,
	"./sl": 293,
	"./sl.js": 293,
	"./sq": 294,
	"./sq.js": 294,
	"./sr": 296,
	"./sr-cyrl": 295,
	"./sr-cyrl.js": 295,
	"./sr.js": 296,
	"./ss": 297,
	"./ss.js": 297,
	"./sv": 298,
	"./sv.js": 298,
	"./sw": 299,
	"./sw.js": 299,
	"./ta": 300,
	"./ta.js": 300,
	"./te": 301,
	"./te.js": 301,
	"./tet": 302,
	"./tet.js": 302,
	"./th": 303,
	"./th.js": 303,
	"./tl-ph": 304,
	"./tl-ph.js": 304,
	"./tlh": 305,
	"./tlh.js": 305,
	"./tr": 306,
	"./tr.js": 306,
	"./tzl": 307,
	"./tzl.js": 307,
	"./tzm": 309,
	"./tzm-latn": 308,
	"./tzm-latn.js": 308,
	"./tzm.js": 309,
	"./uk": 310,
	"./uk.js": 310,
	"./ur": 311,
	"./ur.js": 311,
	"./uz": 313,
	"./uz-latn": 312,
	"./uz-latn.js": 312,
	"./uz.js": 313,
	"./vi": 314,
	"./vi.js": 314,
	"./x-pseudo": 315,
	"./x-pseudo.js": 315,
	"./yo": 316,
	"./yo.js": 316,
	"./zh-cn": 317,
	"./zh-cn.js": 317,
	"./zh-hk": 318,
	"./zh-hk.js": 318,
	"./zh-tw": 319,
	"./zh-tw.js": 319
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 723;

/***/ }),
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/ads.c22fb88.jpg";

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/chaos.4e7e762.png";

/***/ }),
/* 734 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB3aWR0aD0iMzAwcHgiIGhlaWdodD0iMzAwcHgiIHZpZXdCb3g9IjAgMCAzMDAgMzAwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAzMDAgMzAwIiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxlbGxpcHNlIGZpbGw9IiNBNEM2MzkiIGN4PSIxNTAiIGN5PSIxMTAuNzgzIiByeD0iNTguMDc1IiByeT0iNTMuNjA4Ii8+DQoJPHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTE1MCw1Ny4xNzV2Ny4yYzE0LjIzMS0wLjAwMSwyNy4wMDksNS4zMjQsMzYuMTgyLDEzLjc5MmM0LjU4NSw0LjIzMiw4LjI2LDkuMjM5LDEwLjc4NCwxNC43NDkNCgkJYzIuNTIzLDUuNTEzLDMuOTA3LDExLjUyMSwzLjkwOSwxNy44NjdjLTAuMDAyLDYuMzQ1LTEuMzg2LDEyLjM1NC0zLjkwOSwxNy44NjdjLTMuNzgzLDguMjYyLTEwLjE2OSwxNS40MDMtMTguMzA2LDIwLjQ3Ng0KCQljLTguMTM1LDUuMDczLTE3Ljk4Myw4LjA2NS0yOC42Niw4LjA2NWMtMTQuMjMxLDAuMDAyLTI3LjAwOS01LjMyNC0zNi4xODEtMTMuNzkyYy00LjU4NS00LjIzMy04LjI2LTkuMjQtMTAuNzg0LTE0Ljc0OQ0KCQljLTIuNTI0LTUuNTEzLTMuOTA4LTExLjUyMi0zLjkwOS0xNy44NjdjMC4wMDEtNi4zNDYsMS4zODUtMTIuMzU0LDMuOTA5LTE3Ljg2N2MzLjc4My04LjI2MiwxMC4xNjgtMTUuNDAzLDE4LjMwNS0yMC40NzYNCgkJYzguMTM1LTUuMDcyLDE3Ljk4My04LjA2NCwyOC42Ni04LjA2NFY1Ny4xNzV2LTcuMmMtMTcuODQzLDAuMDAxLTM0LjEwMyw2LjY3Ni00NS45NDksMTcuNjExDQoJCWMtNS45MjQsNS40NjktMTAuNzU0LDEyLjAxMy0xNC4xMDcsMTkuMzMxYy0zLjM1NCw3LjMxNC01LjIyLDE1LjQwOC01LjIxOCwyMy44NjZjLTAuMDAyLDguNDU4LDEuODY1LDE2LjU1MSw1LjIxOCwyMy44NjUNCgkJYzUuMDMzLDEwLjk3OSwxMy4zNzUsMjAuMjA5LDIzLjc3NiwyNi42OTZjMTAuNDAyLDYuNDg5LDIyLjkwMSwxMC4yNDcsMzYuMjgsMTAuMjQ3YzE3Ljg0My0wLjAwMiwzNC4xMDMtNi42NzcsNDUuOTQ5LTE3LjYxMQ0KCQljNS45MjQtNS40NjksMTAuNzU0LTEyLjAxNCwxNC4xMDctMTkuMzMyYzMuMzU0LTcuMzE0LDUuMjIxLTE1LjQwOCw1LjIxOS0yMy44NjZjMC4wMDItOC40NTgtMS44NjQtMTYuNTUyLTUuMjE5LTIzLjg2Ng0KCQljLTUuMDMzLTEwLjk3OS0xMy4zNzUtMjAuMjA4LTIzLjc3Ni0yNi42OTZjLTEwLjQwMi02LjQ4OC0yMi45MDEtMTAuMjQ3LTM2LjI4LTEwLjI0NlY1Ny4xNzV6Ii8+DQoJPHBhdGggZmlsbD0iI0E0QzYzOSIgZD0iTTEwNS45NjYsOTcuMzhoODguMDY4YzcuNzU1LDAsMTQuMDQxLDYuMjg2LDE0LjA0MSwxNC4wNHY4OC4wN2MwLDcuNzU1LTYuMjg2LDE0LjAzOS0xNC4wNDEsMTQuMDM5DQoJCWgtODguMDY4Yy03Ljc1NSwwLTE0LjA0LTYuMjg0LTE0LjA0LTE0LjAzOXYtODguMDdDOTEuOTI2LDEwMy42NjYsOTguMjExLDk3LjM4LDEwNS45NjYsOTcuMzh6Ii8+DQoJPHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTEwNS45NjYsOTcuMzh2Ny4yaDg4LjA2OGMwLjk2NSwwLjAwMSwxLjg0NywwLjE5MSwyLjY2MSwwLjUzNWMxLjIxOCwwLjUxNCwyLjI3NywxLjM5MSwzLjAxNiwyLjQ4Ng0KCQljMC43MzksMS4xMDEsMS4xNjEsMi4zNzgsMS4xNjQsMy44MTl2ODguMDdjLTAuMDAxLDAuOTY1LTAuMTkxLDEuODQ2LTAuNTM0LDIuNjZjLTAuNTE0LDEuMjE4LTEuMzkxLDIuMjc2LTIuNDg2LDMuMDE1DQoJCWMtMS4xMDEsMC43MzgtMi4zNzgsMS4xNjEtMy44MiwxLjE2NGgtODguMDY4Yy0wLjk2NS0wLjAwMS0xLjg0Ny0wLjE5MS0yLjY2MS0wLjUzNGMtMS4yMTgtMC41MTQtMi4yNzctMS4zOTEtMy4wMTUtMi40ODUNCgkJYy0wLjczOC0xLjEtMS4xNjEtMi4zNzctMS4xNjQtMy44MTl2LTg4LjA3YzAuMDAxLTAuOTY0LDAuMTkxLTEuODQ2LDAuNTM0LTIuNjZjMC41MTQtMS4yMTgsMS4zOTEtMi4yNzcsMi40ODYtMy4wMTYNCgkJYzEuMTAxLTAuNzM4LDIuMzc4LTEuMTYxLDMuODItMS4xNjRWOTcuMzh2LTcuMmMtMi45MTMtMC4wMDEtNS43MjUsMC41OTUtOC4yNywxLjY3MmMtMy44MjEsMS42MTgtNy4wNSw0LjMwMS05LjMzOCw3LjY4OA0KCQljLTIuMjksMy4zODEtMy42MzUsNy41MDYtMy42MzIsMTEuODh2ODguMDdjLTAuMDAxLDIuOTEzLDAuNTk0LDUuNzI1LDEuNjcyLDguMjdjMS42MTgsMy44MjEsNC4zMDEsNy4wNSw3LjY4OCw5LjMzOQ0KCQljMy4zODEsMi4yODksNy41MDYsMy42MzQsMTEuODgsMy42MzFoODguMDY4YzIuOTEyLDAuMDAxLDUuNzI1LTAuNTk1LDguMjctMS42NzJjMy44MjEtMS42MTcsNy4wNS00LjMwMSw5LjM0LTcuNjg3DQoJCWMyLjI4OS0zLjM4MSwzLjYzNS03LjUwNywzLjYzMi0xMS44ODF2LTg4LjA3YzAuMDAxLTIuOTEzLTAuNTk1LTUuNzI1LTEuNjczLTguMjdjLTEuNjE3LTMuODIxLTQuMzAxLTcuMDQ5LTcuNjg4LTkuMzM4DQoJCWMtMy4zODEtMi4yODktNy41MDctMy42MzUtMTEuODgxLTMuNjMyaC04OC4wNjhWOTcuMzh6Ii8+DQoJPHBhdGggZmlsbD0iI0QxRDNENCIgZD0iTTExMS45NDksNDIuOTU3TDExMS45NDksNDIuOTU3Yy0yLjAwNCwxLjExLTIuNzI4LDMuNjM2LTEuNjE3LDUuNjM5bDIyLjU4Nyw0MC43NDcNCgkJYzEuMTEsMi4wMDMsMy42MzUsMi43MjgsNS42MzksMS42MTdjMi4wMDQtMS4xMTEsMi43MjgtMy42MzYsMS42MTctNS42MzlsLTIyLjU4Ni00MC43NDcNCgkJQzExNi40NzksNDIuNTcsMTEzLjk1Myw0MS44NDYsMTExLjk0OSw0Mi45NTd6Ii8+DQoJPHBhdGggZmlsbD0iI0QxRDNENCIgZD0iTTIyNS45NDQsMTEwLjc4MkwyMjUuOTQ0LDExMC43ODJjLTguNDYsMC0xNS4zMTYsNi44NTctMTUuMzE2LDE1LjMxNnY1NC4yNDUNCgkJYzAsOC40Niw2Ljg1NiwxNS4zMTcsMTUuMzE2LDE1LjMxN2M4LjQ1OSwwLDE1LjMxNS02Ljg1NywxNS4zMTUtMTUuMzE3di01NC4yNDVDMjQxLjI2LDExNy42NCwyMzQuNDAzLDExMC43ODIsMjI1Ljk0NCwxMTAuNzgyeiINCgkJLz4NCgk8cGF0aCBmaWxsPSIjRDFEM0Q0IiBkPSJNMTcxLjY5OCwxNzIuNjg3TDE3MS42OTgsMTcyLjY4N2MtOC40NTksMC0xNS4zMTYsNi44NTYtMTUuMzE2LDE1LjMxNnY1NC4yNDYNCgkJYzAsOC40NTksNi44NTcsMTUuMzE1LDE1LjMxNiwxNS4zMTVzMTUuMzE2LTYuODU2LDE1LjMxNi0xNS4zMTV2LTU0LjI0NkMxODcuMDE1LDE3OS41NDMsMTgwLjE1NywxNzIuNjg3LDE3MS42OTgsMTcyLjY4N3oiLz4NCgk8cGF0aCBmaWxsPSIjRDFEM0Q0IiBkPSJNMTg4LjA1MSw0Mi45NTdMMTg4LjA1MSw0Mi45NTdjMi4wMDQsMS4xMSwyLjcyOCwzLjYzNiwxLjYxNyw1LjYzOWwtMjIuNTg2LDQwLjc0Nw0KCQljLTEuMTExLDIuMDAzLTMuNjM2LDIuNzI4LTUuNjQsMS42MTdjLTIuMDA0LTEuMTExLTIuNzI4LTMuNjM2LTEuNjE3LTUuNjM5bDIyLjU4Ny00MC43NDcNCgkJQzE4My41MjEsNDIuNTcsMTg2LjA0Nyw0MS44NDYsMTg4LjA1MSw0Mi45NTd6Ii8+DQoJPHBhdGggZmlsbD0iI0QxRDNENCIgZD0iTTc0LjA1NywxMTAuNzgyTDc0LjA1NywxMTAuNzgyYzguNDU5LDAsMTUuMzE2LDYuODU3LDE1LjMxNiwxNS4zMTZ2NTQuMjQ1DQoJCWMwLDguNDYtNi44NTcsMTUuMzE3LTE1LjMxNiwxNS4zMTdzLTE1LjMxNi02Ljg1Ny0xNS4zMTYtMTUuMzE3di01NC4yNDVDNTguNzQsMTE3LjY0LDY1LjU5OCwxMTAuNzgyLDc0LjA1NywxMTAuNzgyeiIvPg0KCTxwYXRoIGZpbGw9IiNEMUQzRDQiIGQ9Ik0xMjguMzAyLDE3Mi42ODdMMTI4LjMwMiwxNzIuNjg3YzguNDU5LDAsMTUuMzE2LDYuODU2LDE1LjMxNiwxNS4zMTZ2NTQuMjQ2DQoJCWMwLDguNDU5LTYuODU3LDE1LjMxNS0xNS4zMTYsMTUuMzE1cy0xNS4zMTYtNi44NTYtMTUuMzE2LTE1LjMxNXYtNTQuMjQ2QzExMi45ODUsMTc5LjU0MywxMTkuODQzLDE3Mi42ODcsMTI4LjMwMiwxNzIuNjg3eiIvPg0KCTxlbGxpcHNlIGZpbGw9IiNEMUQzRDQiIGN4PSIxNTAiIGN5PSIxMTAuNzgzIiByeD0iNTguMDc1IiByeT0iNTMuNjA4Ii8+DQoJPHBhdGggZmlsbD0iI0QxRDNENCIgZD0iTTEwNS45NjYsOTcuMzhoODguMDY4YzcuNzU1LDAsMTQuMDQxLDYuMjg2LDE0LjA0MSwxNC4wNHY4OC4wN2MwLDcuNzU1LTYuMjg2LDE0LjAzOS0xNC4wNDEsMTQuMDM5DQoJCWgtODguMDY4Yy03Ljc1NSwwLTE0LjA0LTYuMjg0LTE0LjA0LTE0LjAzOXYtODguMDdDOTEuOTI2LDEwMy42NjYsOTguMjExLDk3LjM4LDEwNS45NjYsOTcuMzh6Ii8+DQoJPGxpbmUgZmlsbD0iI0ZGRkZGRiIgeDE9Ijg5LjM3MyIgeTE9IjExMy4wMTYiIHgyPSIyMTAuNjI4IiB5Mj0iMTEzLjAxNiIvPg0KCTxwb2x5bGluZSBmaWxsPSIjRkZGRkZGIiBwb2ludHM9Ijg5LjM3MywxMTYuNjE2IDIxMC42MjgsMTE2LjYxNiAyMTAuNjI4LDEwOS40MTYgODkuMzczLDEwOS40MTYgCSIvPg0KCTxjaXJjbGUgZmlsbD0iI0ZGRkZGRiIgY3g9IjEyMy4xOTYiIGN5PSI4NC42MTYiIHI9IjIuNTUyIi8+DQoJPHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTEyMy4xOTYsODIuMDY0djMuNnYtMS4wNDdsLTAuNzQxLDAuNzRjMC4xNzgsMC4xODQsMC40NjMsMC4zMDksMC43NDEsMC4zMDd2LTEuMDQ3bC0wLjc0MSwwLjc0DQoJCWwwLjc0MS0wLjc0aC0xLjA0N2MtMC4wMDEsMC4yNzgsMC4xMjMsMC41NjIsMC4zMDcsMC43NGwwLjc0MS0wLjc0aC0xLjA0N2gxLjA0OGwtMC43NDEtMC43NDENCgkJYy0wLjE4NCwwLjE3OS0wLjMwOSwwLjQ2My0wLjMwNywwLjc0MWgxLjA0OGwtMC43NDEtMC43NDFsMC43NCwwLjc0MXYtMS4wNDdjLTAuMjc3LTAuMDAyLTAuNTYyLDAuMTIzLTAuNzQsMC4zMDdsMC43NCwwLjc0MQ0KCQl2LTEuMDQ3djEuMDQ3bDAuNzQtMC43NDFjLTAuMTc4LTAuMTg0LTAuNDYzLTAuMzA5LTAuNzQtMC4zMDd2MS4wNDdsMC43NC0wLjc0MWwtMC43NDEsMC43NDFoMS4wNDgNCgkJYzAuMDAyLTAuMjc4LTAuMTIzLTAuNTYyLTAuMzA3LTAuNzQxbC0wLjc0MSwwLjc0MWgxLjA0OGgtMS4wNDdsMC43NDEsMC43NGMwLjE4NC0wLjE3OCwwLjMwOC0wLjQ2MiwwLjMwNy0wLjc0aC0xLjA0N2wwLjc0MSwwLjc0DQoJCWwtMC43NDEtMC43NHYxLjA0N2MwLjI3NywwLjAwMiwwLjU2Mi0wLjEyMywwLjc0MS0wLjMwN2wtMC43NDEtMC43NHYxLjA0N1Y4Mi4wNjR2LTMuNmMtMS42ODgtMC4wMDItMy4yNDksMC42OTQtNC4zNTEsMS44MDINCgkJYy0xLjEwNywxLjEwMy0xLjgwMywyLjY2My0xLjgwMiw0LjM1MWMtMC4wMDIsMS42ODgsMC42OTQsMy4yNDksMS44MDIsNC4zNTFjMS4xMDIsMS4xMDgsMi42NjMsMS44MDQsNC4zNTEsMS44MDINCgkJYzEuNjg4LDAuMDAyLDMuMjQ5LTAuNjk0LDQuMzUxLTEuODAyYzEuMTA4LTEuMTAyLDEuODA0LTIuNjYzLDEuODAyLTQuMzUxYzAuMDAxLTEuNjg4LTAuNjk0LTMuMjQ4LTEuODAyLTQuMzUxDQoJCWMtMS4xMDItMS4xMDgtMi42NjQtMS44MDQtNC4zNTEtMS44MDJWODIuMDY0eiIvPg0KCTxjaXJjbGUgZmlsbD0iI0ZGRkZGRiIgY3g9IjE3Ni44MDQiIGN5PSI4NC42MTYiIHI9IjIuNTUyIi8+DQoJPHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTE3Ni44MDQsODIuMDY0djMuNnYtMS4wNDdsLTAuNzQsMC43NGMwLjE3OCwwLjE4NCwwLjQ2MywwLjMwOSwwLjc0LDAuMzA3di0xLjA0N2wtMC43NCwwLjc0bDAuNzQtMC43NA0KCQloLTEuMDQ3Yy0wLjAwMiwwLjI3OCwwLjEyMiwwLjU2MiwwLjMwNywwLjc0bDAuNzQtMC43NGgtMS4wNDdoMS4wNDhsLTAuNzQxLTAuNzQxYy0wLjE4NSwwLjE3OS0wLjMwOSwwLjQ2My0wLjMwNywwLjc0MWgxLjA0OA0KCQlsLTAuNzQxLTAuNzQxbDAuNzQsMC43NDF2LTEuMDQ3Yy0wLjI3Ny0wLjAwMi0wLjU2MiwwLjEyMy0wLjc0LDAuMzA3bDAuNzQsMC43NDF2LTEuMDQ3djEuMDQ3bDAuNzQtMC43NDENCgkJYy0wLjE3OS0wLjE4NC0wLjQ2My0wLjMwOS0wLjc0LTAuMzA3djEuMDQ3bDAuNzQtMC43NDFsLTAuNzQxLDAuNzQxaDEuMDQ4YzAuMDAyLTAuMjc4LTAuMTIyLTAuNTYyLTAuMzA3LTAuNzQxbC0wLjc0MSwwLjc0MQ0KCQloMS4wNDhoLTEuMDQ3bDAuNzQsMC43NGMwLjE4NS0wLjE3OCwwLjMwOS0wLjQ2MiwwLjMwNy0wLjc0aC0xLjA0N2wwLjc0LDAuNzRsLTAuNzQtMC43NHYxLjA0Nw0KCQljMC4yNzcsMC4wMDIsMC41NjItMC4xMjMsMC43NC0wLjMwN2wtMC43NC0wLjc0djEuMDQ3VjgyLjA2NHYtMy42Yy0xLjY4OC0wLjAwMi0zLjI0OSwwLjY5NC00LjM1MSwxLjgwMg0KCQljLTEuMTA4LDEuMTAzLTEuODA0LDIuNjYzLTEuODAyLDQuMzUxYy0wLjAwMiwxLjY4OCwwLjY5MywzLjI0OSwxLjgwMiw0LjM1MWMxLjEwMywxLjEwOCwyLjY2MywxLjgwNCw0LjM1MSwxLjgwMg0KCQljMS42ODgsMC4wMDIsMy4yNDgtMC42OTQsNC4zNTEtMS44MDJjMS4xMDgtMS4xMDIsMS44MDQtMi42NjMsMS44MDItNC4zNTFjMC4wMDItMS42ODgtMC42OTMtMy4yNDgtMS44MDItNC4zNTENCgkJYy0xLjEwMi0xLjEwOC0yLjY2My0xLjgwNC00LjM1MS0xLjgwMlY4Mi4wNjR6Ii8+DQo8L2c+DQo8L3N2Zz4NCg=="

/***/ }),
/* 735 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAACXBIWXMAACxKAAAsSgF3enRNAAAFBElEQVR42u2d7XGkOBCGX7vm/3ARLBvBchGYDJYMbi6CJQQyWC6Cm80AR7A4AxzB4QiOiUD345oqViOhbxAMXaWyzdgIPXRLrVZLfmKM4RB7eT4QHABXlVPEz5ZPvk+pdAAGujbQzwdAAAWAjKBlAM4Gf/tBIFsqi0J9WmkQSQhaAeCr53t/EMgrfd0VwBRAReDOC9T3AaAmmMOWAY7g/tD8/XdqcDujwRnd95PG/W4EsvYOkjEWsiSMsZqppWGMlYyxzLKOgurpFfX09Lve2hgSXq5oUMcYuxAAn/VmBHOYqbv1VW8oeLXi4fPAmj+Wy8xLHHxoYwiT7WY0bilwfClnNLKKBWAmedsDNQArl4T6WpFc1waYSd5wxxhLI4DHm/UgGciSNQDK4F0DDBA+X3gngbgowEQCr4oUnE5/fV0KoOwBLhuAp2pDtQTAq6DickPwVBDzkAALnyNZJBB7gfeg7MNt5sIJgJ4LBrzT3HTLktHce9quVwp8eI1I11wlN1UlG5EOQMld+8oFdp2DCbnAdIsNm66oNIIAhLc+sBXMa7GzkgpcM6lnYWLCOYAX7tplh+tEPXVTU6l89IF8//CDKtuj1NS3j/JJpiy6AFPB2kW149XKQaCFpQvAywNpn0wLv5AiWS1r8gAbDZ+qjtAtMdXChlvHKe/uqRm50B7WZ6Iza4jr7KgQhOeMR+HcQvvOkZhhITI7A2lUZmwDULVYfQXwZwTwbvTsrn11M8cjBMAR4tPKJfGU5tEKLEwbYCIIGgx4LOlcAGaKmx0ANRxofprziPI++f58ALTzCYVcTPMDTQBm1If6ljYSgL0NQF25APg70L1/rBAF6iDJY3zeGDzQ1KqOxbafA72tW2AH+RoLwFMggHlALSlXcKdSXwBTQ4h7kVQ2qKhMeLAEuDdJZM71s4YmHQD/j8JM+2DtQaRXTO0eQWanszoAb5I3cQDUHERazoksoA6qJnALp4cWk+0O+Wy3pplfPJXaIU86FukMkj/5pKPUNKTPzz1VeTDlBkz9i+Z0MMOvG3k+7sYFy7eQW+QOxiRXyxzI2ja9rQbwzXBCH7MjrRPREaXx/c73gboAUwD/cNc+Y9/xQT4oIsyB1A0m9ADeuGvVzt2XSmCFd2KSoZoD+PkgWlgC+M7NPhLXcFYr0MJ6h/ASXe0zGYUfPUM18Zml39hks2+kFKYK4itL/20H8b+UXBSjdtmE9AfBPPcFEYXZLfu9Bve7D9SzFc87lS4bNd3Wtm9/9L1yMkWo2UK7NVNJMuUWIMo2YBttefVx7Iloi5TU8Yyoz2sFUaN3GjS0M9B8rAuPK3DTyPU54lE5Jy/CGZ4vgPdRWvF6SgxaV9N0lE9BfrOB5zoKzyWidxGek9CHSEQ/eTQL03jbElKQz/oi+OxGn7n5r57ecGez2zvg6FpqnJqU+ajPxyicAPjXcQQeDxOzPVRxPHuwkGjb9Nkqn1GkkyczsTHfZNLo6XF4N4LYTwailgM9zl1TBbCp/EXwoju9rTFwohP6vFlo8WigEziCRYtcTZg3XwD4jXvL+UTTllrufKXgQPAAx8mz+b5O+qPcwLxGR3Yw/JupHzeeo9pgQXHVwNaywdOGN1R6LjaXcn2eqJ/t13bYXQCmuF/qVMmNYI2asvldTy4mnBho2QhsdzudXE14EERhpmc6t9i5+BiFi0lA4eH20q11EPdu5PhnBI7yH0pAAUCtFK76AAAAAElFTkSuQmCC"

/***/ }),
/* 736 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgYmFzZVByb2ZpbGU9InRpbnkiIGhlaWdodD0iNTEycHgiIGlkPSJMYXllcl8xIiB2ZXJzaW9uPSIxLjIiIHZpZXdCb3g9IjAgMCA1MTIgNTEyIiB3aWR0aD0iNTEycHgiIHhtbDpzcGFjZT0icHJlc2VydmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxnPjxwYXRoIGQ9Ik0yOTcuMDM2LDIwNS41NzhsLTM2LjMzNCwzMy44MDlsLTMzLjcxNi02OC4wMDVsMTcuNDQ2LTM5LjEwOGM0LjQxNi03Ljg0LDExLjYyMS03Ljg1NSwxNi4wMzcsMCAgIEwyOTcuMDM2LDIwNS41Nzh6IiBmaWxsPSIjRkZBMDAwIi8+PHBvbHlnb24gZmlsbD0iI0Y1N0YxNyIgcG9pbnRzPSIyNjAuNzAyLDIzOS4zODYgMTI0LjkyNCwzNjUuNjk3IDIyNi45ODYsMTcxLjM4MSAgIi8+PHBhdGggZD0iTTMzNi43NzYsMTUzLjkwMWM2LjQ5MS02LjIzOSwxMy4yMDItNC4xMTEsMTQuOTEyLDQuNzI5bDM1LjM0MiwyMDUuMzc1TDI2OS44NzMsNDM0LjIyICAgYy00LjEsMi4yNjQtMTQuOTU3LDMuMjQ2LTE0Ljk1NywzLjI0NnMtOS45MS0xLjE4NS0xMy42ODctMy4yODFMMTI0LjkyLDM2NS42OUwzMzYuNzc2LDE1My45MDF6IiBmaWxsPSIjRkZDQTI4Ii8+PHBhdGggZD0iTTIyNi45ODYsMTcxLjM4MUwxMjQuOTI0LDM2NS42OTdsNDUuNDYtMjgzLjk5OGMxLjY3NC04Ljg0Nyw2LjcxLTkuNjk5LDExLjIwMy0xLjg5TDIyNi45ODYsMTcxLjM4MXoiIGZpbGw9IiNGRkEwMDAiLz48L2c+PC9zdmc+"

/***/ }),
/* 737 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDIwMDEwOTA0Ly9FTiIKICJodHRwOi8vd3d3LnczLm9yZy9UUi8yMDAxL1JFQy1TVkctMjAwMTA5MDQvRFREL3N2ZzEwLmR0ZCI+CjxzdmcgdmVyc2lvbj0iMS4wIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiB3aWR0aD0iMzEwLjAwMDAwMHB0IiBoZWlnaHQ9IjMxMC4wMDAwMDBwdCIgdmlld0JveD0iMCAwIDMxMC4wMDAwMDAgMzEwLjAwMDAwMCIKIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiPgo8bWV0YWRhdGE+CkNyZWF0ZWQgYnkgcG90cmFjZSAxLjE1LCB3cml0dGVuIGJ5IFBldGVyIFNlbGluZ2VyIDIwMDEtMjAxNwo8L21ldGFkYXRhPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwzMTAuMDAwMDAwKSBzY2FsZSgwLjEwMDAwMCwtMC4xMDAwMDApIgpmaWxsPSIjRDFEM0Q0IiBzdHJva2U9Im5vbmUiPgo8cGF0aCBkPSJNMTM1MCAzMDMxIGMtMTQyIC00NCAtMzQ5IC0yMTggLTQ5OSAtNDIwIC0yOTMgLTM5NiAtNDU1IC04NjkgLTQzNwotMTI4MSA4IC0yMDIgNDkgLTM1NSAxNDQgLTU0NSAxMzYgLTI3NCA0MDggLTU1MSA2NTUgLTY2OSAxNDEgLTY3IDEzNCAtNjkKMTQxIDI4IDMgNDQgMTAgMzI0IDE2IDYyMSAyNyAxMzczIDQ0IDE3NjAgODIgMTkxMyA2IDIzIDE0IDQyIDE5IDQyIDEyIDAgMzYKLTkxIDQ5IC0xODMgNSAtNDMgMTAgLTE3NyAxMCAtMjk4IDAgLTEyMCAzIC0yMTkgNyAtMjE5IDMgMCA1NyA1MCAxMTkgMTEwIDY5CjY4IDEyMCAxMTAgMTMzIDExMCAxOCAwIDE5IC0zIDEwIC0yNyAtMTIgLTMxIC03OSAtMTMyIC0xOTEgLTI4NSBsLTc4IC0xMDggMQotMzEyIGMxIC0xNzIgNCAtMzc0IDggLTQ0OSBsNiAtMTM3IDExMCAxMjYgYzE0MCAxNjAgMzUxIDM3MSAzOTUgMzk2IGwzMyAxOQotNiAtMzIgYy0yMCAtOTggLTk1IC0yMDcgLTM3NCAtNTQzIGwtMTYzIC0xOTYgMCAtMzExIGMwIC0xODMgNCAtMzExIDkgLTMxMQoyOCAwIDE5MyA2NCAyNjggMTA1IDEzOCA3MyAyMzggMTUwIDM4MyAyOTUgMTU3IDE1NyAyNDQgMjc0IDMzNCA0NTIgMjA1IDQwMAoyMTAgODAzIDE2IDExOTAgLTE3OCAzNTYgLTU0NiA3MjEgLTg3OCA4NjkgLTExNyA1MyAtMjQ2IDczIC0zMjIgNTB6Ii8+CjwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 739 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 740 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNi4wLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DQo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4Ig0KCSB3aWR0aD0iMzAwcHgiIGhlaWdodD0iMzAwcHgiIHZpZXdCb3g9IjAgMCAzMDAgMzAwIiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCAzMDAgMzAwIiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxnIGlkPSJnMTIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE3OC4wNjI2LDIzNS4wMDg2KSI+DQoJCTxwYXRoIGlkPSJwYXRoMTQiIGZpbGw9IiNGMUYyRjIiIGQ9Ik0tNS40OTMtMTY5LjY0MmwtMjIuNTY5LDM5LjA5MWwtMjIuNTY5LTM5LjA5MWgtNzUuMTU5TC0yOC4wNjMtMC4zNzVsOTcuNzI5LTE2OS4yNjhILTUuNDkzeg0KCQkJIi8+DQoJPC9nPg0KCTxnIGlkPSJnMTYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE3OC4wNjI2LDIzNS4wMDg2KSI+DQoJCTxwYXRoIGlkPSJwYXRoMTgiIGZpbGw9IiNEMUQzRDQiIGQ9Ik0tNS40OTMtMTY5LjY0MmwtMjIuNTY5LDM5LjA5MWwtMjIuNTY5LTM5LjA5MWgtMzYuMDY3bDU4LjYzNywxMDEuNTYxbDU4LjYzOC0xMDEuNTYxSC01LjQ5Mw0KCQkJeiIvPg0KCTwvZz4NCjwvZz4NCjxnPg0KCTxnPg0KCQk8ZGVmcz4NCgkJCTxyZWN0IGlkPSJTVkdJRF81XyIgeD0iLTM0Mi4wNDEiIHk9Ii0yNi45IiB3aWR0aD0iMzU1LjgwMSIgaGVpZ2h0PSIzNTUuODAxIi8+DQoJCTwvZGVmcz4NCgkJPGNsaXBQYXRoIGlkPSJTVkdJRF8xXyI+DQoJCQk8dXNlIHhsaW5rOmhyZWY9IiNTVkdJRF81XyIgIG92ZXJmbG93PSJ2aXNpYmxlIi8+DQoJCTwvY2xpcFBhdGg+DQoJCTxnIGNsaXAtcGF0aD0idXJsKCNTVkdJRF8xXykiPg0KCQkJPGRlZnM+DQoJCQkJPHJlY3QgaWQ9IlNWR0lEXzdfIiB4PSItMzQyLjA0MSIgeT0iLTI2LjkiIHdpZHRoPSIzNTUuODAxIiBoZWlnaHQ9IjM1NS44MDEiLz4NCgkJCTwvZGVmcz4NCgkJCTxjbGlwUGF0aCBpZD0iU1ZHSURfMl8iPg0KCQkJCTx1c2UgeGxpbms6aHJlZj0iI1NWR0lEXzdfIiAgb3ZlcmZsb3c9InZpc2libGUiLz4NCgkJCTwvY2xpcFBhdGg+DQoJCTwvZz4NCgk8L2c+DQo8L2c+DQo8L3N2Zz4NCg=="

/***/ }),
/* 741 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDIwMDEwOTA0Ly9FTiIKICJodHRwOi8vd3d3LnczLm9yZy9UUi8yMDAxL1JFQy1TVkctMjAwMTA5MDQvRFREL3N2ZzEwLmR0ZCI+CjxzdmcgdmVyc2lvbj0iMS4wIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiB3aWR0aD0iNjAwLjAwMDAwMHB0IiBoZWlnaHQ9IjYwMC4wMDAwMDBwdCIgdmlld0JveD0iMCAwIDYwMC4wMDAwMDAgNjAwLjAwMDAwMCIKIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIG1lZXQiPgo8bWV0YWRhdGE+CkNyZWF0ZWQgYnkgcG90cmFjZSAxLjE1LCB3cml0dGVuIGJ5IFBldGVyIFNlbGluZ2VyIDIwMDEtMjAxNwo8L21ldGFkYXRhPgo8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCw2MDAuMDAwMDAwKSBzY2FsZSgwLjEwMDAwMCwtMC4xMDAwMDApIgpmaWxsPSIjMjgzMDQ0IiBzdHJva2U9Im5vbmUiPgo8cGF0aCBkPSJNMTkxNSA0MDgwIGwtMTA4MCAtMTA4MCA1NjMgLTU2MiA1NjIgLTU2MyA1MjAgNTIwIDUyMCA1MjAgNTE4IC01MTgKNTE3IC01MTcgNTY1IDU1OSA1NjUgNTU5IC0xMDgwIDEwODEgYy01OTQgNTk1IC0xMDgyIDEwODEgLTEwODUgMTA4MSAtMyAwCi00OTEgLTQ4NiAtMTA4NSAtMTA4MHogbTIwMjMgLTE0MyBsOTMzIC05MzMgLTQxNyAtNDE4IC00MTggLTQxNyAtNTE4IDUxOApjLTI4NCAyODQgLTUyMSA1MTQgLTUyNSA1MTAgLTQgLTQgLTIzOSAtMjM4IC01MjEgLTUyMCBsLTUxMiAtNTEyIC00MTggNDE4Ci00MTcgNDE3IDkzNSA5MzUgYzUxNCA1MTQgOTM3IDkzNSA5NDAgOTM1IDMgMCA0MjUgLTQyMCA5MzggLTkzM3oiLz4KPHBhdGggZD0iTTI1NTAgMjE3NSBsLTQ0NSAtNDQ1IDQ0OCAtNDQ4IDQ0NyAtNDQ3IDQ0NyA0NDcgNDQ4IDQ0OCAtNDQ1IDQ0NQpjLTI0NSAyNDUgLTQ0NyA0NDUgLTQ1MCA0NDUgLTMgMCAtMjA1IC0yMDAgLTQ1MCAtNDQ1eiBtNzU1IC0xNDUgbDI5OSAtMzAwCi0zMDIgLTMwMiAtMzAyIC0zMDMgLTMwMiAzMDMgLTMwMyAzMDIgMzAwIDMwMCBjMTY1IDE2NSAzMDIgMzAwIDMwNSAzMDAgMyAwCjE0MCAtMTM1IDMwNSAtMzAweiIvPgo8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/project1.ccbfe92.jpg";

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/project2.4fb31a8.jpg";

/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/project3.f2840da.jpg";

/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/project4.d376984.jpg";

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/project5.4c375df.jpg";

/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/project_logo_adamlobo.bb108a8.svg";

/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/project_logo_icmarc.ca46eae.png";

/***/ }),
/* 749 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/project_logo_lastingimpressions.37ccec9.svg";

/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/project_logo_vr.04ea41f.png";

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/showcase_doritos.967756c.png";

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/showcase_gap.70ee358.png";

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/showcase_keyg.2fc678b.png";

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/showcase_komaneko.cdfbf15.png";

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/showcase_lastingimpressions.d4b7573.png";

/***/ }),
/* 757 */,
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(712)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(836),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(706)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(829),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(688)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(810),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(713)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(837),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(823),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(693)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(815),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(692)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(814),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(716)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(840),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ddf21b4e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(708)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(831),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(682)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(804),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(689)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(811),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(697)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(819),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-56f738fc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(843),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(715)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(839),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(680)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(801),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(678)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(799),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(674)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(795),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(686)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(808),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(702)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(825),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(685)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(807),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(679)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(800),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(711)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(835),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(676)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(797),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(717)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(841),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(687)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(809),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(691)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(813),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(703)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(826),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(683)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(805),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(700)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(822),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(696)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(818),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(714)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(838),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(690)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(812),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(681)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(802),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(709)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(832),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(675)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(796),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(694)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(816),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(718)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(842),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 795 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-home"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._v("\n      This is home.\n    ")])])])
}]}

/***/ }),
/* 796 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-components"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.wrapperList), function(wrapper) {
    return _c('div', {
      class: wrapper.class
    }, _vm._l((wrapper.componentList), function(component) {
      return _c('div', {
        class: component.class
      }, _vm._l((component.itemList), function(item) {
        return _c('div', {
          class: item.class
        }, [(item.content && item.content.type === 'title') ? _c('p', {
          staticClass: "title"
        }, [_vm._v(_vm._s(item.content.title))]) : _vm._e(), _vm._v(" "), (item.content && item.content.type === 'title') ? _c('p', {
          staticClass: "subtitle"
        }, [_vm._v(_vm._s(item.content.subtitle))]) : _vm._e(), _vm._v(" "), (!component.nocontrol) ? _c('div', {
          staticClass: "columns"
        }, [_c('div', {
          staticClass: "column has-text-right"
        }, [_c('p', [_c('a', {
          on: {
            "click": function($event) {
              _vm.addComponent(wrapper.componentList, 1);
              component.nocontrol = true
            }
          }
        }, [_vm._v("add column "), _c('i', {
          staticClass: "material-icons md-18"
        }, [_vm._v("arrow_forward")])])])])]) : _vm._e()])
      }))
    }))
  }), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "box content",
    staticStyle: {
      "background-color": "#eee"
    }
  }, [_c('p', [_c('a', {
    on: {
      "click": function($event) {
        _vm.addComponents(_vm.wrapperList, 1)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("arrow_downward")]), _vm._v(" add row")])])])])])], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column content",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Components")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Describing Components")])])])
}]}

/***/ }),
/* 797 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-register"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "tabs is-centered"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")])], 1), _vm._v(" "), _c('li', {
    staticClass: "is-active"
  }, [_c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Sign Up")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 is-offset-2"
  }, [_c('div', {
    staticClass: "register-form form-horizontal"
  }, [(_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v("\n                " + _vm._s(_vm.error) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('form-input', {
    attrs: {
      "type": "email",
      "name": "email",
      "fa": "user",
      "mdi": "email",
      "placeholder": "Email",
      "value": _vm.credentials.email,
      "error": _vm.errors.email,
      "required": "true",
      "autofocus": "true"
    },
    on: {
      "onInput": _vm.onInput
    }
  }), _vm._v(" "), _c('form-input', {
    attrs: {
      "type": "text",
      "name": "name",
      "fa": "user",
      "mdi": "person_outline",
      "placeholder": "Username",
      "value": _vm.credentials.name,
      "error": _vm.errors.name,
      "required": "true"
    },
    on: {
      "onInput": _vm.onInput
    }
  }), _vm._v(" "), _c('form-input', {
    attrs: {
      "type": "password",
      "name": "password",
      "fa": "lock",
      "mdi": "lock",
      "placeholder": "Password",
      "value": _vm.credentials.password,
      "error": _vm.errors.password,
      "required": "true"
    },
    on: {
      "onInput": _vm.onInput
    }
  }), _vm._v(" "), _c('form-input', {
    attrs: {
      "type": "password",
      "name": "password_confirmation",
      "fa": "lock",
      "mdi": "lock_outline",
      "placeholder": "Confirm Password",
      "value": _vm.credentials.password_confirmation,
      "error": _vm.errors.password_confirmation,
      "required": "true"
    },
    on: {
      "onInput": _vm.onInput
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "control submit"
  }, [_c('button', {
    staticClass: "button is-primary is-outlined is-fullwidth",
    class: {
      'is-loading': _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("\n                  Register\n                ")])])], 1)])])])])])])
},staticRenderFns: []}

/***/ }),
/* 798 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-prop"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns is-gapless is-flex-mobile is-centered"
  }, [_c('div', {
    staticClass: "column is-6 is-11-mobile has-text-centered"
  }, [_c('div', {
    staticClass: "cont-desc",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('h1', {
    staticClass: "supertitle"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.subtitle))])]), _vm._v(" "), _c('div', {
    staticClass: "cont-desc",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_vm._t("default")], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 799 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-contact"
  }, [_c('header-prop', {
    staticClass: "header-prop-contact",
    attrs: {
      "title": "Hello",
      "subtitle": "how can we be of assistance?"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/noctorus.studio",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.twitter.com/noctorus",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.medium.com/@noctorus",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-medium"
  })])]), _vm._v(" "), _c('contact-section', {
    attrs: {
      "id": "section-contact"
    }
  }), _vm._v(" "), (false) ? _c('section-comment') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 800 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-login"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-4"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "tabs is-centered"
  }, [_c('ul', [_c('li', {
    staticClass: "is-active"
  }, [_c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Login")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Sign Up")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 is-offset-2"
  }, [_c('div', {
    staticClass: "login-form form-horizontal"
  }, [(_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v("\n                " + _vm._s(_vm.error) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('form-input', {
    attrs: {
      "type": "email",
      "name": "email",
      "fa": "user",
      "mdi": "person_outline",
      "placeholder": "Email",
      "value": _vm.credentials.email,
      "error": _vm.errors.email,
      "required": "true",
      "autofocus": "true"
    },
    on: {
      "onInput": _vm.onInput
    }
  }), _vm._v(" "), _c('form-input', {
    attrs: {
      "type": "password",
      "name": "password",
      "fa": "lock",
      "mdi": "lock_outline",
      "placeholder": "Password",
      "value": _vm.credentials.password,
      "error": _vm.errors.password,
      "required": "true"
    },
    on: {
      "onInput": _vm.onInput
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "control has-text-centered"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    staticClass: "styled",
    attrs: {
      "id": "checkbox",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.rememberMe) ? _vm._i(_vm.rememberMe, null) > -1 : (_vm.rememberMe)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rememberMe = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rememberMe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberMe = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox"
    }
  }, [_vm._v("\n                        Remember Me\n                  ")])]), _vm._v(" "), _c('p', {
    staticClass: "control submit"
  }, [_c('button', {
    staticClass: "button is-primary is-outlined is-fullwidth",
    class: {
      'is-loading': _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("\n                  Login\n                ")])])], 1)])]), _vm._v(" "), _vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "extra"
  }, [_c('p', {
    staticClass: "has-text-centered"
  }, [_c('a', {
    attrs: {
      "href": "{ route('password.request') }"
    }
  }, [_vm._v("Forgot password")]), _vm._v("\n               \n            "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Need help?")])])])
}]}

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-about"
  }, [_c('header-prop', {
    staticClass: "header-prop-about",
    attrs: {
      "title": "Essential",
      "subtitle": "ingredients"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://vuejs.org",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(740),
      "width": "100"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://octobercms.com/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "october",
    attrs: {
      "src": __webpack_require__(738),
      "width": "70"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://developer.apple.com/ios/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(737),
      "width": "100"
    }
  })]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://developer.android.com/studio/index.html",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(734),
      "width": "100"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://facebook.github.io/react-native/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(739),
      "width": "100"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://firebase.google.com/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "grayscale",
    attrs: {
      "src": __webpack_require__(736),
      "width": "100"
    }
  })])]), _vm._v(" "), _c('content-project-list-section'), _vm._v(" "), _c('div', {
    staticClass: "particle-wrapper"
  }, [_c('vue-particles', {
    staticClass: "particle-main",
    attrs: {
      "color": "#A01A37",
      "particleOpacity": 5,
      "particlesNumber": 15,
      "shapeType": "edge",
      "particleSize": 8.5,
      "linesColor": "#dedede",
      "linesWidth": 1,
      "lineLinked": true,
      "lineOpacity": 0.4,
      "linesDistance": 150,
      "moveSpeed": 3,
      "moveDirection": 'bottom',
      "hoverEffect": true,
      "hoverMode": "grab",
      "clickEffect": true,
      "clickMode": "push"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "hero section-about",
    attrs: {
      "id": "section-about"
    }
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-multiline"
  }, [_c('div', {
    staticClass: "column is-10 is-content has-text-left",
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('p'), _vm._m(0), _vm._v(" "), _c('p'), _vm._v(" "), _c('br'), _vm._v(" "), (false) ? _c('a', {
    staticClass: "button is-medium",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$scrollTo('#carousel-slick', {
          offset: -30
        })
      }
    }
  }, [_vm._v("Run")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "column is-4 is-card has-text-left",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "card",
    attrs: {
      "data-aos": "fade-left",
      "data-aos-once": "true"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "card-content",
    staticStyle: {
      "background-color": "lightgray"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n                    Bzzz."), _c('br'), _vm._v(" "), _c('a', [_vm._v("#metaphorical")]), _vm._v(" "), _c('a', [_vm._v("#concepts")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s('11:09 PM - 1 Jan 2017'))])])])])]) : _vm._e()])])])])], 1), _vm._v(" "), _c('carousel-slick'), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "z-index": "1"
    }
  }, [_c('a', {
    staticClass: "next-section next-blue",
    attrs: {
      "rel": "nofollow",
      "href": "#portfolio"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$scrollTo('#section-services', {
          offset: 0
        })
      }
    }
  }, [_c('i', {
    staticClass: "material-icons",
    staticStyle: {
      "font-size": "1.5em"
    }
  }, [_vm._v("keyboard_arrow_down")])])]), _vm._v(" "), _c('div', {
    staticClass: "section-services",
    attrs: {
      "id": "section-services"
    }
  }, [_c('section', {
    staticStyle: {
      "position": "relative",
      "width": "100%"
    }
  }, [_c('div', {
    attrs: {
      "id": "services-bg"
    }
  }, [_vm._v("\n           \n      ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "services-cover"
    }
  }, [_vm._v("\n           \n      ")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), (false) ? _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "80px",
      "margin-bottom": "0px"
    }
  }, [_vm._m(5)]) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(6)]) : _vm._e(), _vm._v(" "), _vm._m(7)])]), _vm._v(" "), (false) ? _c('section-comment') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', {
    staticClass: "text-faded has-text-centered"
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v("\n                  hello, we are "), _c('span', {
    staticClass: "color-orange"
  }, [_vm._v("passionate")]), _vm._v(" "), _c('span', {
    staticClass: "color-gray"
  }, [_vm._v("\\\\n")]), _vm._v(" "), _c('br'), _c('span', [_c('b', [_c('a', {
    attrs: {
      "href": "/contact",
      "target": "_blank"
    }
  }, [_c('u', {
    staticStyle: {
      "border-bottom": "1px solid #fc0",
      "text-decoration": "none",
      "color": "white"
    }
  }, [_vm._v("coders")])]), _vm._v(" &\n                      "), _c('a', {
    attrs: {
      "href": "/contact",
      "target": "_blank"
    }
  }, [_c('u', {
    staticStyle: {
      "border-bottom": "1px solid #A01A37",
      "text-decoration": "none",
      "color": "white"
    }
  }, [_vm._v("designers")])])])]), _vm._v(",\n                  "), _vm._v(" "), _c('br'), _vm._v("specializing "), _c('span', {
    staticClass: "color-red"
  }, [_vm._v("minimal")]), _vm._v(" UI / UX design.\n                  "), _c('br'), _vm._v("tayloring "), _c('span', {
    staticClass: "color-gray"
  }, [_vm._v("bespoke")]), _vm._v(" software solutions.\n                  "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "auto",
      "margin-right": "auto"
    },
    attrs: {
      "ng-cloak": ""
    }
  }, [_c('span', {
    staticClass: "typewriter-start typewriter"
  }, [_c('div', {
    staticStyle: {
      "border-width": "3px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#F0A202"
    }
  }, [_vm._v(">:")]), _vm._v("  \n                      ")])])]), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    staticStyle: {
      "width": "300px",
      "margin": "0 auto"
    },
    attrs: {
      "src": __webpack_require__(322),
      "width": "150",
      "alt": "Image"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('figure', {
    staticClass: "image is-48x48"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "30px"
    },
    attrs: {
      "src": "http://via.placeholder.com/96/ffffff/000000",
      "alt": "Image"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v("noctorus")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_c('span', {
    staticClass: "color-orange"
  }, [_vm._v(">:")]), _vm._v(" "), _c('span', {
    staticClass: "color-gray"
  }, [_vm._v("= nocturnal")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless"
  }, [_c('div', {
    staticClass: "column has-text-centered"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("core")]), _vm._v(" "), _c('hr', {
    staticClass: "center"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns is-centered is-gapless"
  }, [_c('div', {
    staticClass: "column is-2 has-text-centered",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-4x fa-circle-o color-orange",
    staticStyle: {
      "padding": "15px",
      "margin-top": "30px"
    },
    attrs: {
      "data-sr": "wait 0.0s, move 0px scale up 20%, over 0.6s"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("minimal")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2 has-text-centered",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-4x fa-hand-spock-o color-blue",
    staticStyle: {
      "padding": "15px",
      "margin-top": "30px"
    },
    attrs: {
      "data-sr": "wait 0.0s, move 0px scale up 20%, over 0.6s"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("passionate")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2 has-text-centered",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-4x fa-cube color-red",
    staticStyle: {
      "padding": "15px",
      "margin-top": "30px"
    },
    attrs: {
      "data-sr": "wait 0.0s, move 0px scale up 20%, over 0.6s"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("extensible")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-gapless"
  }, [_c('div', {
    staticClass: "column has-text-centered"
  }, [_c('i', {
    staticClass: "fa fa-4x fa-gear",
    staticStyle: {
      "color": "#bbb"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns is-gapless"
  }, [_c('div', {
    staticClass: "column has-text-centered"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("stack")]), _vm._v(" "), _c('hr', {
    staticClass: "center"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "50px",
      "padding-bottom": "50px"
    }
  }, [_c('div', {
    staticClass: "columns is-centered is-gapless"
  }, [_c('div', {
    staticClass: "column is-4 has-text-centered",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('i', {
    staticClass: "fa fa-4x fa-cubes color-gray",
    staticStyle: {
      "padding": "15px"
    },
    attrs: {
      "data-sr": "wait 0.0s, move 0px scale up 20%, over 0.6s"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("engine")])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-centered is-gapless",
    attrs: {
      "data-aos": "fade-right",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "column is-3 is-6-tablet is-3-desktop has-text-left",
    staticStyle: {
      "padding": "30px",
      "padding-top": "0"
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', [_c('li', [_vm._v("Brand / corporate identity")]), _vm._v(" "), _c('li', [_vm._v("Collateral design")]), _vm._v(" "), _c('li', [_vm._v("UI / UX design")]), _vm._v(" "), _c('li', [_vm._v("App development")]), _vm._v(" "), _c('li', [_vm._v("Web solutions")])])])])])])
}]}

/***/ }),
/* 802 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-layout-masonry"
  }, [_vm._m(0), _vm._v(" "), _c('masonry-instagram'), _vm._v(" "), _c('section-comment', {
    staticStyle: {
      "margin-top": "50px"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n      Masonry + Instagram Layout.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_vm._v("\n      Masonry + Instagram layout."), _c('br')])])
}]}

/***/ }),
/* 803 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "disqus_thread"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 804 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container gallery-container",
    attrs: {
      "id": "gallery-container"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n    Gallery\n  ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "masonry",
      rawName: "v-masonry"
    }, {
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    staticClass: "masonry-container",
    attrs: {
      "id": "masonry-container",
      "transition-duration": "0.0s",
      "item-selector": ".masonry-item",
      "data-masonry-options": "{ 'isFitWidth': true }",
      "infinite-scroll-disabled": "itemsLoading",
      "infinite-scroll-distance": "10"
    }
  }, _vm._l((_vm.items), function(image, index) {
    return _c('div', {
      directives: [{
        name: "masonry-tile",
        rawName: "v-masonry-tile"
      }],
      staticClass: "masonry-item",
      attrs: {
        "data-aos": "slide-up",
        "data-aos-once": "true",
        "data-aos-duration": "1000",
        "data-aos-offset": "0"
      }
    }, [_c('a', {
      attrs: {
        "href": image.link,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-image"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": _vm.parseInstagramImageLink(image.images.standard_resolution.url),
        "alt": "Image"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "media"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "media-content"
    }, [_c('p', {
      staticClass: "title is-4"
    }, [_vm._v(_vm._s(image.id))]), _vm._v(" "), _c('p', {
      staticClass: "title is-4"
    }, [_vm._v(_vm._s(image.link))]), _vm._v(" "), _c('p', {
      staticClass: "title is-4"
    }, [_vm._v(_vm._s(image.caption.text))])])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_vm._v("\n              " + _vm._s(image.description) + " "), _c('a', [_vm._v("@architecture")]), _vm._v(".\n              "), _c('a', [_vm._v("#elegant")]), _vm._v(" "), _c('a', [_vm._v("#design")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm._f("datetime")(image.created_at)))])])])])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "load-more"
  }, [(!_vm.itemsEnded) ? _c('div', {
    staticClass: "button",
    class: {
      'is-loading': _vm.itemsLoading
    },
    on: {
      "click": function($event) {
        _vm.loadMore()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.itemsEnded) ? _c('div', {
    staticClass: "ended",
    attrs: {
      "data-aos": "slide-up",
      "data-aos-once": "true",
      "data-aos-duration": "1000"
    }
  }, [_vm._v("browse more at"), _c('br', {
    staticClass: "is-hidden-desktop"
  }), _vm._v("  "), _vm._m(1)]) : _vm._e()]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.error)
    }
  })]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-left"
  }, [_c('figure', {
    staticClass: "image is-48x48"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "30px"
    },
    attrs: {
      "src": "http://bulma.io/images/placeholders/96x96.png",
      "alt": "Image"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://www.instagram.com/adamlob0/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-instagram",
    staticStyle: {
      "vertical-align": "middle"
    }
  }), _vm._v(" / ADAMLOBOTV")])
}]}

/***/ }),
/* 805 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "terms-of-service container"
  }, [_c('h2', [_vm._v("Terms of Service")]), _vm._v(" "), _c('h3', [_vm._v("1. Terms")]), _vm._v(" "), _c('p', [_vm._v("By accessing the website at "), _c('a', {
    attrs: {
      "href": "https://noctorus.studio"
    }
  }, [_vm._v("https://noctorus.studio")]), _vm._v(", you are agreeing to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site. The materials contained in this website are protected by applicable copyright and trademark law.")]), _vm._v(" "), _c('h3', [_vm._v("2. Use License")]), _vm._v(" "), _c('ol', {
    attrs: {
      "type": "a"
    }
  }, [_c('li', [_vm._v("Permission is granted to temporarily download one copy of the materials (information or software) on Noctorus Studio's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:\n     "), _c('ol', {
    attrs: {
      "type": "i"
    }
  }, [_c('li', [_vm._v("modify or copy the materials;")]), _vm._v(" "), _c('li', [_vm._v("use the materials for any commercial purpose, or for any public display (commercial or non-commercial);")]), _vm._v(" "), _c('li', [_vm._v("attempt to decompile or reverse engineer any software contained on Noctorus Studio's website;")]), _vm._v(" "), _c('li', [_vm._v("remove any copyright or other proprietary notations from the materials; or")]), _vm._v(" "), _c('li', [_vm._v("transfer the materials to another person or \"mirror\" the materials on any other server.")])])]), _vm._v(" "), _c('li', [_vm._v("This license shall automatically terminate if you violate any of these restrictions and may be terminated by Noctorus Studio at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in electronic or printed format.")])]), _vm._v(" "), _c('h3', [_vm._v("3. Disclaimer")]), _vm._v(" "), _c('ol', {
    attrs: {
      "type": "a"
    }
  }, [_c('li', [_vm._v("The materials on Noctorus Studio's website are provided on an 'as is' basis. Noctorus Studio makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.")]), _vm._v(" "), _c('li', [_vm._v("Further, Noctorus Studio does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.")])]), _vm._v(" "), _c('h3', [_vm._v("4. Limitations")]), _vm._v(" "), _c('p', [_vm._v("In no event shall Noctorus Studio or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Noctorus Studio's website, even if Noctorus Studio or a Noctorus Studio authorized representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.")]), _vm._v(" "), _c('h3', [_vm._v("5. Accuracy of materials")]), _vm._v(" "), _c('p', [_vm._v("The materials appearing on Noctorus Studio website could include technical, typographical, or photographic errors. Noctorus Studio does not warrant that any of the materials on its website are accurate, complete or current. Noctorus Studio may make changes to the materials contained on its website at any time without notice. However Noctorus Studio does not make any commitment to update the materials.")]), _vm._v(" "), _c('h3', [_vm._v("6. Links")]), _vm._v(" "), _c('p', [_vm._v("Noctorus Studio has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Noctorus Studio of the site. Use of any such linked website is at the user's own risk.")]), _vm._v(" "), _c('h3', [_vm._v("7. Modifications")]), _vm._v(" "), _c('p', [_vm._v("Noctorus Studio may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.")]), _vm._v(" "), _c('h3', [_vm._v("8. Governing Law")]), _vm._v(" "), _c('p', [_vm._v("These terms and conditions are governed by and construed in accordance with the laws of Puchong, Malaysia and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.")])])
}]}

/***/ }),
/* 806 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-contact",
    attrs: {
      "id": "section-contact"
    }
  }, [_c('div-columns', {
    attrs: {
      "column-num": "is-8"
    }
  }, [_c('form-dynamix', {
    attrs: {
      "type": "team",
      "feedback": _vm.feedback,
      "loading": _vm.loading,
      "names": _vm.names,
      "models": _vm.models,
      "attributes": _vm.attributes,
      "vuelidate": _vm.$v,
      "no-print": _vm.noPrint,
      "is-print": _vm.isPrint,
      "is-print-pdf": _vm.isPrintPdf,
      "is-rerender": _vm.isRerender
    },
    on: {
      "recaptcha": _vm.onRecaptcha,
      "send": _vm.onSend
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 807 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-showcase"
  }, [_c('header-prop', {
    staticClass: "header-prop-showcase",
    attrs: {
      "title": "Define",
      "subtitle": "app"
    }
  }), _vm._v(" "), _c('div-columns', {
    staticClass: "div-content",
    attrs: {
      "column-num": "is-8",
      "div-style": {}
    }
  }, [_c('div', {
    staticClass: "column"
  }, [(_vm.$route.params.type.toLowerCase() === 'ios') ? _c('div', _vm._l((_vm.projects), function(project) {
    return _c('div', {
      key: project.name,
      staticStyle: {
        "margin-top": "2em",
        "margin-bottom": "2em"
      },
      attrs: {
        "align": "center"
      }
    }, [_c('h1', {
      staticStyle: {
        "margin-top": "2em",
        "margin-bottom": "0.5em"
      }
    }, [_vm._v(_vm._s(project.title))]), _vm._v(" "), (project.linkLabel && project.link) ? _c('h4', {
      staticStyle: {
        "margin-left": "0.5em",
        "margin-top": "0em",
        "margin-bottom": "1em"
      }
    }, [_c('a', {
      attrs: {
        "href": project.link
      }
    }, [_vm._v(_vm._s(project.linkLabel))])]) : (project.linkLabel && project.link === undefined) ? _c('h4', {
      staticStyle: {
        "margin-left": "0.5em",
        "margin-top": "0em",
        "margin-bottom": "1em"
      }
    }, [_vm._v(_vm._s(project.linkLabel))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "100%",
        "display": "inline-block",
        "font-size": "0"
      },
      attrs: {
        "align": "left"
      }
    }, _vm._l((project.images), function(info) {
      return _c('lightbox', {
        key: info.path,
        staticStyle: {
          "display": "inline-block",
          "width": "50%",
          "cursor": "pointer"
        },
        attrs: {
          "caption": project.title,
          "src": info.path,
          "album": 'test'
        }
      }, [_c('img', {
        staticStyle: {
          "display": "inline-block"
        },
        attrs: {
          "src": info.path,
          "data-pin-nopin": "true"
        }
      })])
    }))])
  })) : _c('div', [_c('span', [_vm._v("else")])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "scroll-spy",
      rawName: "v-scroll-spy",
      value: (_vm.scrollPos),
      expression: "scrollPos"
    }],
    staticClass: "page-landing"
  }, [_c('div', {
    staticClass: "hero is-primary section-main",
    attrs: {
      "id": "section-main"
    }
  }, [_c('div', {
    staticClass: "hero-cover"
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 is-offset-2"
  }, [_c('p', {
    staticStyle: {
      "color": "black"
    }
  }, [(false) ? _c('fb-login') : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 is-offset-2"
  }, [_vm._m(0), _c('div', [_c('div', {
    staticClass: "title",
    staticStyle: {
      "display": "flex",
      "max-width": "200px",
      "margin": "auto"
    },
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true",
      "data-aos-delay": "500"
    }
  }, [_c('span', {
    staticClass: "typewriter-start typewriter"
  }, [_c('div', [_c('a', {
    staticClass: "page-scroll",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$scrollTo('#section-main-showcase', {
          offset: 80
        })
      }
    }
  }, [_c('span', {
    staticClass: "color-red"
  }, [_vm._v("$")]), _vm._v(" "), _c('span', {
    staticClass: "color-orange"
  }, [_vm._v(": _")]), _vm._v("  "), _c('span', {
    staticStyle: {
      "width": "100%",
      "margin-right": "10px",
      "margin-bottom": "1em"
    }
  }, [_vm._v("HERE")]), _vm._v(" ")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p')])])])])]), _vm._v(" "), _c('div', {
    staticClass: "hero is-primary section-main section-main-reversed",
    attrs: {
      "id": "section-main-2"
    }
  }, [_c('div', {
    staticClass: "hero-cover hero-cover-reversed"
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 is-offset-2"
  }, [_vm._m(1), _c('div', {
    staticClass: "title",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    staticClass: "typewriter-start typewriter"
  }, [_c('div', [_c('a', {
    staticClass: "page-scroll",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$scrollTo('#section-main-3', {
          offset: -50
        })
      }
    }
  }, [_c('span', {
    staticClass: "color-orange"
  }, [_vm._v("_")]), _vm._v(" thought "), _c('span', {
    staticClass: "color-red"
  }, [_vm._v("_")]), _vm._v("  ")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p')])])])])]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "hero is-primary section-main section-main-highlighted",
    attrs: {
      "id": "section-main-3"
    }
  }, [_c('div', {
    staticClass: "hero-cover hero-cover-highlighted"
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 is-offset-2"
  }, [_vm._m(2), _c('div', {
    staticClass: "title",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    staticClass: "typewriter-start typewriter"
  }, [_c('div', [_c('a', {
    staticClass: "page-scroll",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.$scrollTo('#section-main-4', {
          offset: -50
        })
      }
    }
  }, [_vm._m(3), _vm._v(" re-order "), _c('span', {
    staticClass: "color-orange"
  }, [_vm._v("/")]), _vm._v(" "), _c('span', {
    staticClass: "color-blue"
  }, [_vm._v("_")]), _vm._v("  ")])])])]), _vm._v(" "), _c('p')])])])])]) : _vm._e(), _vm._v(" "), (false) ? _c('content-project-list-section', {
    attrs: {
      "id": "section-main-showcase"
    }
  }) : _vm._e(), _vm._v(" "), (false) ? _c('content-service-list-section') : _vm._e(), _vm._v(" "), (false) ? _c('top-section') : _vm._e(), _vm._v(" "), _vm._m(4), _vm._v(" "), (false) ? _c('content-project-list-section') : _vm._e(), _vm._v(" "), (false) ? _c('content-quote-section') : _vm._e(), _vm._v(" "), (false) ? _c('section-comment') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title capital has-text-centered",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_vm._v("\n              Let's Build"), _c('br'), _vm._v("\n              Something "), _c('span', {
    staticClass: "color-blue"
  }, [_vm._v("Great")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": __webpack_require__(741),
      "width": "240px",
      "data-pin-nopin": "true"
    }
  }), _vm._v(" "), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title capital",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "color-red"
  }, [_vm._v("Cast")]), _vm._v(" a "), _c('span', {
    staticClass: "color-orange"
  }, [_vm._v("reflection")]), _vm._v(" :"), _c('br'), _vm._v("\n              of your"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title capital",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_vm._v("\n              Succumb to "), _c('span', {
    staticClass: "color-blue"
  }, [_vm._v("..")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#A01A37"
    }
  }, [_vm._v("chaos")]), _c('br'), _vm._v("\n              or "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": __webpack_require__(732),
      "width": "300px",
      "data-aos": "fade-right",
      "data-aos-once": "true",
      "data-pin-nopin": "true"
    }
  }), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "color-blue"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero is-primary section-main section-main-ads",
    attrs: {
      "id": "section-main-5"
    }
  }, [_c('div', {
    staticClass: "hero-cover hero-cover-ads"
  }), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 is-offset-2 has-text-centered",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('img', {
    staticStyle: {
      "margin-bottom": "1rem"
    },
    attrs: {
      "src": __webpack_require__(731)
    }
  }), _vm._v(" "), _c('div', [_c('span', [_vm._v("\"we'll be right back after this commercial break.\"")])])])])])])])
}]}

/***/ }),
/* 809 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-verify"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-4 is-offset-4"
  }, [_c('div', {
    staticClass: "box section"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8 is-offset-2"
  }, [_c('div', {
    staticClass: "login-form form-horizontal"
  }, [(_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v("\n                " + _vm._s(_vm.error) + "\n              ")]) : _vm._e(), _vm._v(" "), (!_vm.success) ? _c('form-input', {
    attrs: {
      "type": "token",
      "name": "token",
      "fa": "key",
      "mdi": "vpn_key",
      "placeholder": "Verification Token",
      "value": _vm.token,
      "error": _vm.errors.token,
      "required": "true",
      "autofocus": "true",
      "disabled": _vm.isLoading
    },
    on: {
      "onInput": _vm.onInput
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.success) ? _c('p', {
    staticClass: "control submit"
  }, [_c('button', {
    staticClass: "button is-primary is-outlined is-fullwidth",
    class: {
      'is-loading': _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.submit(_vm.token)
      }
    }
  }, [_vm._v("\n                  Verify\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "control notification is-primary"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.success = undefined
      }
    }
  }), _vm._v("\n                " + _vm._s(_vm.success) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary is-outlined is-fullwidth",
    attrs: {
      "disabled": !_vm.success
    },
    on: {
      "click": function($event) {
        _vm.$router.push('/login')
      }
    }
  }, [_vm._v("\n                  Proceed To Login\n                ")])]) : _vm._e()], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "header has-text-centered"
  }, [_c('h1', [_vm._v("Email Verification")])])
}]}

/***/ }),
/* 810 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero is-primary section-service-list",
    attrs: {
      "id": "section-service-list"
    }
  }, [_c('div', {
    staticClass: "hero-body",
    staticStyle: {
      "color": "white"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns is-multiline is-gapless is-centered"
  }, [_c('div', {
    staticClass: "column is-10"
  }, [_c('h1', [_vm._v("$ > services")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "hero-body",
    staticStyle: {
      "padding": "0",
      "margin-bottom": "5em"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns is-multiline is-gapless is-centered"
  }, [_c('div', {
    staticClass: "column is-10"
  }, [_c('div', {
    staticClass: "columns is-multiline is-gapless"
  }, [_c('div', {
    staticClass: "column is-6 has-text-centered section-1",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('span', [_vm._v("bespoke solutions")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-6 has-text-centered section-2",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('span', [_vm._v("branding & collateral design")])])]), _vm._v(" "), _c('div', {
    staticClass: "columns is-multiline is-gapless"
  }, [_c('div', {
    staticClass: "column is-6 has-text-centered section-3",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('span', [_vm._v("responsive to modern platforms")])]), _vm._v(" "), _c('div', {
    staticClass: "column is-6 has-text-centered section-4",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('span', [_vm._v("mobile apps")])])])])])])])])
}]}

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-wrapper",
    class: {
      'landing': _vm.isLanding, 'affix': _vm.isAffix
    },
    attrs: {
      "id": "navse",
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('div-container', {
    staticStyle: {
      "padding-top": "30px"
    },
    attrs: {
      "column-num": "is-11"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-mobile navbar-full"
  }, [_c('div', {
    staticClass: "column is-narrow column-link navbar-brand",
    attrs: {
      "align": "left"
    }
  }, [_c('router-link', {
    attrs: {
      "href": "/",
      "to": {
        name: 'landing'
      }
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    style: ({
      maxHeight: 'auto'
    }),
    attrs: {
      "src": __webpack_require__(322),
      "width": "110"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "column navbar-brand is-hidden-touch has-text-centered"
  }, [_c('router-link', {
    attrs: {
      "href": "/",
      "to": {
        name: 'landing'
      }
    }
  }, [_c('span', {
    staticStyle: {
      "margin-left": "110px"
    },
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_vm._v("noctorus")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "column is-hidden-desktop"
  }), _vm._v(" "), _vm._l((_vm.navMain), function(navItem) {
    return _c('div', {
      staticClass: "column column-link is-narrow is-hidden-touch",
      class: {
        'is-active': _vm.$route.name === navItem.name
      },
      staticStyle: {
        "display": "none"
      }
    }, [_c('router-link', {
      class: {
        active: _vm.$route.name === navItem.name
      },
      attrs: {
        "href": navItem.path,
        "to": {
          name: navItem.name,
          params: navItem.params
        }
      }
    }, [_vm._v("\n          " + _vm._s(navItem.title) + "\n        ")])], 1)
  }), _vm._v(" "), _vm._l((_vm.navMain), function(navItem) {
    return _c('dropdown', {
      key: navItem.name,
      staticClass: "column column-link is-narrow is-hidden-touch has-text-right",
      attrs: {
        "visible": _vm.visible,
        "animation": 'ani-slide-y',
        "position": ['center', 'bottom', 'center', 'top']
      },
      on: {
        "positioned": function($event) {
          _vm.onDropdownPosition($event)
        }
      }
    }, [(navItem.subnav) ? _c('a', {
      class: {
        'nav-item-link': true, active: _vm.$route.name === navItem.name
      },
      staticStyle: {
        "display": "block"
      },
      attrs: {
        "href": [navItem.section ? '/?anchor=' + navItem.section : (navItem.path ? navItem.path : '#')]
      },
      on: {
        "click": function($event) {
          [navItem.section ? _vm.onScrollTo($event, 'landing', navItem.section) : (navItem.path ? '' : $event.preventDefault())]
        },
        "mouseover": function($event) {
          _vm.onMouseOverSubnav($event, navItem.subnav)
        },
        "mouseout": function($event) {
          _vm.onMouseOutSubnav($event, navItem.subnav)
        }
      }
    }, [_c('span', {
      staticClass: "link"
    }, [_vm._v("\n            " + _vm._s(navItem.title) + "\n          ")]), _vm._v(" "), (navItem.subnav) ? _c('span', [_vm._v("\n             "), _c('i', {
      staticClass: "fa fa-caret-right",
      staticStyle: {
        "vertical-align": "middle",
        "font-size": "1.2em"
      }
    })]) : _vm._e()]) : _c('router-link', {
      class: {
        'nav-item-link': true, active: _vm.$route.name === navItem.name
      },
      attrs: {
        "href": navItem.path,
        "to": {
          name: navItem.name,
          params: navItem.params
        }
      }
    }, [_vm._v("\n          " + _vm._s(navItem.title) + "\n        ")]), _vm._v(" "), (navItem.subnav) ? _c('div', {
      staticClass: "dropdown-wrapper",
      attrs: {
        "slot": "dropdown"
      },
      on: {
        "mouseover": function($event) {
          _vm.visible = true
        },
        "mouseout": function($event) {
          _vm.visible = false
        }
      },
      slot: "dropdown"
    }, _vm._l((navItem.subnav), function(navSubItem) {
      return _c('div', {
        staticClass: "dropdown-item has-text-left"
      }, [(navSubItem.section) ? _c('a', {
        class: {
          'nav-item-link': true, active: _vm.$route.name === navSubItem.name
        },
        attrs: {
          "href": [navSubItem.section ? '/?anchor=' + navSubItem.section : (navSubItem.path ? navSubItem.path : '#')]
        },
        on: {
          "click": function($event) {
            [navSubItem.section ? _vm.onScrollTo($event, 'landing', navSubItem.section) : (navSubItem.path ? '' : $event.preventDefault())]
          }
        }
      }, [_c('div', {
        staticClass: "dropdown-item-inner"
      }, [_vm._v("\n                " + _vm._s(navSubItem.title) + "\n              ")])]) : _c('router-link', {
        class: {
          'nav-item-link': true, active: _vm.$route.name === navSubItem.name
        },
        attrs: {
          "href": navSubItem.path,
          "to": {
            name: navSubItem.name
          }
        }
      }, [_c('div', {
        staticClass: "dropdown-item-inner"
      }, [_vm._v("\n                " + _vm._s(navSubItem.title) + "\n              ")])])], 1)
    })) : _vm._e()], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "column is-narrow navbar-menu",
    attrs: {
      "data-aos": "zoom-in",
      "data-aos-once": "true"
    },
    on: {
      "click": function($event) {
        _vm.onToggle()
      }
    }
  }, [_c('div', {
    staticClass: "control-menu",
    class: {
      active: _vm.showNav
    }
  }, [_c('span')])])], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 812 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-layout-masonry"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n      Masonry Layout.\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "grid",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "data-masonry": "{ \"columnWidth\": 200 }"
    }
  }, _vm._l((_vm.images), function(image) {
    return _c('div', {
      staticClass: "grid-item"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": image.image_900
      }
    })])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "container masonry-container"
  }, [_c('div', {
    directives: [{
      name: "masonry",
      rawName: "v-masonry"
    }],
    staticClass: "masonry-wrapper",
    attrs: {
      "transition-duration": "0.3s",
      "item-selector": ".masonry-item",
      "is-fit-width": "true",
      "data-masonry-options": "{ 'isFitWidth': true }"
    }
  }, _vm._l((_vm.images), function(image, index) {
    return _c('div', {
      directives: [{
        name: "masonry-tile",
        rawName: "v-masonry-tile"
      }],
      staticClass: "masonry-item"
    }, [_c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticClass: "card-image"
    }, [_c('figure', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": image.image_900,
        "alt": "Image"
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "card-content"
    }, [_c('div', {
      staticClass: "media"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "media-content"
    }, [_c('p', {
      staticClass: "title is-4"
    }, [_vm._v(_vm._s(image.title))]), _vm._v(" "), _c('p', {
      staticClass: "subtitle is-6"
    }, [_vm._v("@" + _vm._s(image.title.replace(/\s+/g, '')))])])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_vm._v("\n              " + _vm._s(image.description) + " "), _c('a', [_vm._v("@architecture")]), _vm._v(".\n              "), _c('a', [_vm._v("#elegant")]), _vm._v(" "), _c('a', [_vm._v("#design")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm._f("datetime")(image.created_at)))])])])])])
  })), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v("\n      " + _vm._s(_vm.error) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('section-comment', {
    staticStyle: {
      "margin-top": "50px"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "subtitle",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_vm._v("\n      Creating Pinterest-like Masonry layout."), _c('br'), _vm._v("\n      Reference: "), _c('a', {
    attrs: {
      "href": "https://www.sitepoint.com/understanding-masonry-layout/",
      "target": "_blank"
    }
  }, [_vm._v("Sitepoint - Understanding Masonry Layout")]), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/shershen08/vue-masonry"
    }
  }, [_c('i', {
    staticClass: "fa fa-2x fa-github color-red"
  }), _vm._v("    shershen08 / Vue-Masonry")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-left"
  }, [_c('figure', {
    staticClass: "image is-48x48"
  }, [_c('img', {
    staticStyle: {
      "border-radius": "30px"
    },
    attrs: {
      "src": "http://bulma.io/images/placeholders/96x96.png",
      "alt": "Image"
    }
  })])])
}]}

/***/ }),
/* 813 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "privacy-policy container"
  }, [_c('h2', [_vm._v("Privacy Policy")]), _vm._v(" "), _c('p', [_vm._v("Your privacy is important to us. It is Noctorus Studio's policy to respect your privacy regarding any information we may collect from you across our website, https://noctorus.studio.")]), _vm._v(" "), _c('p', [_vm._v("We don’t ask for your personal information unless we truly need it. When we do, we’ll only collect what we need by fair and lawful means and, where appropriate, with your knowledge or consent. We’ll also let you know why we’re collecting it and how it will be used.")]), _vm._v(" "), _c('p', [_vm._v("We don’t share your personal information with third-parties, except where required by law. We will only retain personal information for as long as necessary to provide you with a service.")]), _vm._v(" "), _c('p', [_vm._v("We don’t store your personal information on our servers unless it’s required for providing a service to you. What we store, we’ll protect within commercially acceptable means to protect your personal information from loss or theft, as well as unauthorized access, disclosure, copying, use or modification.")])])
}]}

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-dynamix"
  }, [(!_vm.isPrint && !_vm.noPrint) ? _c('div', {
    staticClass: "columns is-gapless is-centered is-multiline",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "column is-12 has-text-right"
  }, [(!_vm.isIE) ? _c('a', {
    attrs: {
      "href": ('/' + _vm.$route.name + '?type=' + _vm.type + '&print=true'),
      "target": "_blank"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Printer Friendly")]), _vm._v("  \n        "), _c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "width": "18px",
      "vertical-align": "middle"
    },
    attrs: {
      "src": __webpack_require__(321),
      "width": "18"
    }
  })]) : _c('a', {
    attrs: {
      "href": _vm.isPrintPdf,
      "target": "_blank"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "11px"
    }
  }, [_vm._v("Printer Friendly")]), _vm._v("  \n        "), _c('img', {
    staticClass: "img-responsive",
    staticStyle: {
      "width": "18px",
      "vertical-align": "middle"
    },
    attrs: {
      "src": __webpack_require__(321),
      "width": "18"
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless is-centered is-multiline",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "column",
      class: [{
        'is-12': !item.attributes.column
      }, item.attributes.column]
    }, [_c('div', {
      staticClass: "field"
    }, [_c('div', {
      staticClass: "control has-icons-right"
    }, [((item.attributes.type === 'checkbox' || item.attributes.type === 'radio')) ? _c('p', {
      staticClass: "label"
    }, [(item.attributes.title && !item.attributes.withDefault && !item.attributes.titleHidden) ? _c('span', [_vm._v("\n              " + _vm._s(item.attributes.title + (_vm.vuelidate.models[item.name].$params.hasOwnProperty('required') || _vm.vuelidate.models[item.name].$params.hasOwnProperty('required_custom') ? ' *' : '')) + "\n            ")]) : _vm._e(), _vm._v(" "), (item.attributes.type === 'checkbox' && item.attributes.withDefault === true) ? _c('label', {
      staticClass: "label default",
      class: [item.attributes.type]
    }, [(!item.attributes.withDefaultHideInput) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.models[item.name]),
        expression: "models[item.name]"
      }],
      attrs: {
        "type": "checkbox",
        "name": [item.name]
      },
      domProps: {
        "checked": Array.isArray(_vm.models[item.name]) ? _vm._i(_vm.models[item.name], null) > -1 : (_vm.models[item.name])
      },
      on: {
        "clicked": function($event) {
          item.attributes.onChecked()
        },
        "__c": function($event) {
          var $$a = _vm.models[item.name],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.models[item.name] = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.models[item.name] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(_vm.models, item.name, $$c)
          }
        }
      }
    }) : _vm._e(), _vm._v("\n              " + _vm._s(item.attributes.title + (_vm.vuelidate.models[item.name].$params.required ? ' *' : '')) + "\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (item.attributes.type === 'dropdown') ? _c('div', {
      staticClass: "select"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.models[item.name]),
        expression: "models[item.name]"
      }],
      class: [{
        'is-danger': _vm.vuelidate.models[item.name].$dirty && (_vm.models[item.name] == undefined || _vm.models[item.name] == 0 || _vm.models[item.name].length <= 0) && (_vm.vuelidate.models[item.name].$params.required && !_vm.vuelidate.models[item.name].required)
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.models, item.name, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((item.attributes.options), function(option) {
      return _c('option', {
        domProps: {
          "value": option.value
        }
      }, [_vm._v("\n                " + _vm._s(option.value !== undefined ? option.title : (option.title + (_vm.vuelidate.models[item.name].$params.required ? ' *' : ''))) + "\n              ")])
    }))]) : (item.attributes.type === 'checkbox' || item.attributes.type === 'radio') ? _vm._l((item.attributes.options), function(option) {
      return _c('label', {
        class: [item.attributes.type]
      }, [(item.attributes.type === 'checkbox') ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.models[item.name][option.value]),
          expression: "models[item.name][option.value]"
        }],
        attrs: {
          "type": "checkbox",
          "name": [item.name + '-' + item.value]
        },
        domProps: {
          "checked": Array.isArray(_vm.models[item.name][option.value]) ? _vm._i(_vm.models[item.name][option.value], null) > -1 : (_vm.models[item.name][option.value])
        },
        on: {
          "clicked": function($event) {
            item.attributes.onChecked()
          },
          "__c": function($event) {
            var $$a = _vm.models[item.name][option.value],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.models[item.name][option.value] = $$a.concat([$$v]))
              } else {
                $$i > -1 && (_vm.models[item.name][option.value] = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.$set(_vm.models[item.name], option.value, $$c)
            }
          }
        }
      }) : (item.attributes.type === 'radio') ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.models[item.name]),
          expression: "models[item.name]"
        }],
        attrs: {
          "type": "radio",
          "name": [item.name + '-' + item.value]
        },
        domProps: {
          "value": option.value,
          "checked": _vm._q(_vm.models[item.name], option.value)
        },
        on: {
          "__c": function($event) {
            _vm.$set(_vm.models, item.name, option.value)
          }
        }
      }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(option.title))])])
    }) : (item.attributes.type === 'textarea') ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (_vm.models[item.name]),
        expression: "models[item.name]",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "textarea",
      class: [{
        'is-danger': _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$dirty
      }],
      attrs: {
        "placeholder": [item.attributes.title + (_vm.vuelidate.models[item.name].$params.required ? ' *' : '')],
        "maxlength": item.attributes.maxLength
      },
      domProps: {
        "value": (_vm.models[item.name])
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.models, item.name, $event.target.value.trim())
        }, function($event) {
          if (item.attributes.onInput) { item.attributes.onInput(_vm.models[item.name], item.attributes); }
        }],
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }) : (item.attributes.type === 'text') ? _c('label', {
      class: [item.attributes.type]
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.models[item.name]),
        expression: "models[item.name]"
      }],
      staticClass: "input",
      class: [{
        'is-danger': _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$dirty
      }],
      attrs: {
        "placeholder": [item.attributes.title + (_vm.vuelidate.models[item.name].$params.required ? ' *' : '')],
        "disabled": item.attributes.disabled
      },
      domProps: {
        "value": (_vm.models[item.name])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.models, item.name, $event.target.value)
        }
      }
    })]) : (item.attributes.type === 'label') ? _c('p', {
      staticClass: "label"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.attributes.title)
      }
    }, [_vm._v(_vm._s(item.attributes.title))])]) : (item.attributes.type === 'image') ? _c('p', {
      staticClass: "image-wrapper",
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('a', {
      attrs: {
        "href": item.attributes.link,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": item.attributes.link
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "gray",
        "font-size": "0.8em"
      }
    }, [_vm._v("(click to view in new tab)")])])]) : (item.attributes.type === 'upload') ? _c('p', {
      staticClass: "upload-wrapper",
      staticStyle: {
        "text-align": "center"
      }
    }, [(!_vm.isRerender) ? _c('form-upload', {
      attrs: {
        "vuelidate": _vm.vuelidate,
        "is-dirty": _vm.vuelidate.models[item.name].dirty,
        "is-required": _vm.vuelidate.models[item.name].required
      },
      on: {
        "files-changed": _vm.onFilesChanged,
        "files-error": _vm.onFilesError
      },
      model: {
        value: (_vm.models[item.name]),
        callback: function($$v) {
          _vm.$set(_vm.models, item.name, $$v)
        },
        expression: "models[item.name]"
      }
    }) : _vm._e()], 1) : _c('p', {
      staticClass: "label-invalid"
    }, [_vm._v("\n            Invalid field.\n          ")]), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid) ? _c('span', {
      staticClass: "icon is-small is-right is-danger"
    }, [_c('i', {
      staticClass: "fa fa-warning"
    })]) : _vm._e(), _vm._v(" "), (item.attributes.type === 'text-area') ? _c('small', {
      staticClass: "help counter"
    }, [_vm._v(_vm._s(item.attributes.curLength) + " / " + _vm._s(item.attributes.maxLength))]) : _vm._e(), _vm._v(" "), (item.attributes.note) ? _c('p', {
      staticClass: "help is-note",
      domProps: {
        "innerHTML": _vm._s(item.attributes.note)
      }
    }) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.required && !_vm.vuelidate.models[item.name].required) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("\"" + _vm._s(item.attributes.title) + "\" is required.")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.numeric && !_vm.vuelidate.models[item.name].numeric) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("\"" + _vm._s(item.attributes.title) + "\" must be numeric value.")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.between && !_vm.vuelidate.models[item.name].between) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("\"" + _vm._s(item.attributes.title) + "\" must be between " + _vm._s(_vm.vuelidate.models[item.name].$params.between.min) + " and " + _vm._s(_vm.vuelidate.models[item.name].$params.between.max) + ".")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.minLength && !_vm.vuelidate.models[item.name].minLength) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("\"" + _vm._s(item.attributes.title) + "\" is too short.")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.maxLength && !_vm.vuelidate.models[item.name].maxLength) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("\"" + _vm._s(item.attributes.title) + "\" is too long.")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.email && !_vm.vuelidate.models[item.name].email) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(item.attributes.title) + " is invalid.")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.hasOwnProperty('required_custom') && !_vm.vuelidate.models[item.name].required_custom) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("\"" + _vm._s(item.attributes.title) + "\" selection with at least one option.")]) : _vm._e(), _vm._v(" "), (_vm.vuelidate.models[item.name].$dirty && _vm.vuelidate.models[item.name].$invalid && _vm.vuelidate.models[item.name].$params.hasOwnProperty('either_custom') && !_vm.vuelidate.models[item.name].either_custom) ? _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v("\"" + _vm._s(item.attributes.title) + "\" selection with conflicting option, please revise.")]) : _vm._e()], 2)])])
  })), _vm._v(" "), (!_vm.isPrint) ? _c('b-field', {
    staticStyle: {
      "width": "100%",
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless is-flex-mobile is-vcentered"
  }, [_c('div', {
    staticClass: "column captcha-image-wrapper"
  }, [(!_vm.isRerender) ? _c('vue-recaptcha', {
    attrs: {
      "sitekey": _vm.recaptchaKey
    },
    on: {
      "verify": _vm.onVerifyRecaptcha,
      "expired": _vm.onExpiredRecaptcha,
      "render": _vm.onRenderRecaptcha
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.models['recaptcha']),
      expression: "models['recaptcha']",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.models['recaptcha'])
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.models, 'recaptcha', $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), (_vm.vuelidate.models['recaptcha'] && _vm.vuelidate.models['recaptcha'].$dirty && _vm.vuelidate.models['recaptcha'].$invalid && _vm.vuelidate.models['recaptcha'].$params.required && !_vm.vuelidate.models['recaptcha'].required) ? _c('p', {
    staticClass: "help is-danger"
  }, [_vm._v("Invalid recaptcha.")]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (!_vm.isPrint) ? _c('b-field', {
    staticClass: "submit-wrapper"
  }, [_c('button', {
    staticClass: "control button is-outlined",
    class: {
      'is-loading': _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.onSend(_vm.vuelidate)
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.loading ? ' ' : 'SUBMIT'))])])]) : _vm._e(), _vm._v(" "), (_vm.feedback) ? _c('p', {
    staticClass: "help is-danger",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.feedback))]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 815 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [(false) ? _c('div', [_vm._m(0), _vm._v("\n          |  \n        "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://github.com/morph85"
    }
  }, [_vm._v("morph / "), _c('i', {
    staticClass: "fa fa-github",
    staticStyle: {
      "vertical-align": "middle"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "middle"
    },
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://ko-fi.com/A83439QF",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "border": "0px",
      "height": "26px"
    },
    attrs: {
      "height": "26",
      "src": "https://az743702.vo.msecnd.net/cdn/kofi2.png?v=0",
      "border": "0",
      "alt": "Buy Me a Coffee at ko-fi.com"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-wraper"
  }, [_c('div', {
    staticClass: "footer-block left brace",
    staticStyle: {
      "margin-right": "15px"
    }
  }, [_c('div', [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/noctorus.studio",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "https://www.twitter.com/noctorus",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "https://www.medium.com/@noctorus",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-medium"
  })])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "https://www.github.com/morph85",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-block left brace"
  }, [_c('span', {
    staticClass: "left-brace-tl"
  }), _vm._v(" "), _c('span', {
    staticClass: "left-brace-tr"
  }), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "left-brace-bl"
  }), _vm._v(" "), _c('span', {
    staticClass: "left-brace-br"
  })]), _vm._v(" "), _c('div', {
    staticClass: "footer-block left"
  }, [_c('i', {
    staticClass: "ficon fa fa-code"
  }), _vm._v(" "), _c('div', {
    staticClass: "fname"
  }, [_c('strong', [_vm._v("noctorus")]), _vm._v(" © 2017.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "footer-block right"
  }, [_c('div', [_c('a', {
    attrs: {
      "href": "/privacy"
    }
  }, [_vm._v("Privacy Policy")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "/terms"
    }
  }, [_vm._v("Terms of Service")])])])])
}]}

/***/ }),
/* 816 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('span', [_vm._t("default")], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.animation
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "my-dropdown-dd",
    style: (_vm.ddStyle)
  }, [_vm._t("dropdown")], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 817 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "side-bar"
  }, [_c('aside', {
    staticClass: "menu"
  }, [_c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n      Admin\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, [_c('li', [_c('router-link', {
    class: {
      'is-active': _vm.$route.name === 'dashboard'
    },
    attrs: {
      "to": "dashboard"
    }
  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    class: {
      'is-active': _vm.$route.name === 'users'
    },
    attrs: {
      "to": "users"
    }
  }, [_vm._v("Users")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    class: {
      'is-active': _vm.$route.name === 'projects'
    },
    attrs: {
      "to": "projects"
    }
  }, [_vm._v("Projects")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n      Debug\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, [_c('li', [_c('router-link', {
    class: {
      'is-active': _vm.$route.name === 'blogs'
    },
    attrs: {
      "to": "blogs"
    }
  }, [_vm._v("Blogs")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    class: {
      'is-active': _vm.$route.name === 'components'
    },
    attrs: {
      "to": "components"
    }
  }, [_vm._v("Components")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 818 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-api-youtube"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column content"
  }, [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _c('div', {
    staticClass: "g-ytsubscribe",
    attrs: {
      "data-channel": "nadeemadamlobo",
      "data-layout": "default",
      "data-theme": "dark",
      "data-count": "hidden"
    }
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "subtitle",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_vm._v("\n          Request for Google Youtube.\n        ")]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v("\n          " + _vm._s(_vm.error) + "\n        ")]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title"
  }, [_vm._v("\n          Google Youtube API."), _c('br')])
}]}

/***/ }),
/* 819 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-wrapper",
    attrs: {
      "id": "tsection"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.toggle) ? _c('div', {
    staticClass: "active-nav"
  }, [_c('div', {
    staticClass: "link shorthand"
  }, [_vm._l((_vm.navMain), function(navItem) {
    return _c('div', {
      staticClass: "small-div"
    }, [_c('a', {
      staticClass: "div-link",
      class: {
        active: _vm.$route.name === navItem.name
      },
      attrs: {
        "href": [navItem.section ? '/?anchor=' + navItem.section : navItem.path]
      },
      on: {
        "click": function($event) {
          [navItem.section ? _vm.onScrollTo($event, 'landing', navItem.section) : (navItem.path ? '' : navItem.subnav ? _vm.onPressSubnav($event, navItem) : $event.preventDefault())]
        }
      }
    }, [_c('span', {
      staticClass: "link",
      staticStyle: {
        "display": "inline-block"
      }
    }, [_vm._v("\n            " + _vm._s(navItem.title) + "\n          ")]), _vm._v(" "), (navItem.subnav) ? _c('span', {
      staticStyle: {
        "display": "inline-block"
      }
    }, [_vm._v("\n             \n            "), (navItem.subnavOpen) ? _c('i', {
      staticClass: "fa fa-caret-down",
      staticStyle: {
        "vertical-align": "middle",
        "font-size": "1.2em"
      }
    }) : _vm._e(), _vm._v(" "), (!navItem.subnavOpen) ? _c('i', {
      staticClass: "fa fa-caret-right",
      staticStyle: {
        "vertical-align": "middle",
        "font-size": "1.2em"
      }
    }) : _vm._e()]) : _vm._e()]), _vm._v(" "), _vm._l((navItem.subnav), function(navSubItem, subindex) {
      return (navItem.subnav && navItem.subnavOpen === true) ? _c('div', {
        staticClass: "small-div-sub"
      }, [_c('a', {
        staticClass: "div-link",
        class: {
          active: _vm.$route.name === navSubItem.name
        },
        attrs: {
          "href": [navSubItem.section ? '/?anchor=' + navSubItem.section : navSubItem.path]
        },
        on: {
          "click": function($event) {
            [navSubItem.section ? _vm.onScrollTo($event, 'landing', navSubItem.section) : (navSubItem.path ? '' : $event.preventDefault())]
          }
        }
      }, [_c('span', {
        staticClass: "link",
        staticStyle: {
          "font-size": "0.9em"
        }
      }, [_vm._v("\n              " + _vm._s(navSubItem.title) + "\n            ")])]), ((subindex !== navItem.subnav.length - 1) && false) ? _c('span', {
        staticStyle: {
          "color": "white"
        }
      }, [_vm._v(" | ")]) : _vm._e()]) : _vm._e()
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "small-div"
  }, [_c('div', [_c('a', {
    staticClass: "elink",
    attrs: {
      "href": ['mailto:' + _vm.navEmail]
    }
  }, [_vm._v(_vm._s(_vm.navEmail))])])]), _vm._v(" "), _c('div', {
    staticClass: "small-div"
  }, [_c('div', {
    staticClass: "eicon"
  }, [(false) ? _c('a', {
    attrs: {
      "href": "https://www.facebook.com/",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.navFacebook.path,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("   / " + _vm._s(_vm.navFacebook.title))])])])], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "full-layer"
  }, [_c('navbar-full', {
    attrs: {
      "toggle": _vm.toggle
    },
    on: {
      "onToggle": function($event) {
        _vm.toggle = $event
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 820 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "field"
  }, [(false) ? _c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.placeholder))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "control has-icon has-icon-right"
  }, [(_vm.type === 'email') ? _c('input', {
    staticClass: "input",
    class: [_vm.name + '-input', {
      'is-danger': _vm.error
    }],
    attrs: {
      "type": "email",
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "required": _vm.required,
      "disabled": _vm.disabled,
      "autofocus": _vm.autofocus
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput
    }
  }) : (_vm.type === 'password') ? _c('input', {
    staticClass: "input",
    class: [_vm.name + '-input', {
      'is-danger': _vm.error
    }],
    attrs: {
      "type": "password",
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "required": _vm.required,
      "disabled": _vm.disabled,
      "autofocus": _vm.autofocus
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput
    }
  }) : _c('input', {
    staticClass: "input",
    class: [_vm.name + '-input', {
      'is-danger': _vm.error
    }],
    attrs: {
      "type": "text",
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "required": _vm.required,
      "disabled": _vm.disabled,
      "autofocus": _vm.autofocus
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "icon"
  }, [(false) ? _c('i', {
    staticClass: "fa",
    class: ['fa-' + _vm.fa],
    attrs: {
      "name": _vm.fa
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mdi !== undefined) ? _c('i', {
    staticClass: "material-icons"
  }, [_vm._v(_vm._s(_vm.mdi))]) : _vm._e()]), _vm._v(" "), (_vm.error) ? _c('form-error', {
    attrs: {
      "error": _vm.error
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "app"
    }
  }, [_c('navbar-overlay'), _vm._v(" "), _c('router-view', {
    staticClass: "page-wrapper"
  }), _vm._v(" "), _c('footer-main'), _vm._v(" "), _c('fb-chat-now')], 1)
},staticRenderFns: []}

/***/ }),
/* 822 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-api-places"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n          Google Places API.\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_vm._v("\n          Request for Google Places search & Google Street View images.\n        ")]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v("\n          " + _vm._s(_vm.error) + "\n        ")]) : _vm._e()])])])])
},staticRenderFns: []}

/***/ }),
/* 823 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fblogin-container"
  }, [(_vm.logged == 'cancelled') ? _c('div', [_vm._t("cancelled"), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n  \t\t\tFacebook Login\n  \t\t")])], 2) : (_vm.logged == 'not_logged') ? _c('div', [_vm._t("check-login", [_vm._v("\n  \t\t\tconnecting with facebook...\n  \t\t")])], 2) : (_vm.logged == 'logged') ? _c('div', [_vm._t("logged", [_vm._v("\n        already logged in...\n  \t\t")])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fb-send-to-messenger",
    staticStyle: {
      "display": "inherit"
    },
    attrs: {
      "id": "fb-send-to-messenger",
      "messenger_app_id": "782732588553167",
      "page_id": "418381418548219",
      "data-ref": "PASS_THROUGH_PARAM",
      "color": "white",
      "size": "standard"
    }
  }, [_vm._v("\n      subscribe chat bot\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "fb-like",
    attrs: {
      "data-href": "https://noctorus.studio/",
      "data-layout": "button",
      "data-action": "like",
      "data-size": "large",
      "data-show-faces": "true",
      "data-share": "false"
    }
  }, [_vm._v("\n      like button\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 824 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section-comment container",
    staticStyle: {
      "padding-top": "15px"
    },
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true",
      "data-aos-duration": "100"
    }
  }, [_c('div', {
    staticClass: "columns is-gapless"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column has-text-centered"
  }, [_c('vue-disqus', {
    staticStyle: {
      "padding": "10px",
      "padding-bottom": "15px"
    },
    attrs: {
      "shortname": "noctorus"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column has-text-centered"
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 10px 15px"
    }
  }, [_c('div', {
    staticClass: "fb-comments",
    attrs: {
      "data-href": "https://noctorus.studio",
      "data-width": "100%",
      "data-colorscheme": "dark",
      "data-numposts": "5"
    }
  })])])
}]}

/***/ }),
/* 825 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-notfound"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "hero is-medium is-primary",
    staticStyle: {
      "background-color": "gray",
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container has-text-centered"
  }, [_c('h1', [_vm._v("\n            Uh oh,\n          ")]), _vm._v(" "), _c('h2', [_vm._v("\n            404 - Page Not Found\n          ")])])])])])])
}]}

/***/ }),
/* 826 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "terms-of-service container"
  }, [_c('h2', [_vm._v("Noctorus Studio Terms of Service & Privacy Policy")]), _vm._v(" "), _c('h3', [_vm._v("1. Terms")]), _vm._v(" "), _c('p', [_vm._v("By accessing the website at "), _c('a', {
    attrs: {
      "href": "https://noctorus.studio"
    }
  }, [_vm._v("https://noctorus.studio")]), _vm._v(", you are agreeing to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site. The materials contained in this website are protected by applicable copyright and trademark law.")]), _vm._v(" "), _c('h3', [_vm._v("2. Use License")]), _vm._v(" "), _c('ol', {
    attrs: {
      "type": "a"
    }
  }, [_c('li', [_vm._v("Permission is granted to temporarily download one copy of the materials (information or software) on Noctorus Studio's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:\n     "), _c('ol', {
    attrs: {
      "type": "i"
    }
  }, [_c('li', [_vm._v("modify or copy the materials;")]), _vm._v(" "), _c('li', [_vm._v("use the materials for any commercial purpose, or for any public display (commercial or non-commercial);")]), _vm._v(" "), _c('li', [_vm._v("attempt to decompile or reverse engineer any software contained on Noctorus Studio's website;")]), _vm._v(" "), _c('li', [_vm._v("remove any copyright or other proprietary notations from the materials; or")]), _vm._v(" "), _c('li', [_vm._v("transfer the materials to another person or \"mirror\" the materials on any other server.")])])]), _vm._v(" "), _c('li', [_vm._v("This license shall automatically terminate if you violate any of these restrictions and may be terminated by Noctorus Studio at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in electronic or printed format.")])]), _vm._v(" "), _c('h3', [_vm._v("3. Disclaimer")]), _vm._v(" "), _c('ol', {
    attrs: {
      "type": "a"
    }
  }, [_c('li', [_vm._v("The materials on Noctorus Studio's website are provided on an 'as is' basis. Noctorus Studio makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.")]), _vm._v(" "), _c('li', [_vm._v("Further, Noctorus Studio does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.")])]), _vm._v(" "), _c('h3', [_vm._v("4. Limitations")]), _vm._v(" "), _c('p', [_vm._v("In no event shall Noctorus Studio or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Noctorus Studio's website, even if Noctorus Studio or a Noctorus Studio authorized representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.")]), _vm._v(" "), _c('h3', [_vm._v("5. Accuracy of materials")]), _vm._v(" "), _c('p', [_vm._v("The materials appearing on Noctorus Studio website could include technical, typographical, or photographic errors. Noctorus Studio does not warrant that any of the materials on its website are accurate, complete or current. Noctorus Studio may make changes to the materials contained on its website at any time without notice. However Noctorus Studio does not make any commitment to update the materials.")]), _vm._v(" "), _c('h3', [_vm._v("6. Links")]), _vm._v(" "), _c('p', [_vm._v("Noctorus Studio has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Noctorus Studio of the site. Use of any such linked website is at the user's own risk.")]), _vm._v(" "), _c('h3', [_vm._v("7. Modifications")]), _vm._v(" "), _c('p', [_vm._v("Noctorus Studio may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.")]), _vm._v(" "), _c('h3', [_vm._v("8. Governing Law")]), _vm._v(" "), _c('p', [_vm._v("These terms and conditions are governed by and construed in accordance with the laws of Puchong, Malaysia and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.")]), _vm._v(" "), _c('h2', [_vm._v("Privacy Policy")]), _vm._v(" "), _c('p', [_vm._v("Your privacy is important to us. It is Noctorus Studio's policy to respect your privacy regarding any information we may collect from you across our website, https://noctorus.studio.")]), _vm._v(" "), _c('p', [_vm._v("We don’t ask for your personal information unless we truly need it. When we do, we’ll only collect what we need by fair and lawful means and, where appropriate, with your knowledge or consent. We’ll also let you know why we’re collecting it and how it will be used.")]), _vm._v(" "), _c('p', [_vm._v("We don’t share your personal information with third-parties, except where required by law. We will only retain personal information for as long as necessary to provide you with a service.")]), _vm._v(" "), _c('p', [_vm._v("We don’t store your personal information on our servers unless it’s required for providing a service to you. What we store, we’ll protect within commercially acceptable means to protect your personal information from loss or theft, as well as unauthorized access, disclosure, copying, use or modification.")])])
}]}

/***/ }),
/* 827 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    },
    style: ([{
      backgroundColor: (_vm.backgroundColor ? _vm.backgroundColor : undefined)
    }])
  }, [_c('div', {
    staticClass: "div-container container",
    class: [{
      'is-fluid': _vm.full === 'true'
    }],
    style: ([{
      paddingTop: (_vm.paddingTop ? _vm.paddingTop : undefined),
      paddingBottom: (_vm.paddingBottom ? _vm.paddingBottom : undefined)
    }])
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered"
  }, [_c('div', {
    staticClass: "column",
    class: [{
      'is-10': _vm.full !== 'true' && !_vm.columnNum
    }, _vm.columnNum]
  }, [_vm._t("default")], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 828 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero is-primary section-project-list",
    attrs: {
      "id": "section-project-list"
    }
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "width": "100%"
    }
  }, [_c('gallery-dynamix')], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "width": "100%",
      "display": "none"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("web works")]), _vm._v(" "), _c('ul', _vm._l((_vm.workList), function(work) {
    return _c('li', {
      staticStyle: {
        "margin-bottom": "3em"
      }
    }, [_c('a', {
      attrs: {
        "href": work.link,
        "target": "_blank"
      }
    }, [_c('h2', {
      staticStyle: {
        "margin-bottom": "1em"
      }
    }, [_vm._v(_vm._s(work.name))]), _vm._v(" "), _c('img', {
      staticStyle: {
        "max-width": "240px",
        "padding": "15px",
        "border-radius": "3px",
        "background-color": "rgba(255,255,255,0.7)"
      },
      attrs: {
        "src": work.logo,
        "data-pin-nopin": "true"
      }
    })])])
  }))])])])
},staticRenderFns: []}

/***/ }),
/* 829 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero section-quote",
    attrs: {
      "id": "section-quote"
    }
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns is-centered"
  }, [_c('div', {
    staticClass: "column box section is-5 has-text-centered section-quote-box"
  }, [_c('p', {
    staticStyle: {
      "padding": "30px"
    }
  }, [_vm._v(_vm._s(_vm.quoteContent)), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-right": "10px"
    },
    attrs: {
      "title": "Refresh quote"
    },
    on: {
      "click": function($event) {
        _vm.refreshQuote()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    staticStyle: {
      "vertical-align": "middle"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.quoteContentUrl,
      "target": "_blank",
      "title": "Tweet this quote!"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter",
    staticStyle: {
      "vertical-align": "middle"
    }
  })])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 830 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "help is-danger has-text-left"
  }, _vm._l((_vm.infos), function(info) {
    return _c('li', [_vm._v(_vm._s(info.message))])
  }))
},staticRenderFns: []}

/***/ }),
/* 831 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gallery-dynamix"
  }, [_c('div', {
    staticClass: "gallery-container",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_vm._l((_vm.segments), function(segment, segmentIndex) {
    return _c('div', {
      staticClass: "tile is-ancestor"
    }, [(segment.selection === 0) ? _c('div', {
      staticClass: "tile is-parent tx_type_0"
    }, _vm._l((segment.items), function(item) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    })) : (segment.selection === 1 || segment.selection === 2) ? _c('div', {
      staticClass: "tile is-parent tx_type_1-2"
    }, _vm._l((segment.items), function(item, index) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h",
        class: {
          'is-4 tx_full_h1': (segment.selection === 1 && index == 0) || (segment.selection === 2 && index == 1),
          'is-8 tx_full_h3': (segment.selection === 1 && index == 1) || (segment.selection === 2 && index == 0)
        }
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    })) : (segment.selection === 3 || segment.selection === 5) ? _c('div', {
      staticClass: "tile is-parent tx_type_3or5"
    }, [_vm._l(([segment.items[0]]), function(item) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h",
        class: {
          'is-4 tx_full_h2': segment.selection === 3, 'is-8 tx_full_h1': segment.selection === 5
        }
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    }), _vm._v(" "), _c('div', {
      staticClass: "tile is-vertical",
      class: {
        'is-4': segment.selection === 5, 'is-8': segment.selection === 3
      }
    }, [_vm._l(([segment.items[1]]), function(item) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h3"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    }), _vm._v(" "), _vm._l(([segment.items[2]]), function(item) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h3"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    })], 2)], 2) : (segment.selection === 4 || segment.selection === 6) ? _c('div', {
      staticClass: "tile is-parent tx_type_4or6"
    }, [_c('div', {
      staticClass: "tile is-vertical",
      class: {
        'is-8': segment.selection === 4, 'is-4': segment.selection === 6
      }
    }, [_vm._l(([segment.items[0]]), function(item) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h3"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    }), _vm._v(" "), _vm._l(([segment.items[1]]), function(item) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h3"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    })], 2), _vm._v(" "), _vm._l(([segment.items[2]]), function(item) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h",
        class: {
          'is-8 tx_full_h1': segment.selection === 6, 'is-4 tx_full_h2': segment.selection === 4
        }
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    })], 2) : (segment.selection >= 7 && segment.selection <= 10) ? _c('div', {
      staticClass: "tile is-parent tx_type_7to10"
    }, [_vm._l(([segment.items[3]]), function(item) {
      return (segment.selection === 9 || segment.selection === 10) ? _c('div', {
        staticClass: "tile is-child is-4 tx_full_h tx_full_h2"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "tile is-vertical is-8"
    }, [_vm._l(([segment.items[0]]), function(item) {
      return (segment.selection === 7 || segment.selection === 9) ? _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h3"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "tile is-parent"
    }, [_vm._l(([segment.items[1]]), function(item) {
      return _c('div', {
        staticClass: "tile is-child is-6 tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    }), _vm._v(" "), _vm._l(([segment.items[2]]), function(item) {
      return _c('div', {
        staticClass: "tile is-child is-6 tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    })], 2), _vm._v(" "), _vm._l(([segment.items[0]]), function(item) {
      return (segment.selection === 8 || segment.selection === 10) ? _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h3"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])]) : _vm._e()
    })], 2), _vm._v(" "), _vm._l(([segment.items[3]]), function(item) {
      return (segment.selection === 7 || segment.selection === 8) ? _c('div', {
        staticClass: "tile is-child is-4 tx_full_h tx_full_h2"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])]) : _vm._e()
    })], 2) : (segment.selection >= 11 && segment.selection <= 13) ? _c('div', {
      staticClass: "tile is-parent tx_type_11to13"
    }, [_vm._l(([segment.items[4]]), function(item) {
      return (segment.selection === 12) ? _c('div', {
        staticClass: "tile is-child is-4 tx_full_h tx_full_h2"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "tile is-vertical is-4 segment-11"
    }, [_vm._l(([segment.items[0]]), function(item) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    }), _vm._v(" "), _vm._l(([segment.items[1]]), function(item) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    })], 2), _vm._v(" "), _vm._l(([segment.items[4]]), function(item) {
      return (segment.selection === 13) ? _c('div', {
        staticClass: "tile is-child is-4 tx_full_h tx_full_h2"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "tile is-vertical is-4"
    }, [_vm._l(([segment.items[2]]), function(item) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    }), _vm._v(" "), _vm._l(([segment.items[3]]), function(item) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    })], 2), _vm._v(" "), _vm._l(([segment.items[4]]), function(item) {
      return (segment.selection === 11) ? _c('div', {
        staticClass: "tile is-child is-4 tx_full_h tx_full_h2"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])]) : _vm._e()
    })], 2) : _c('div', {
      staticClass: "tile is-parent"
    }, _vm._l((segment.items), function(item) {
      return _c('div', {
        staticClass: "tile is-child is-4 tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": item.url_1,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + item.image.path + ')'
        })
      })])])
    }))])
  }), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v("\n      " + _vm._s(_vm.error) + "\n    ")]) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 832 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-blogs"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_c('div', [_c('slick', {
    ref: "slick",
    attrs: {
      "options": _vm.slickOptions
    }
  }, [_c('a', {
    attrs: {
      "href": "http://placehold.it/2000x1000"
    }
  }, [_c('img', {
    attrs: {
      "src": "http://placehold.it/2000x1000",
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://placehold.it/2000x1000"
    }
  }, [_c('img', {
    attrs: {
      "src": "http://placehold.it/2000x1000",
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://placehold.it/2000x1000"
    }
  }, [_c('img', {
    attrs: {
      "src": "http://placehold.it/2000x1000",
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://placehold.it/2000x1000"
    }
  }, [_c('img', {
    attrs: {
      "src": "http://placehold.it/2000x1000",
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://placehold.it/2000x1000"
    }
  }, [_c('img', {
    attrs: {
      "src": "http://placehold.it/2000x1000",
      "alt": ""
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://placehold.it/2000x1000"
    }
  }, [_c('img', {
    attrs: {
      "src": "http://placehold.it/2000x1000",
      "alt": ""
    }
  })])])], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column content",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Blogs")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Describing Blogs")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('article', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('figure', {
    staticClass: "image is-64x64"
  }, [_c('img', {
    attrs: {
      "src": "http://bulma.io/images/placeholders/128x128.png",
      "alt": "Image"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_c('strong', [_vm._v("John Smith")]), _vm._v(" "), _c('small', [_vm._v("@johnsmith")]), _vm._v(" "), _c('small', [_vm._v("31m")]), _vm._v(" "), _c('br'), _vm._v("\n            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean efficitur sit amet massa fringilla egestas. Nullam condimentum luctus turpis.\n          ")])]), _vm._v(" "), _c('nav', {
    staticClass: "level is-mobile"
  }, [_c('div', {
    staticClass: "level-left"
  }, [_c('a', {
    staticClass: "level-item",
    staticStyle: {
      "padding": "5px",
      "padding-left": "0px"
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("reply")])])]), _vm._v(" "), _c('a', {
    staticClass: "level-item",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("share")])])]), _vm._v(" "), _c('a', {
    staticClass: "level-item",
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("favorite")])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column content"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('ul', [_c('li', {
    staticClass: "is-active"
  }, [_c('a', [_vm._v("Featured")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("Most Popular")])]), _vm._v(" "), _c('li', [_c('a', [_vm._v("Most Viewed")])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('div', {
    staticClass: "tile is-child"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image is-4by3"
  }, [_c('img', {
    attrs: {
      "src": "http://bulma.io/images/placeholders/1280x960.png",
      "alt": "Image"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-left"
  }, [_c('figure', {
    staticClass: "image is-64x64"
  }, [_c('img', {
    attrs: {
      "src": "http://bulma.io/images/placeholders/96x96.png",
      "alt": "Image"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v("John Smith")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("@johnsmith")])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("\n              This is a card design, no lorem ipsum anymore! consectetur adipiscing elit.\n              Phasellus nec iaculis mauris. "), _c('a', [_vm._v("@bulmaio")]), _vm._v(".\n              "), _c('a', [_vm._v("#css")]), _vm._v(" "), _c('a', [_vm._v("#responsive")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("11:09 PM - 1 Jan 2016")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent"
  }, [_c('div', {
    staticClass: "tile is-child box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Two")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Describing Two")])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-6 is-parent"
  }, [_c('div', {
    staticClass: "tile is-child box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Three")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Describing Three")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-6 is-parent"
  }, [_c('div', {
    staticClass: "tile is-child box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Four")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Describing Four")])])]), _vm._v(" "), _c('div', {
    staticClass: "tile"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('div', {
    staticClass: "tile is-child box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Five")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Describing Five")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tile is-parent"
  }, [_c('div', {
    staticClass: "tile is-child box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Six")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Describing Six")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('div', {
    staticClass: "tile is-child box"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("Seven")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Describing Seven")])])])])
}]}

/***/ }),
/* 833 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "div-columns",
    style: (_vm.divStyle)
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered"
  }, [_c('div', {
    staticClass: "column content",
    class: [{
      'is-11': _vm.full !== 'true' && !_vm.columnNum
    }, _vm.columnNum],
    style: ([{
      paddingTop: (_vm.paddingTop ? _vm.paddingTop : undefined),
      paddingBottom: (_vm.paddingBottom ? _vm.paddingBottom : undefined),
      backgroundColor: (_vm.backgroundColor ? _vm.backgroundColor : undefined),
      textAlign: (_vm.textAlign ? _vm.textAlign : undefined)
    }])
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}

/***/ }),
/* 834 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 835 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-projects"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n        Projects.\n      ")]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('b-table', {
    attrs: {
      "data": _vm.tableData,
      "bordered": _vm.isBordered,
      "striped": _vm.isStriped,
      "narrowed": _vm.isNarrowed,
      "checkable": _vm.isCheckable,
      "loading": _vm.isLoading,
      "mobile-cards": _vm.hasMobileCards,
      "paginated": _vm.isPaginated,
      "per-page": 50,
      "pagination-simple": true,
      "default-sort": "user.first_name",
      "selected": _vm.selected,
      "checked-rows": _vm.checkedRows
    },
    on: {
      "update:selected": function($event) {
        _vm.selected = $event
      },
      "update:checkedRows": function($event) {
        _vm.checkedRows = $event
      }
    }
  }, [
    [_c('b-table-column', {
      attrs: {
        "field": "id",
        "label": "ID",
        "width": "40",
        "sortable": "",
        "numeric": ""
      }
    }, [_vm._v("\n            " + _vm._s(_vm.props.row.id) + "\n          ")]), _vm._v(" "), _c('b-table-column', {
      attrs: {
        "field": "name",
        "label": "Name",
        "sortable": ""
      }
    }, [_vm._v("\n            " + _vm._s(_vm.props.row.name) + "\n          ")]), _vm._v(" "), _c('b-table-column', {
      attrs: {
        "field": "description",
        "label": "Description",
        "sortable": ""
      }
    }, [_vm._v("\n            " + _vm._s(_vm.props.row.description) + "\n          ")]), _vm._v(" "), _c('b-table-column', {
      attrs: {
        "field": "sort",
        "label": "Sort",
        "sortable": ""
      }
    }, [_vm._v("\n              " + _vm._s(_vm.props.row.sort) + "\n            ")]), _vm._v(" "), _c('b-table-column', {
      attrs: {
        "field": "status",
        "label": "Status",
        "sortable": ""
      }
    }, [_c('b-icon', {
      attrs: {
        "pack": "mdi",
        "icon": _vm.props.row.status ? 'done' : 'close'
      }
    })], 1), _vm._v(" "), _c('b-table-column', {
      attrs: {
        "field": "edit",
        "label": "Edit",
        "sortable": ""
      }
    }, [_c('b-icon', {
      attrs: {
        "pack": "mdi",
        "icon": _vm.props.row.status ? 'done' : 'close'
      }
    })], 1)], _vm._v(" "), _c('div', {
      staticClass: "has-text-centered",
      attrs: {
        "slot": "empty"
      },
      slot: "empty"
    }, [_c('span', {
      staticStyle: {
        "color": "#ccc"
      }
    }, [_vm._v("Table contains nothing.")])])
  ], 2)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 836 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel-slick slick-wrapper",
    attrs: {
      "id": "carousel-slick"
    }
  }, [_c('slick', {
    ref: "slick",
    attrs: {
      "options": _vm.slickOptions
    }
  }, _vm._l((_vm.images), function(image) {
    return _c('lightbox', {
      key: image.title,
      attrs: {
        "caption": image.title,
        "src": image.src,
        "album": image.album
      }
    }, [_c('img', {
      attrs: {
        "src": image.src
      }
    })])
  }))], 1)
},staticRenderFns: []}

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fbchatnow-container"
  }, [_c('button', {
    staticClass: "f-button",
    class: _vm.fButtonClass,
    staticStyle: {
      "color": "rgb(255, 255, 255)",
      "background": "rgb(0, 0, 0)"
    },
    on: {
      "click": _vm.onCountDownSlideUp
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "f-title"
  }, [_vm._v("Need help?")])]), _vm._v(" "), _c('div', {
    staticClass: "f-box",
    style: (_vm.fBoxStyle)
  }, [_c('button', {
    staticClass: "f-close",
    staticStyle: {
      "border-color": "#000000"
    },
    on: {
      "click": _vm.onCountDownSlideDown
    }
  }, [_vm._v("x")]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "fb-messengermessageus",
    staticStyle: {
      "font-size": "0.6em"
    },
    attrs: {
      "messenger_app_id": "782732588553167",
      "page_id": "418381418548219",
      "color": "white",
      "size": "standard"
    }
  }, [_vm._v("\n      message us at https://www.facebook.com/noctorus.studio.\n    ")]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "f-icon"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(735),
      "alt": "Facebook Chat"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "border": "3px solid rgb(0, 0, 0)",
      "min-width": "290px",
      "min-height": "350px",
      "width": "auto",
      "height": "auto"
    },
    attrs: {
      "id": "fb-livechat-page"
    }
  }, [_c('div', {
    staticClass: "fb-page fb_iframe_widget",
    attrs: {
      "data-tabs": "messages",
      "data-height": "350",
      "data-width": "290",
      "data-href": "https://www.facebook.com/noctorus.studio",
      "data-small-header": "true",
      "data-adapt-container-width": "false",
      "data-hide-cover": "false",
      "data-show-facepile": "false",
      "data-show-posts": "false",
      "fb-xfbml-state": "rendered",
      "fb-iframe-plugin-query": "adapt_container_width=false&app_id=&container_width=290&height=350&hide_cover=false&href=https%3A%2F%2Fwww.facebook.com%2Fnoctorus.studio&locale=en_US&sdk=joey&show_facepile=false&show_posts=false&small_header=true&tabs=messages&width=290"
    }
  })])
}]}

/***/ }),
/* 838 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-layout-gallery"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n      Dynamic Gallery.\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle",
    staticStyle: {
      "margin-top": "15px",
      "margin-bottom": "30px"
    }
  }, [_vm._v("\n      Creating a customized dynamic grid system using Vue + Bulma's flex tile layout. "), _c('br'), _vm._v("\n      Inspiration from simplex-d site by utilizing pagejoint.com's layout engine & reverse engineered "), _c('i', {
    staticClass: "material-icons color-orange"
  }, [_vm._v("favorite")]), _vm._v(" the CSS layout."), _c('br'), _vm._v("\n      Click button below to see the difference!"), _c('br'), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "button is-white",
    on: {
      "click": function($event) {
        _vm.refresh()
      }
    }
  }, [_vm._v("Refresh")])])]), _vm._v(" "), _c('div', {
    staticClass: "container gallery-container",
    staticStyle: {
      "margin-bottom": "50px"
    }
  }, [_vm._l((_vm.segments), function(segment, segmentIndex) {
    return _c('div', {
      staticClass: "tile is-ancestor"
    }, [(segment.selection === 0) ? _c('div', {
      staticClass: "tile is-parent tx_type_0"
    }, _vm._l((segment.images), function(image) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])])
    })) : (segment.selection === 1 || segment.selection === 2) ? _c('div', {
      staticClass: "tile is-parent tx_type_1-2"
    }, _vm._l((segment.images), function(image, index) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h",
        class: {
          'is-4 tx_full_h1': (segment.selection === 1 && index == 0) || (segment.selection === 2 && index == 1),
          'is-8 tx_full_h3': (segment.selection === 1 && index == 1) || (segment.selection === 2 && index == 0)
        }
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])])
    })) : (segment.selection === 3 || segment.selection === 5) ? _c('div', {
      staticClass: "tile is-parent tx_type_3or5"
    }, [_vm._l(([segment.images[0]]), function(image) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h",
        class: {
          'is-4 tx_full_h2': segment.selection === 3, 'is-8 tx_full_h1': segment.selection === 5
        }
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_1280 + ')'
        })
      })])])
    }), _vm._v(" "), _c('div', {
      staticClass: "tile is-vertical",
      class: {
        'is-4': segment.selection === 5, 'is-8': segment.selection === 3
      }
    }, [_vm._l(([segment.images[1]]), function(image) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h3"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])])
    }), _vm._v(" "), _vm._l(([segment.images[2]]), function(image) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h3"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])])
    })], 2)], 2) : (segment.selection === 4 || segment.selection === 6) ? _c('div', {
      staticClass: "tile is-parent tx_type_4or6"
    }, [_c('div', {
      staticClass: "tile is-vertical",
      class: {
        'is-8': segment.selection === 4, 'is-4': segment.selection === 6
      }
    }, [_vm._l(([segment.images[0]]), function(image) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h3"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])])
    }), _vm._v(" "), _vm._l(([segment.images[1]]), function(image) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h3"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])])
    })], 2), _vm._v(" "), _vm._l(([segment.images[2]]), function(image) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h",
        class: {
          'is-8 tx_full_h1': segment.selection === 6, 'is-4 tx_full_h2': segment.selection === 4
        }
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_1280 + ')'
        })
      })])])
    })], 2) : (segment.selection >= 7 && segment.selection <= 10) ? _c('div', {
      staticClass: "tile is-parent tx_type_7to10"
    }, [_vm._l(([segment.images[3]]), function(image) {
      return (segment.selection === 9 || segment.selection === 10) ? _c('div', {
        staticClass: "tile is-child is-4 tx_full_h tx_full_h2"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_1280 + ')'
        })
      })])]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "tile is-vertical is-8"
    }, [_vm._l(([segment.images[0]]), function(image) {
      return (segment.selection === 7 || segment.selection === 9) ? _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h3"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "tile is-parent"
    }, [_vm._l(([segment.images[1]]), function(image) {
      return _c('div', {
        staticClass: "tile is-child is-6 tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])])
    }), _vm._v(" "), _vm._l(([segment.images[2]]), function(image) {
      return _c('div', {
        staticClass: "tile is-child is-6 tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])])
    })], 2), _vm._v(" "), _vm._l(([segment.images[0]]), function(image) {
      return (segment.selection === 8 || segment.selection === 10) ? _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h3"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])]) : _vm._e()
    })], 2), _vm._v(" "), _vm._l(([segment.images[3]]), function(image) {
      return (segment.selection === 7 || segment.selection === 8) ? _c('div', {
        staticClass: "tile is-child is-4 tx_full_h tx_full_h2"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_1280 + ')'
        })
      })])]) : _vm._e()
    })], 2) : (segment.selection >= 11 && segment.selection <= 13) ? _c('div', {
      staticClass: "tile is-parent tx_type_11to13"
    }, [_vm._l(([segment.images[4]]), function(image) {
      return (segment.selection === 12) ? _c('div', {
        staticClass: "tile is-child is-4 tx_full_h tx_full_h2"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_1280 + ')'
        })
      })])]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "tile is-vertical is-4 segment-11"
    }, [_vm._l(([segment.images[0]]), function(image) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])])
    }), _vm._v(" "), _vm._l(([segment.images[1]]), function(image) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])])
    })], 2), _vm._v(" "), _vm._l(([segment.images[4]]), function(image) {
      return (segment.selection === 13) ? _c('div', {
        staticClass: "tile is-child is-4 tx_full_h tx_full_h2"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_1280 + ')'
        })
      })])]) : _vm._e()
    }), _vm._v(" "), _c('div', {
      staticClass: "tile is-vertical is-4"
    }, [_vm._l(([segment.images[2]]), function(image) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])])
    }), _vm._v(" "), _vm._l(([segment.images[3]]), function(image) {
      return _c('div', {
        staticClass: "tile is-child tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])])
    })], 2), _vm._v(" "), _vm._l(([segment.images[4]]), function(image) {
      return (segment.selection === 11) ? _c('div', {
        staticClass: "tile is-child is-4 tx_full_h tx_full_h2"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_1280 + ')'
        })
      })])]) : _vm._e()
    })], 2) : _c('div', {
      staticClass: "tile is-parent"
    }, _vm._l((segment.images), function(image) {
      return _c('div', {
        staticClass: "tile is-child is-4 tx_full_h tx_full_h1"
      }, [_c('a', {
        attrs: {
          "href": image.image.path,
          "target": "_blank"
        }
      }, [_c('div', {
        staticClass: "tile-image",
        style: ({
          'background-image': 'url(' + image.image_900 + ')'
        })
      })])])
    }))])
  }), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v("\n      " + _vm._s(_vm.error) + "\n    ")]) : _vm._e()], 2), _vm._v(" "), _c('section-comment')], 1)
},staticRenderFns: []}

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-top-section",
    class: [_vm.$route.name !== 'landing' ? 'not-landing' : '']
  }, [(false) ? _c('div', {
    staticClass: "section-indicator"
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'landing') ? _c('div', {
    staticClass: "container-wrapper"
  }, [(_vm.loading === false) ? _c('div', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "slick-wrapper",
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "data-aos": "fade-in",
      "data-aos-once": "true"
    }
  }, [_c('slick', {
    ref: "slick",
    attrs: {
      "options": _vm.slickOptions
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      key: item.title,
      staticClass: "item-wrapper",
      staticStyle: {
        "background-color": "black"
      },
      attrs: {
        "caption": item.title,
        "href": item.image.path,
        "src": item.image.path
      }
    }, [(_vm.isDesktop) ? _c('div', {
      staticClass: "item-image item-image-desktop",
      style: ({
        'background-image': 'url(' + item.image.path + ')'
      }),
      attrs: {
        "data-pin-nopin": "true"
      }
    }) : (item.image_mobile) ? _c('div', {
      staticClass: "item-image item-image-mobile",
      style: ({
        'background-image': 'url(' + item.image_mobile.path + ')'
      }),
      attrs: {
        "data-pin-nopin": "true"
      }
    }) : _c('div', {
      staticClass: "item-image item-image-desktop",
      style: ({
        'background-image': 'url(' + item.image.path + ')'
      }),
      attrs: {
        "data-pin-nopin": "true"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "item-slogan"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": __webpack_require__(733),
        "width": "200"
      }
    })])])
  }))], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'landing') ? _c('section', {
    staticClass: "scroll-down"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.$scrollTo('#section-about', {
          offset: -30
        })
      }
    }
  }, [_vm._m(0)])]) : _vm._e(), _vm._v(" "), (false) ? _c('section', {
    staticClass: "arrow-down"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.$scrollTo('#section-about', {
          offset: -30
        })
      }
    }
  }, [_c('span')])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "circle"
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down"
  })])])
}]}

/***/ }),
/* 840 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-upload",
    attrs: {
      "enctype": "multipart/form-data",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "dropbox",
    class: [{
      'is-dragging': _vm.dragging,
      'is-dirty': _vm.vuelidate.models[_vm.uploadFieldName].$dirty,
      'is-invalid': _vm.vuelidate.models[_vm.uploadFieldName].$invalid
    }]
  }, [(_vm.rerender) ? _c('input', {
    staticClass: "input-file",
    attrs: {
      "type": "file",
      "multiple": "",
      "name": _vm.uploadFieldName,
      "disabled": _vm.isSaving,
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.filesChange($event.target.name, $event.target.files);
      },
      "dragenter": function($event) {
        _vm.dragging = true
      },
      "dragend": function($event) {
        _vm.dragging = false
      },
      "dragleave": function($event) {
        _vm.dragging = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered"
  }, [_c('div', {
    staticClass: "column"
  }, [(_vm.isInitial) ? _c('p', {
    staticClass: "description"
  }, [_vm._v("\n          Drag your file(s) here to begin"), _c('br'), _vm._v(" or click to browse " + _vm._s(_vm.vuelidate.models[_vm.uploadFieldName].$params.required ? '*' : '(optional)') + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isInitial) ? _c('p', {
    staticClass: "description ie-only"
  }, [_vm._v("\n          Click to browse " + _vm._s(_vm.vuelidate.models[_vm.uploadFieldName].$params.required ? '*' : '(optional)') + "\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('p', [_vm._v("\n          Previewing " + _vm._s(_vm.fileCount) + " files...\n        ")]) : _vm._e()])])]), _vm._v(" "), (_vm.uploadedFiles && _vm.uploadedFiles.length > 0) ? _c('div', {
    staticClass: "dropbox-overlay"
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered is-multiline"
  }, _vm._l((_vm.uploadedFiles), function(fileInfo) {
    return _c('div', {
      staticClass: "column is-4"
    }, [(fileInfo.preview) ? _c('img', {
      staticStyle: {
        "max-width": "100%",
        "max-height": "140px",
        "margin": "auto"
      },
      attrs: {
        "src": fileInfo.preview
      }
    }) : _vm._e(), _vm._v(" "), (fileInfo.file) ? _c('p', {
      staticStyle: {
        "position": "absolute",
        "overflow": "hidden",
        "text-overflow": "ellipsis"
      }
    }, [_vm._v("\n          " + _vm._s(fileInfo.file.name) + "\n        ")]) : _vm._e()])
  }))]) : _vm._e(), _vm._v(" "), (_vm.isFailed) ? _c('div', {
    staticClass: "dropbox-overlay"
  }, [_c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered"
  }, [_c('div', {
    staticClass: "column"
  }, [_vm._v("\n        Error: " + _vm._s(_vm.uploadError) + "\n      ")])])]) : _vm._e(), _vm._v(" "), (_vm.isSuccess || _vm.isFailed) ? _c('div', {
    staticClass: "dropbox-reset",
    staticStyle: {
      "position": "absolute",
      "top": "15px",
      "right": "15px"
    }
  }, [_c('a', {
    staticClass: "button is-primary",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]) : _vm._e(), _vm._v(" "), (_vm.isSuccess && false) ? _c('div', [_c('p', [_vm._v("Uploaded " + _vm._s(_vm.uploadedFiles.length) + " file(s) successfully.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "button is-danger",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("\n        reset\n      ")])]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, _vm._l((_vm.uploadedFiles), function(item) {
    return _c('li', [_c('img', {
      staticClass: "img-responsive img-thumbnail",
      attrs: {
        "src": item.url,
        "alt": item.originalName
      }
    })])
  }))]) : _vm._e(), _vm._v(" "), (_vm.isFailed && false) ? _c('div', [_c('p', [_vm._v("Uploaded failed.")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "button is-danger",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.reset()
      }
    }
  }, [_vm._v("\n        reset\n      ")])]), _vm._v(" "), (_vm.uploadError) ? _c('pre', [_vm._v("Upload failed: " + _vm._s(_vm.uploadError))]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 841 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-users"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n        Users.\n      ")]), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "control notification is-danger"
  }, [_c('button', {
    staticClass: "delete",
    on: {
      "click": function($event) {
        _vm.error = undefined
      }
    }
  }), _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('b-table', {
    attrs: {
      "data": _vm.tableData,
      "bordered": _vm.isBordered,
      "striped": _vm.isStriped,
      "narrowed": _vm.isNarrowed,
      "checkable": _vm.isCheckable,
      "loading": _vm.isLoading,
      "mobile-cards": _vm.hasMobileCards,
      "paginated": _vm.isPaginated,
      "per-page": 50,
      "pagination-simple": true,
      "default-sort": "user.first_name",
      "selected": _vm.selected,
      "checked-rows": _vm.checkedRows
    },
    on: {
      "update:selected": function($event) {
        _vm.selected = $event
      },
      "update:checkedRows": function($event) {
        _vm.checkedRows = $event
      }
    }
  }, [
    [_c('b-table-column', {
      attrs: {
        "field": "identifier",
        "label": "ID",
        "width": "40",
        "sortable": "",
        "numeric": ""
      }
    }, [_vm._v("\n            " + _vm._s(_vm.props.row.identifier) + "\n          ")]), _vm._v(" "), _c('b-table-column', {
      attrs: {
        "field": "username",
        "label": "User Name",
        "sortable": ""
      }
    }, [_vm._v("\n            " + _vm._s(_vm.props.row.username) + "\n          ")]), _vm._v(" "), _c('b-table-column', {
      attrs: {
        "field": "email",
        "label": "Email",
        "sortable": ""
      }
    }, [_vm._v("\n            " + _vm._s(_vm.props.row.email) + "\n          ")]), _vm._v(" "), _c('b-table-column', {
      attrs: {
        "field": "role",
        "label": "Role",
        "sortable": ""
      }
    }, [_c('span', {
      staticClass: "tag",
      class: {
        'is-warning': (_vm.props.row.role === 'root'),
        'is-danger': (_vm.props.row.role === 'admin'),
        'is-success': (_vm.props.row.role === 'user')
      }
    }, [_vm._v("\n              " + _vm._s(_vm.props.row.role) + "\n            ")])]), _vm._v(" "), _c('b-table-column', {
      attrs: {
        "field": "isVerified",
        "label": "Verified",
        "sortable": ""
      }
    }, [_c('b-icon', {
      attrs: {
        "pack": "mdi",
        "icon": _vm.props.row.isVerified ? 'done' : 'close'
      }
    })], 1)], _vm._v(" "), _c('div', {
      staticClass: "has-text-centered",
      attrs: {
        "slot": "empty"
      },
      slot: "empty"
    }, [_c('span', {
      staticStyle: {
        "color": "#ccc"
      }
    }, [_vm._v("Table contains nothing.")])])
  ], 2)], 1)])])
},staticRenderFns: []}

/***/ }),
/* 842 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-pulse v-pulse1",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay1])
  }), _c('div', {
    staticClass: "v-pulse v-pulse2",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay2])
  }), _c('div', {
    staticClass: "v-pulse v-pulse3",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay3])
  })])
},staticRenderFns: []}

/***/ }),
/* 843 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "particles-js",
      "color": _vm.color,
      "particleOpacity": _vm.particleOpacity,
      "linesColor": _vm.linesColor,
      "particlesNumber": _vm.particlesNumber,
      "shapeType": _vm.shapeType,
      "particleSize": _vm.particleSize,
      "linesWidth": _vm.linesWidth,
      "lineLinked": _vm.lineLinked,
      "lineOpacity": _vm.lineOpacity,
      "linesDistance": _vm.linesDistance,
      "moveSpeed": _vm.moveSpeed,
      "moveDirection": _vm.moveDirection,
      "hoverEffect": _vm.hoverEffect,
      "hoverMode": _vm.hoverMode,
      "clickEffect": _vm.clickEffect,
      "clickMode": _vm.clickMode
    }
  })
},staticRenderFns: []}

/***/ }),
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
]),[372]);


// WEBPACK FOOTER //
// static/js/app.049fd2bbf64a2d25d761.js